const fr = {
    common: {
        enhancement_banner: {
            title: 'Cette page est en cours d’amélioration',
            description:
                'Cette fonctionnalité reste disponible pendant sa refonte et s’améliorera très prochainement. Une question ou une suggestion ?',
            description_alt:
                'Cette fonctionnalité reste accessible le temps de son amélioration.\nElle sera améliorée dans les jours à venir.',
            link: 'Discutons-en !',
        },
        onboarding_banner: {
            title: 'Bienvenue',
            description:
                'Cette fonctionnalité reste disponible pendant sa refonte et s’améliorera très prochainement. Une question ou une suggestion ?',
            description_alt:
                'Cette fonctionnalité reste accessible le temps de son amélioration.\nElle sera améliorée dans les jours à venir.',
            link: 'Discutons-en !',
            first_step: 'Première étape',
            next_step: 'Étape suivante',
            last_step: 'Dernière étape',
            configure_now: 'Configurer maintenant',
            create_now: 'Créer maintenant',
            complete_info: 'Veuillez compléter les informations suivantes :',
            steps: {
                parameters: {
                    title: 'Paramètres',
                    name: "Nom de l'établissement",
                    company_name: "Nom légal de l'entreprise",
                    language: 'Langue',
                    timezone: 'Fuseau horaire',
                    legal_form: 'Forme juridique',
                    registration_number: "Numéro d'immatriculation",
                    address: "Adresse de l'établissement",
                    hours: "Horaires d'ouverture",
                },
                experience: {
                    title: 'Créez une expérience réservable par vos clients',
                    create: 'Créer une expérience',
                    photos: 'Ajouter des photos',
                    pricing: 'Définir les prix',
                },
                stripe: {
                    title: 'Configurez votre compte Stripe',
                },
            },
        },
        no_result: 'Aucun résultat',
        add_question: 'Ajouter une question',
        scheduleTime: {
            nextDayShort: 'Lendemain',
            invalidTime: 'Veuillez saisir une heure valide (ex : 20:05).',
            placeholder: 'Saisissez une heure précise, ex. 20:05',
            closedAllDay: 'Fermé toute la journée',
            entered: 'saisi',
        },
        select: 'Sélectionner...',
        change: 'Changer',
        close: 'Fermer',
        validate: 'Valider',
        hide: 'Masquer',
        minimize: 'Minimiser',
        no_date: 'Aucune date',
        invalid_date: 'Date invalide',
        crop: 'Recadrer',
        edit: 'Modifier',
        enabled: 'Activé',
        disabled: 'Désactivé',
        visible: 'Visible',
        invisible: 'Invisible',
        show: 'Voir',
        delete: 'Supprimer',
        actions: 'Actions',
        no_results: 'Aucun résultat',
        send: 'Envoyer',
        download: 'Télécharger',
        continue: 'Continuer',
        faq: 'FAQ',
        loading: 'Chargement...',
        error: 'Erreur',
        success: 'Succès',
        cancel: 'Annuler',
        return: 'Retour',
        save: 'Enregistrer',
        saving: 'Enregistrement...',
        optional: '(optionnel)',
        choose: '-- Choisir --',
        confirm: 'Valider',
        confirm_delete: 'Êtes-vous sûr de vouloir supprimer cet élément ?',
        reset: 'Réinitialiser',
        cropConfirm: 'Valider le recadrage',
        cropImage: "Recadrer l'image",
        cropCancel: 'Annuler le recadrage',
        list: 'Liste',
        calendar: 'Calendrier',
        to: "jusqu'à",
        closed: 'Fermé',
        formValidationError: 'Veuillez corriger les erreurs dans le formulaire.',
        please_fill: 'Veuillez remplir',
        loadMore: 'Charger plus',
        placeholderSelect: '- Veuillez sélectionner -',
        allDays: 'Tous les jours de la semaine',
        allDaysNoWeekend: 'Tous les jours de la semaine sauf les weekends',
        weekDays: 'Jours de la semaine',
        weekendDays: 'Tous les weekends',
        allDaysExpect: 'Tous les jours sauf',
        allSpecificDay: 'Tous les',
        min: 'min',
        duration: {
            minutesOnly: '{n} min',
            hourSingular: '1 heure',
            hourPlural: '{n} heures',
            hourWithMinutes: '{h} h {m}',
        },
        search: 'Rechercher...',
        linePerPage: 'Lignes par page',
        from: 'Du',
        to_date: 'au',
        and: 'et',
        yes: 'Oui',
        no: 'Non',
        add: 'Ajouter',
        remove: 'Retirer',
        replace: 'Remplacer',
        create: 'Créer',
        recommended_size: 'Taille recommandée',
        filter: 'Filtrer',
        status: 'Activé',
        all: 'Tous',
        max: 'max',
        deleted_successfully: 'Supprimé avec succès',
        copy_link: 'Copier le lien',
        copied: 'Copié !',
        activeFilters: 'Filtres actifs',
        resetAll: 'Tout effacer',
        duplicate: 'Dupliquer',
        stay: 'Rester',
        none: 'Aucune',
        apply: 'Appliquer',
        of: 'de',
        expired: 'Expiré',
        now: 'Maintenant',
        soon: 'Bientôt',
        address: 'Adresse',
        country: 'Pays',
        postal_code: 'Code postal',
        steps: {
            parameters: {
                company_name: "Nom de l'entreprise",
            },
        },
        error_validate: 'Erreur de validation',
        formRequiredError: 'Veuillez remplir ce champ.',
        invalidUrlError: 'Veuillez entrer une URL valide (ex: https://exemple.com).',
        deleteSelection: 'Supprimer la sélection',
        expires_at: 'expire le {date}',
        expired_at: 'Expiré le {date}',
        yes_cancel: 'Oui, annuler',
        no_keep: 'Non, garder',
        preview: 'Prévisualiser',
        essential: 'Essentiel',
        vat_rates: {
            normal: 'Taux normal',
            standard: 'Taux standard',
            intermediate: 'Taux intermédiaire',
            intermediate_culture: 'Taux intermédiaire (services culturels, loisirs)',
            reduced: 'Taux réduit (inchangé)',
            reduced_food: 'Taux réduit (alimentation de base)',
            special: 'Taux particulier (inchangé)',
            none: 'Pas de TVA',
        },
        select_at_least_one_column: 'Veuillez sélectionner au moins une colonne',
        columns_saved_success: 'Les colonnes ont été sauvegardées avec succès',
        fill_required_fields: 'Veuillez compléter tous les champs requis avant de continuer.',
        save_error: 'Une erreur est survenue lors de la sauvegarde.',
        generic_error: 'Une erreur est survenue',
        deleted_success: 'Supprimé avec succès',
        export_error: "Erreur lors de l'export",
        modified_success: 'Modifié avec succès',
        added_success: 'Ajouté avec succès',
        visibility_update_error: 'Erreur lors de la mise à jour de la visibilité',
        settings_updated_success: 'Les paramètres ont été mis à jour avec succès !',
        data_load_error: "Une erreur s'est produite lors du chargement des données.",
        excel_download_success: 'Le fichier Excel a été téléchargé avec succès.',
        config_updated_success: 'La configuration a été mise à jour avec succès !',
        slot_update_error: 'Erreur lors de la modification du créneau',
        copy_error: 'Erreur lors de la copie',
        form_saved_success: 'Formulaire enregistré avec succès',
        tenant_not_found: 'Locataire non trouvé',
        status_change_error: 'Erreur lors du changement de statut',
        load_error: 'Erreur lors du chargement des informations',
        copied_clipboard: 'Copié dans le presse-papier',
        enter_text_first: "Veuillez saisir du texte avant de l'améliorer.",
        text_enhanced_success: 'Texte amélioré avec succès !',
        file_too_large: 'Fichier trop volumineux (max 5 Mo)',
        error_occurred: 'Une erreur est survenue',
        success_message: 'Opération réussie',
        add_images: 'Ajouter des images',
        options: 'Options',
    },
    widget: {
        load_activities_error: 'Erreur lors du chargement des activités',
        verify_activity_error: 'Erreur lors de la vérification de activité',
        load_quotes_error: 'Erreur lors du chargement des devis',
        load_categories_error: 'Erreur lors du chargement des catégories',
        load_services_error: 'Erreur lors du chargement des prestations et packages',
        load_combos_error: 'Erreur lors du chargement des formules combinées',
        load_events_error: 'Erreur lors du chargement des événements',
        load_series_error: 'Erreur lors du chargement des séries',
        load_vouchers_error: 'Erreur lors du chargement des billets non datés',
    },
    karafun: {
        syncKarafun: 'Télécharger les espaces depuis Karafun',
        syncSuccess: 'Synchronisation réussie !',
        syncError: 'La synchronisation a échoué',
        titleKarafun: 'Karafun',
        selectKarafun: 'Sélectionner les appareils',
        selectSpaces: 'Choisissez un ou plusieurs espaces à lier :',
    },
    mail_custom: {
        sections: {
            reminder_before: 'Rappel avant réservation',
            birthday: "Cadeau d'anniversaire client",
            confirmation: 'Confirmation de réservation',
            request_imprint: 'Demande de réservation avec empreinte',
            thanks_after: 'Remerciements après une visite',
            accept: "Message suite à l'acceptation de la demande",
            decline: 'Message suite au refus de la demande',
            fidelity: 'Palier de fidélité atteint',
            miss_you: 'Vous nous manquez',
            notification_settings: 'Paramètres des notifications',
        },
        fields: {
            full_email_description: 'Rédigez l’intégralité de l’email envoyé au destinataire',
            partial_email_description: 'Ajoutez un message qui sera inséré dans l’email envoyé par défaut',
            reminder_days: 'Nombre de jours avant rappel',
            birthday_points: 'Nombre de point à créditer',
            birthday_send_before_days: 'Délai d’envoi avant l’anniversaire (en jours)',
            treshold_1: 'Palier 1',
            treshold_2: 'Palier 2',
            treshold_3: 'Palier 3',
            revisit_time: 'Délai sans revisite avant envoi',
            select_roles: 'Sélectionner les rôles à notifier',
            placeholder_roles: 'Sélectionner un rôle',
            booking_update_mail: 'Modification de réservation — Notifier les rôles suivants',
            thanks_after_visit_time: 'Délai d’envoi après la visite (en jours)',
            notice_google_link: 'Lien vers votre fiche d’avis Google',
            reminder_text: "Message personnalisé ajouté à l'e-mail",
        },
        title_page: 'Mails automatiques',
    },
    annonce: {
        title: 'Annonces',
        add_banner: 'Bannière',
        add_popup: 'Popup',
        filter_type: 'Filtrer par type',
        no_img: "Pas d'image",
        banner: 'Bannière',
        popup: 'Popup',
        visible: 'Visible',
        invisible: 'Invisible',
        delete_title: 'Suppression',
        delete_description_multiple: 'Êtes-vous sûr de vouloir supprimer les éléments sélectionnés ?',
        delete_description_single: 'Êtes-vous sûr de vouloir supprimer cet élément ?',
        toggle_visibility_error: 'Erreur lors de la modification de la visibilité',
        delete_error: 'Erreur lors de la suppression',
        fetch_error: 'Une erreur est survenue',
        all: 'Tout',
        columns: {
            title: 'Titre',
            type: 'Type',
            description: 'Description',
            visibility: 'Visibilité',
            actions: 'Actions',
            date: 'Dates',
        },
    },
    notifications_push: {
        title: 'Notifications Push',
        tabs: {
            current: 'En cours',
            history: 'Historique',
        },
        status: {
            all: 'Tous',
            current: 'En cours',
            history: 'Historique',
        },
        add: 'Nouvelle campagne push',
        columns: {
            system_title: 'Titre système',
            title_notif: 'Titre notification',
            description: 'Description',
            send_time: "Heure d'envoi",
            end_date: 'Date d’envoi',
            updated_at: 'Mis à jour',
            send: 'Envoyée',
            actions: 'Actions',
        },
        edit: 'Modifier la notification',
        general_info: 'Informations générales',
        system_title_label: 'Nom interne',
        system_title_placeholder: 'Ex: Promo Octobre',
        title_notif_label: 'Titre de la notification',
        title_notif_placeholder: "🎉 Offre flash : -20% aujourd'hui !",
        desc_notif_label: 'Message',
        description_placeholder: "Ex: Profitez de notre promo exceptionnelle jusqu'à ce soir. Réservez vite !",
        delete_modal: {
            title: 'Supprimer la notification',
            message: 'Êtes-vous sûr de vouloir supprimer cette notification ? Cette action est irréversible.',
        },
        messages: {
            delete_success: 'Notification supprimée.',
            save_success: 'Notification sauvegardée avec succès.',
            error: 'Une erreur est survenue.',
            submit_error: 'Erreur lors de la soumission.',
            delete_error: 'Erreur lors de la suppression.',
            validation: {
                system_title_required: 'Le titre système est obligatoire.',
                title_required: 'Le titre est obligatoire.',
                description_required: 'La description est obligatoire.',
                time_required: "L'heure est obligatoire.",
                date_required: 'La date de fin est obligatoire.',
            },
        },
    },
    blog: {
        title: 'Blog',
        add_blog: 'Créer un article',
        edit_blog: "Modifier l'article",
        main_information: 'Informations principales',
        short_desc: 'Description courte',
        content: 'Contenu',
        image: 'Illustration',
        seo_optimization: 'Optimisation SEO',
        create_success: 'Article créé avec succès',
        no_img: "Pas d'image",
        published: 'Publié',
        unpublished: 'Non publié',
        delete_title: 'Suppression',
        delete_description_multiple: 'Êtes-vous sûr de vouloir supprimer les blogs sélectionnés ?',
        delete_description_single: 'Êtes-vous sûr de vouloir supprimer ce blog ?',
        toggle_publish_error: 'Erreur lors de la modification du statut de publication',
        delete_error: 'Erreur lors de la suppression',
        fetch_error: 'Une erreur est survenue lors du chargement des blogs',
        select_categories: 'Sélectionner une ou plusieurs catégories',
        columns: {
            title: 'Titre',
            blogger: 'Rédacteur',
            categories: 'Catégories',
            publish_at: 'Date de publication',
            status: 'Statut',
            actions: 'Actions',
        },
        titles: {
            category: 'Catégories',
        },
        faq: 'Foire aux questions (FAQ)',
        no_faq: 'Aucun FAQ ajouté pour le moment.',
        faq_item: 'Question',
        faq_question: 'Question',
        faq_answer: 'Réponse',
        btn_add_faq: 'Ajouter une FAQ',
        save_draft: 'Enregistrer le brouillon',
        publish: 'Publier',
        add_category: 'Ajouter une catégorie',
        category_name: 'Nom de la catégorie',
        category_create_success: 'Catégorie créée avec succès',
        add_article: 'Ajouter un article',
    },
    form_question: {
        title: 'Demandes de devis',
        tabs: {
            entreprise: 'Formulaire Entreprise',
            anniversaire: 'Formule Anniversaire',
            evg: 'Formulaire EVG/JF',
        },
        columns: {
            full_name: 'Nom complet',
            email: 'Email',
            phone: 'Téléphone',
            date: 'Date',
            actions: 'Actions',
        },
        delete_title: 'Suppression',
        delete_description_multiple: 'Êtes-vous sûr de vouloir supprimer les éléments sélectionnés ?',
        delete_description_single: 'Êtes-vous sûr de vouloir supprimer cet élément ?',
        delete_error: 'Erreur lors de la suppression',
        fetch_error: 'Une erreur est survenue',
    },
    forms: {
        activeOnSite: 'Formulaire actif sur le site',
        inactiveOnSite: 'Formulaire désactivé',
        addNew: 'Nouveau formulaire',
        addNewLimit: 'Nouveau formulaire · {count}/{max}',
        maxForms: '3 formulaires maximum',
        deleteFormTitle: 'Supprimer le formulaire ?',
        deleteFormMessage: 'Voulez-vous vraiment supprimer ce formulaire ? Cette action est irréversible.',
        formDeleted: 'Formulaire supprimé avec succès',
        formDeleteError: 'Erreur lors de la suppression du formulaire',
        formCreateError: 'Erreur lors de la création du formulaire',
        formListError: 'Erreur lors du chargement des formulaires',
        formDuplicated: 'Formulaire dupliqué avec succès',
        formDuplicateError: 'Erreur lors de la duplication du formulaire',
        menu: {
            rename: 'Renommer',
            duplicate: 'Dupliquer',
            disable: 'Désactiver le formulaire',
            enable: 'Activer le formulaire',
            delete: 'Supprimer',
            cannotDeleteLast: 'Impossible de supprimer le dernier formulaire',
            soon: 'Bientôt disponible',
            options: 'Options du formulaire',
        },
        status: {
            active: 'Actif',
            inactive: 'Inactif',
        },
        questionsHeader: {
            order: "Ordre d'affichage pour le client",
            noneRequired: 'Aucune réponse obligatoire',
            requiredSummary: '{n} question{plural} obligatoire{plural} sur {total}',
        },
        question: {
            label: 'Question',
            intitule: 'Intitulé de la question',
            typeLabel: 'Type de réponse',
            placeholderLabel: 'Placeholder',
            placeholderHint: 'Texte indicatif affiché dans le champ de réponse',
            collapse: 'Replier',
            optionsTitle: 'Réponses proposées',
            required: 'Obligatoire',
            requiredAnswer: 'Réponse obligatoire',
            minChoicesPrefix: 'Le client doit cocher au minimum',
            numberBetween: 'Valeur autorisée entre',
            and: 'et',
            characterUnit: 'caractère',
            answerUnit: 'réponse',
            boundsRequired: 'Veuillez renseigner une valeur minimale et une valeur maximale.',
            maxLengthRequired: 'Veuillez renseigner la longueur maximale.',
            optional: 'Facultatif',
            emptyTitle: 'Sans titre',
            add: 'Ajouter une question',
            placeholder: 'Poser une question…',
            helpPlaceholder: "Ajouter un texte d'aide…",
            options: 'Options',
            optionPlaceholder: 'Option {n}',
            addOption: 'Ajouter une option',
            validations: 'Validations',
            minLength: 'Longueur minimale',
            maxLengthLabel: 'Longueur maximale',
            minValue: 'Valeur minimale',
            maxValue: 'Valeur maximale',
            minChoicesLabel: 'Nombre de réponses minimal',
            minChoicesHelp: 'Nombre de cases minimum à cocher pour valider la question',
            dateRange: 'Plage de dates',
            dateSingle: 'Date unique',
            dateFormatLabel: 'Format',
            forbidPast: 'Interdire les dates passées',
            experiencesTitle: 'Expériences proposées',
            experiencesHint: 'Cochez les expériences configurées à proposer au client.',
            experiencesLoading: 'Chargement des expériences…',
            experiencesRetry: 'Réessayer',
            experiencesEmpty: 'Aucune expérience configurée pour le moment.',
            experiencesSelectAll: 'Tout sélectionner',
            experiencesClear: 'Tout désélectionner',
            experiencesSearch: 'Rechercher une expérience…',
            experiencesClearSearch: 'Effacer la recherche',
            experiencesNoResult: 'Aucune expérience ne correspond à cette recherche.',
            help: 'Aide',
            order: 'Ordre',
            moveUp: 'Monter',
            moveDown: 'Descendre',
            duplicate: 'Dupliquer',
            delete: 'Supprimer',
            locked: 'Champ protégé : modification/suppression impossible',
            deleteConfirmTitle: 'Supprimer la question',
            deleteConfirmMessage: 'Êtes-vous sûr de vouloir supprimer cette question ?',
            cancel: 'Annuler',
            newQuestion: 'Nouvelle question',
            summary: {
                textShort: 'Texte court',
                textLong: 'Texte long',
                number: 'Nombre',
                single: 'Choix unique',
                multiple: 'Choix multiple',
                dropdown: 'Liste déroulante',
                dateSingle: 'Date unique',
                dateRange: 'Plage de dates',
                answers: '{n} réponse{plural}',
                minChoices: 'min. {n}',
                maxLength: '{n} caractères max.',
                pastDates: 'Dates passées interdites',
                minMax: '{min}–{max}',
            },
        },
        type: {
            title: 'Choisir un type de question',
            short: 'Texte court',
            long: 'Texte long',
            number: 'Nombre',
            radio: 'Choix unique',
            checkbox: 'Choix multiple',
            select: 'Liste déroulante',
            date: 'Date',
            experience: 'Expérience',
            desc: {
                short: 'Réponse en une ligne',
                long: 'Réponse en plusieurs lignes',
                number: 'Réponse numérique',
                radio: 'Une seule réponse parmi une liste',
                checkbox: 'Plusieurs réponses possibles',
                select: 'Choix dans une liste déroulante',
                date: 'Réponse sous forme de date',
                experience: 'Choix parmi les expériences configurées',
            },
        },
        presentation: {
            title: 'Présentation du formulaire',
            description: 'Description générale',
            descriptionSubtitle: 'Affichée en haut du formulaire, avant la première question.',
            descriptionPlaceholder:
                'Décrivez votre projet en quelques lignes, nous revenons vers vous sous 48 h avec une proposition chiffrée.',
            image: "Image d'en-tête",
            imageHint: 'JPG, PNG ou WebP · 1 Mo max.',
        },
        faq: {
            title: 'FAQ',
            subtitle: 'Questions fréquentes affichées à côté du formulaire, dans l’ordre défini ici.',
            question: 'Question',
            questionPlaceholder: 'Écrire une question…',
            answer: 'Réponse',
            answerPlaceholder: 'Réponse affichée sous la question',
            add: 'Ajouter une question fréquente',
            newQuestion: 'Nouvelle question fréquente',
            delete: 'Supprimer',
            propose: '✨ Proposer des questions',
            proposeSoon: 'Bientôt disponible',
        },
        save: {
            label: 'Enregistrer',
            saving: 'Enregistrement…',
            saved: 'Formulaire enregistré',
            minMaxRequired: 'Questions « Nombre » : veuillez renseigner une valeur minimale et maximale — {labels}',
            minMaxIncoherent:
                'Questions « Nombre » : la valeur minimale doit être inférieure ou égale à la valeur maximale — {labels}',
            maxLengthRequired: 'Questions « Texte long » : veuillez renseigner la longueur maximale — {labels}',
            boundsMixedRequired: 'Veuillez renseigner les valeurs obligatoires des questions — {labels}',
        },
    },
    format: {
        23: '2:3',
        45: '4:5',
        169: '16:9',
        square: 'Carré (1:1)',
        free: 'Libre',
        portrait: 'Portrait (3:4)',
        landscape: 'Paysage (4:3)',
        facebookCover: 'Couverture Facebook',
        circle: 'Cercle',
    },
    customers: {
        title: 'Clients',
        title_single: 'un client',
        add: 'Ajouter',
        export: 'Exporter',
        import: 'Importer',
        csv: 'Format CSV',
        excel: 'Format Excel',
        merge: 'Fusionner',
        columns: 'Modifier les colonnes',
        unspecified: 'Non spécifié',
        setPassword: 'Définir mot de passe',
        caisse: 'Nouvelle vente',
        edit: 'Modifier',
        delete: 'Supprimer',
        disable: 'Désactiver',
        enable: 'Réactiver',
        scheduleReservation: 'Planifier une réservation',
        selectedItems: '{count} élément{plural} sélectionné{plural}',
        deleteSelection: 'Supprimer la sélection',
        deletePopupTitle: 'Supprimer client(s)',
        deletePopupDescriptionSingle: 'Voulez-vous vraiment supprimer ce client ?',
        deletePopupDescriptionMultiple: 'Voulez-vous vraiment supprimer {count} client(s) ?',
        disableConfirmTitle: 'Voulez-vous désactiver ce client ?',
        enableConfirmTitle: 'Voulez-vous réactiver ce client ?',
        disableSuccess: 'Utilisateur désactivé avec succès',
        enableSuccess: 'Utilisateur activé avec succès',
        fields: {
            id: 'Id',
            firstName: 'Prénom',
            lastName: 'Nom',
            email: 'Adresse email',
            phone: 'Téléphone',
            birthday: 'Date de naissance',
            age: 'Âge',
            gender: 'Genre',
            account: 'Compte',
            client: 'Client',
            guest: 'Invité',
            origin: 'Origine',
            spent: 'Montant dépensé',
            loyaltyPoints: 'Points de fidélité',
            firstComing: 'Première visite',
            lastComing: 'Dernière visite',
            createdAt: "Date d'ajout",
            actions: 'Actions',
            status: 'Statut',
            communication: 'Communications',
            subscribed: 'Inscrit',
            unsubscribed: 'Non inscrit',
            type_customer: 'Type',
            social_reason: 'Société',
        },
        confirmDelete: 'Êtes-vous sûr de vouloir supprimer {name} ?',
        deleteSuccess: 'Utilisateur supprimé avec succès',
        deleteError: "Erreur lors de la suppression de l'utilisateur",
        exportSuccess: "L'export a été généré avec succès.",
        exportError: "Une erreur est survenue lors de l'export.",
        navigation: {
            customers: 'Clients',
            groups: 'Groupes clients',
            billetsNonDatees: 'Billets non datés',
            subscriptions: 'Abonnements & Forfaits',
            vouchers: 'Bons cadeaux',
        },
        importModal: {
            title: 'Importer un fichier CSV',
            subtitle: "Assurez-vous que les colonnes sont présentes et correctement remplies avant d'importer.",
            downloadTemplate: 'Télécharger le modèle de fichier CSV',
            csvOnly: 'Fichier CSV uniquement',
            analyzing: 'Analyse du fichier en cours…',
            reviewTitle: 'Vérification avant import —',
            ready: '{count} prêts',
            autofilled: '{count} complétés auto (à vérifier)',
            duplicates: '{count} doublons',
            existing: '{count} déjà existants',
            totalLines: '(sur {count} lignes)',
            cancel: 'Annuler',
            importing: 'Import…',
            validateImport: "Valider l'import ({count})",
            importInProgress: 'Import en cours…',
            flaggedRowsLabel: 'Lignes complétées automatiquement — corrigez si besoin avant de valider :',
            colLine: 'Ligne',
            colFirstName: 'Prénom',
            colLastName: 'Nom',
            colEmail: 'Email',
            colPhone: 'Téléphone',
            colCompleted: 'Complété',
            importSuccess: 'Import terminé avec succès !',
            created: 'Clients créés',
            alreadyExisting: 'Déjà existants',
            doublons: 'Doublons',
            totalImported: 'Total lignes',
            errorsLine: '{count} ligne(s) en erreur (cliquer pour voir)',
            close: 'Fermer',
            downloadError: 'Impossible de télécharger le modèle.',
        },
    },
    groups: {
        title: 'Groupes clients',
        addTitle: 'Ajouter un groupe client',
        editTitle: 'Modifier le groupe client',
        add: 'Ajouter',
        export: 'Exporter',
        csv: 'Format CSV',
        excel: 'Format Excel',
        status: 'Statut',
        active: 'Actif',
        inactive: 'Suspendu',
        name: 'Nom',
        owner: 'Propriétaire',
        customersCount: 'Nombre de clients',
        actions: 'Actions',
        edit: 'Modifier',
        delete: 'Supprimer',
        disable: 'Désactiver',
        disableConfirmTitle: 'Désactiver le groupe',
        disableSuccess: 'Groupe désactivé avec succès',
        disableError: 'Une erreur est survenue lors de la désactivation du groupe',
        selectedItems: '{count} élément{plural} sélectionné{plural}',
        deleteSelection: 'Supprimer la sélection',
        deletePopupTitle: 'Supprimer groupe(s)',
        deletePopupDescriptionSingle: 'Voulez-vous vraiment supprimer ce groupe ?',
        deletePopupDescriptionMultiple: 'Voulez-vous vraiment supprimer {count} groupe(s) ?',
        exportSuccess: "L'export a été généré avec succès.",
        deleteSuccess: 'Groupe supprimé avec succès',
        deleteError: 'Erreur lors de la suppression du groupe',
        enableSuccess: 'Groupe activé avec succès',
        enableConfirmTitle: 'Voulez-vous réactiver ce groupe ?',
        loadError: 'Impossible de charger les groupes.',
        exportError: "Une erreur est survenue lors de l'exportation.",
    },
    voucher: {
        title: 'Bons cadeaux',
        add: 'Ajouter',
        export: 'Exporter',
        columns: 'Modifier les colonnes',
        csv: 'Format CSV',
        excel: 'Format Excel',
        status: 'Statut',
        all_status: 'Tous les statuts',
        status_active: 'Actif',
        status_used: 'Utilisé',
        status_expired: 'Expiré',
        status_blocked: 'Bloqué',
        status_partially_used: 'Partiellement utilisé',
        code: 'Code',
        gifted_by: 'Offert par',
        gifted_to: 'Bénéficiaire',
        beneficiary: 'Bénéficiaire',
        send_date: "Date d'envoie",
        availability: 'Date de creation',
        used_at: "Date d'utilisation",
        date_end: "Date d'expiration",
        total_amount: 'Montant',
        available_amount: 'Solde',
        actions: 'Actions',
        edit: 'Modifier',
        history: 'Historique',
        delete: 'Supprimer',
        selectedItems: '{count} élément{plural} sélectionné{plural}',
        deleteSelection: 'Supprimer la sélection',
        deletePopupTitle: 'Supprimer bon(s) cadeau(x)',
        deletePopupDescriptionSingle: 'Voulez-vous vraiment supprimer ce bon cadeau ?',
        deletePopupDescriptionMultiple: 'Voulez-vous vraiment supprimer {count} bon(s) cadeau(x) ?',
        loadError: 'Impossible de charger les bons cadeaux.',
        exportError: "Une erreur est survenue lors de l'export.",
        exportSuccess: "L'export a été généré avec succès.",
        downloadSelection: 'Télécharger',
        cancelSelection: 'Annuler',
        bulkDownloadSuccess: 'Les bons cadeaux ont été téléchargés avec succès.',
        bulkDownloadError: 'Une erreur est survenue lors du téléchargement des bons cadeaux.',
        enable: 'Réactiver',
        disable: 'Bloquer',
        resend: 'Renvoyer par email',
        download: 'Télécharger PDF',
        enablePopupTitle: 'Réactiver bon cadeau',
        disablePopupTitle: 'Bloquer bon cadeau',
        enablePopupDescription: 'Voulez-vous vraiment réactiver ce bon cadeau ?',
        disablePopupDescription: 'Voulez-vous vraiment bloquer ce bon cadeau ?',
        resendSuccess: 'Email renvoyé avec succès.',
        resendError: "Erreur lors de l'envoi de l'email.",
        statusUpdateSuccess: 'Statut mis à jour avec succès.',
        statusUpdateError: 'Erreur lors de la mise à jour du statut.',
        updateSuccess: 'Bon cadeau mis à jour avec succès.',
        updateError: 'Erreur lors de la mise à jour du bon cadeau.',
        edit_title: 'Modifier bon cadeau',
        from_first_name: "Prénom l'acheteur",
        from_last_name: "Nom l'acheteur",
        from_email: "Email l'acheteur",
        to_email: 'Email du bénéficiaire',
        from_message: "Message l'acheteur",
        send_title: 'Renvoyer le mail',
        general_info: 'Informations générales',
        resend_to_buyer: "Renvoyer à l'acheteur",
        resend_to_recipient: 'Renvoyer au bénéficiaire',
        buyer_email: "Email de l'acheteur",
        buyer_email_placeholder: "Saisissez l'email de l'acheteur",
        recipient_email: 'Email du bénéficiaire',
        recipient_email_placeholder: "Saisissez l'email du bénéficiaire",
        message_optional: 'Votre message (optionnel)',
        message_placeholder: 'Veuillez remplir',
        client: 'client',
    },
    billetNonDate: {
        title: 'Billets non datés',
        add: 'Ajouter',
        export: 'Exporter',
        columns: 'Modifier les colonnes',
        csv: 'Format CSV',
        excel: 'Format Excel',
        status: 'Statut',
        all_status: 'Tous les statuts',
        status_active: 'Actif',
        status_used: 'Utilisé',
        status_expired: 'Expiré',
        status_blocked: 'Bloqué',
        status_partially_used: 'Partiellement utilisé',
        code: 'Code',
        gifted_by: 'Offert par',
        gifted_to: 'Bénéficiaire',
        beneficiary: 'Bénéficiaire',
        send_date: 'Disponibilité',
        availability: 'Disponibilité',
        date_end: "Date d'expiration",
        created_at: 'Date de création',
        used_at: "Date d'utilisation",
        total_amount: 'Montant',
        available_amount: 'Solde',
        actions: 'Actions',
        edit: 'Modifier',
        history: 'Historique',
        delete: 'Supprimer',
        selectedItems: '{count} élément{plural} sélectionné{plural}',
        deleteSelection: 'Supprimer la sélection',
        deletePopupTitle: 'Supprimer bon(s) cadeau(x)',
        deletePopupDescriptionSingle: 'Voulez-vous vraiment supprimer ce bon cadeau ?',
        deletePopupDescriptionMultiple: 'Voulez-vous vraiment supprimer {count} bon(s) cadeau(x) ?',
        loadError: 'Impossible de charger les bons cadeaux.',
        exportError: "Une erreur est survenue lors de l'export.",
        exportSuccess: "L'export a été généré avec succès.",
        downloadSelection: 'Télécharger',
        cancelSelection: 'Annuler',
        bulkDownloadSuccess: 'Le téléchargement des billets non datés a été planifié avec succès.',
        bulkDownloadError: 'Une erreur est survenue lors du téléchargement des billets non datés.',
        enable: 'Réactiver',
        disable: 'Bloquer',
        resend: 'Renvoyer par email',
        download: 'Télécharger PDF',
        enablePopupTitle: 'Réactiver billet non daté',
        disablePopupTitle: 'Bloquer billet non daté',
        enablePopupDescription: 'Voulez-vous vraiment réactiver ce billet non daté ?',
        disablePopupDescription: 'Voulez-vous vraiment bloquer ce billet non daté ?',
        resendSuccess: 'Email renvoyé avec succès.',
        resendError: "Erreur lors de l'envoi de l'email.",
        statusUpdateSuccess: 'Statut mis à jour avec succès.',
        statusUpdateError: 'Erreur lors de la mise à jour du statut.',
        edit_title: 'Modifier billets non datés',
        from_first_name: "Prénom l'acheteur",
        from_last_name: "Nom l'acheteur",
        from_email: "Email l'acheteur",
        to_email: 'Email du bénéficiaire',
        from_message: "Message l'acheteur",
        no_items: 'Aucun objet lié.',
        unnamed_item: 'Article',
        generate_invoice: 'Générer facture',
        items: 'Contenu',
        client: 'Client',
        import_note: "Note d'import",
        to_first_name: 'Prénom du destinataire',
        to_last_name: 'Nom du destinataire',
    },
    treatment_customer: {
        title: 'Abonnements & Forfaits',
        export: 'Exporter',
        csv: 'Format CSV',
        excel: 'Format Excel',
        all_active: 'Actifs',
        archived: 'Archivés',
        user_name: 'Client',
        treatment_name: 'Offre',
        quantity_left: 'Quantité restante',
        prestations_qty: 'Quantité totale',
        loadError: 'Impossible de charger les données.',
        exportError: "Une erreur est survenue lors de l'export.",
        exportSuccess: "L'export a été généré avec succès.",
        deleteSuccess: 'Élément désactivé avec succès',
        deleteError: "Erreur lors de la désactivation de l'élément",
        deletePopupTitle: 'Désactiver',
        deletePopupDescription: 'Voulez-vous vraiment désactiver cet élément ?',
        selectedItems: '{count} élément{plural} sélectionné{plural}',
        cancelSelection: 'Annuler la sélection',
        disable: 'Désactiver',
    },
    datatable: {
        search: 'Recherche...',
        show: 'Afficher',
        entries: 'entrées',
        noData: 'Aucun contenu à afficher pour le moment',
        loading: 'Chargement...',
        first: 'Premier',
        previous: 'Précédent',
        next: 'Suivant',
        last: 'Dernier',
        showing: 'Affichage de',
        to: 'à',
        of: 'sur',
        filtered: '(filtré à partir de {total} entrées au total)',
        error: 'Erreur lors du chargement des données',
        columns: {
            visible: 'Colonnes visibles',
            apply: 'Valider',
        },
        bulk_actions: 'Actions groupées',
        modal: {
            title: 'Confirmer la suppression',
            message: 'Êtes-vous sûr de vouloir supprimer les tables sélectionnées ?',
            cancel: 'Annuler',
            confirm: 'Supprimer',
        },
    },
    resource_planning: {
        holiday: {
            title: 'Horaires vacances',
            description: 'Configurez les horaires spéciaux pour les périodes de vacances',
            add_button: 'Ajouter des horaires vacances',
            save: 'Enregistrer les horaires vacances',
            add_holiday: 'Ajouter des horaires vacances',
            edit_holiday: 'Modifier les horaires vacances',
            no_holidays: 'Aucun horaire vacances',
            no_holidays_description: 'Aucun horaire vacances configuré pour le moment.',
        },
        tabs: {
            regular: 'Planning régulier',
            holiday: 'Horaires vacances',
            exceptions: 'Fermetures temporaires',
        },
        subcards: {
            title: "Horaires d'ouverture",
            description: "Définissez vos horaires d'ouverture et périodes de fermeture.",
            regular: {
                title: 'Horaires réguliers',
                description: "Définissez vos créneaux d'ouverture pour chaque jour.",
            },
            holiday: {
                title: 'Périodes de fermeture',
                description: 'Ajoutez vacances et fermetures exceptionnelles.',
            },
            exceptions: {
                title: 'Jours fériés',
                description: 'Indiquez votre ouverture les jours fériés.',
            },
        },
        break: 'Pause',
        add_break: 'Ajouter une pause',
        remove_break: 'Supprimer la pause',
        start_time: 'Heure de début',
        end_time: 'Heure de fin',
        loading: 'Chargement du planning...',
        save_success: 'Planning enregistré avec succès',
        week_number: 'Semaine',
        unplanned_hours: 'Non planifié',
        lunch_break: 'Pause déjeuner',
        title: "Horaires d'ouverture",
        recap: 'Récapitulatif',
        closed: 'Fermé',
        week_days: {
            monday: 'Lundi',
            tuesday: 'Mardi',
            wednesday: 'Mercredi',
            thursday: 'Jeudi',
            friday: 'Vendredi',
            saturday: 'Samedi',
            sunday: 'Dimanche',
        },
        week_days_schedule: {
            mon: 'Lun',
            tue: 'Mar',
            wed: 'Mer',
            thu: 'Jeu',
            fri: 'Ven',
            sat: 'Sam',
            sun: 'Dim',
        },
        weekRangeScheduling: {
            title: 'Planification par plage de semaines',
            period_label: 'Nom de la période',
            period_placeholder: 'Entrez un nom pour cette plage',
            date_begin_label: 'Date de début',
            date_end_label: 'Date de fin',
            period_date_placeholder: 'jj/mm/aaaa',
        },
        scheduling_temporary_closures: {
            all_day_title: 'Journée entière',
            time_slot_title: 'Créneau horaire',
            close_label: 'Titre de la fermeture ',
            close_placeholder: 'Vacances de Pâquese',
            color_label: 'Couleur',
            hour_begin_label: 'Heure de début',
            hour_end_label: 'Heure de fin',
            hour_peack_begin_label: 'Heure creuse de début',
            hour_peack_end_label: 'Heure creuse de fin',
            reason_label: 'Motif',
            reason_placeholder: 'Sélectionner un motif',
            closure_color: {
                red: 'Rouge',
                blue: 'Bleu',
                green: 'Vert',
                orange: 'Orange',
                purple: 'Violet',
                pink: 'Rose',
                cyan: 'Cyan',
                yellow: 'Jaune',
                gray: 'Gris',
                dark_blue: 'Bleu foncé',
            },
        },
        reasons: {
            works: 'Travaux',
            maintenance: 'Maintenance',
            exceptional_closure: 'Fermeture exceptionnelle',
            team_meeting: "Réunion d'équipe",
            private_event: 'Événement privé',
            breakdown: 'Panne',
        },
        errors: {
            no_data: 'Aucune donnée de planning à enregistrer',
            save_error: 'Une erreur est survenue lors de la sauvegarde du planning',
            update_error: 'Échec de la mise à jour du planning. Veuillez réessayer.',
            invalid_time_range: "Plage horaire invalide pour {day} : l'heure de fin doit être après l'heure de début",
            invalid_lunch_range: "Heure de pause déjeuner invalide pour {day} : l'heure de fin doit être après l'heure de début",
            lunch_outside_work_hours: 'La pause déjeuner pour {day} doit être comprise dans les heures de travail',
        },
        schedule_updated: 'Planning mis à jour avec succès',
        error_updating_schedule: 'Erreur lors de la mise à jour du planning',
        exceptions: {
            title: 'Fermetures temporaires',
            description: 'Gérez les exceptions à votre planning habituel',
            add_button: 'Ajouter une exception',
            add_exception: 'Planifier des fermetures temporaires',
            set_special_hours: 'Définir des horaires spéciaux',
            edit_exception: 'Modifier la fermeture',
            establishment: 'Établissement',
            establishment_id: "ID de l'établissement",
            establishment_id_placeholder: "Entrez l'ID de l'établissement",
            status: 'Statut',
            period: 'Période',
            start_date: 'Date de début',
            end_date: 'Date de fin',
            quick_select: 'Sélection rapide',
            today: "Aujourd'hui",
            month: 'Mois',
            day: 'jour',
            tomorrow: 'Demain',
            this_week: 'Cette semaine',
            next_week: 'La semaine prochaine',
            this_weekend: 'Ce week-end',
            next_weekend: 'Le week-end prochain',
            next_month: 'Le mois prochain',
            all_day: 'Toute la journée',
            specific_hours: 'Heures spécifiques',
            start_time: 'Heure de début',
            end_time: 'Heure de fin',
            notes: 'Notes',
            notes_placeholder: 'Ajoutez des notes concernant cette exception',
            save: "Enregistrer l'exception",
            cancel: 'Annuler',
            exceptions: 'Planifier des fermetures temporaires',
            exceptions_description: 'Gérez les exceptions de planning pour les jours spécifiques',
            no_exceptions: 'Aucune exception trouvée',
            no_exceptions_description: 'Aucune exception de planning configurée pour le moment.',
            exception_types: {
                open: 'Ouvert',
                open2: 'Ouverture',
                closed: 'Fermé',
                close: 'Fermeture',
                by_appointment: 'Sur rendez-vous',
                special_hours: 'Horaires spéciaux',
                temporarily_closed: 'Temporairement fermé',
                works: 'Travaux',
                holiday: 'Vacances',
                breakdown: 'Panne',
                maintenance: 'Maintenance',
                training: 'Formation',
                special_event: 'Événement spécial',
            },
            status_options: {
                0: {
                    title: 'Inactif',
                    description: "L'exception n'est pas active",
                },
                1: {
                    title: 'Actif',
                    description: "L'exception est actuellement active",
                },
                2: {
                    title: 'Archivé',
                    description: "L'exception est archivée",
                },
            },
            preview: 'Aperçu',
            confirm_delete: 'Confirmer la suppression',
            confirm_delete_message: 'Êtes-vous sûr de vouloir supprimer cette exception ?',
            save_success: 'Exception enregistrée avec succès',
            save_error: "Erreur lors de la sauvegarde de l'exception",
            delete_success: 'Exception supprimée avec succès',
            create_success: 'Exception créée avec succès',
            update_success: 'Exception mise à jour avec succès',
            delete_error: "Erreur lors de la suppression de l'exception",
            validation: {
                establishment_required: "L'ID de l'établissement est requis",
                status_required: 'Le statut est requis',
                start_date_required: 'La date de début est requise',
                start_heure_required: "L'heure de début est requise",
                end_date_required: 'La date de fin est requise',
                end_heure_required: "L'heure de fin est requise",
                selected_days_required: 'Jours est requise',
                end_date_after_start: 'La date de fin doit être postérieure à la date de début',
            },
        },
    },
    PlanningRegulier: {
        title: 'Horaires personnalisés',
        description:
            'Personnalisez les horaires que vous souhaitez afficher sur votre site. Vous pouvez mentionner des cas particuliers comme une ouverture sur demande, une privatisation ou tout autre fonctionnement spécifique. Le texte saisi sera affiché tel quel.',
        ctaButton: 'Horaires personnalisés',
        toggleLabel: 'Afficher ces horaires personnalisés sur le site de réservation',
        tableHeader: 'Horaires',
        inputPlaceholder: 'Ex: Fermé, 9h - 18h',
        backButton: '← Retour',
        saveButton: 'Enregistrer mes horaires',
        notifications: {
            loadError: 'Impossible de charger les horaires personnalisés.',
            saveSuccess: 'Horaires enregistrés avec succès.',
            saveErrorDefault: 'Une erreur est survenue lors de la sauvegarde.',
        },
    },
    configuration: {
        stripeSetup: {
            fields: {
                stripeStatus: {
                    label: 'Activer Stripe',
                    description: 'Activez cette option pour accepter les paiements en ligne via Stripe.',
                },
                stripeSharedPayment: {
                    label: 'Activer le paiement partagé',
                    description:
                        "Activez cette option pour permettre aux clients de partager le paiement d'une réservation entre plusieurs personnes.",
                },
                stripeMode: {
                    label: 'Mode Stripe',
                    description: 'Utilisez le mode test pour les tests et le mode production pour les transactions réelles.',
                    options: {
                        production: {
                            label: 'Production',
                            description: 'Transactions réelles avec vos clients.',
                        },
                        sandbox: {
                            label: 'Test',
                            description: 'Mode test, aucune transaction réelle.',
                        },
                    },
                },
                stripeKey: {
                    label: 'Clé publique',
                    placeholder: 'pk_live_xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx',
                },
                stripeSecret: {
                    label: 'Clé secrète',
                    placeholder: 'sk_live_xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx',
                    helper: "Votre clé secrète est chiffrée, stockée en toute sécurité et n'est jamais partagée.",
                },
                klarna: {
                    label: 'Activer Klarna',
                    link: 'https://www.youtube.com/watch?v=T5FM2X4G_Kw',
                },
                applePay: {
                    label: 'Activer Apple Pay',
                    link: 'https://www.youtube.com/watch?v=J4MJsC6C5Ng',
                },
                googlePay: {
                    label: 'Activer Google Pay',
                    link: 'https://www.youtube.com/watch?v=KChUrPf8UdE',
                },
                howToActivateGoogleApplePay: {
                    label: 'Comment activer Google Pay / Apple Pay ?',
                    link: 'https://www.youtube.com/watch?v=KChUrPf8UdE',
                },
            },
            errors: {
                invalidLivePublishableKey: 'Clé publique Live invalide (doit commencer par pk_live_)',
                invalidLiveSecretKey: 'Clé secrète Live invalide (doit commencer par sk_live_)',
                invalidTestPublishableKey: 'Clé publique Test invalide (doit commencer par pk_test_)',
                invalidTestSecretKey: 'Clé secrète Test invalide (doit commencer par sk_test_)',
                invalidStatus: 'Configuration Stripe invalide',
            },
            security: {
                ipRestriction: {
                    title: 'Important : Restreindre votre clé API Stripe par adresse IP',
                    description:
                        'Pour protéger votre compte Stripe contre toute utilisation non autorisée, rendez-vous dans votre Dashboard Stripe > Developers > API Keys, puis cliquez sur "Manage IP restrictions" sur votre Secret Key et ajoutez l\'adresse IP du serveur ci-dessous.',
                    serverIp: 'IP du serveur (copier et ajouter dans Stripe)',
                },
            },
        },
        reservationCancellationRulesForm: {
            nav: {
                reservation: 'Réservation',
                cancellation: 'Annulation',
                modification: 'Modification',
            },
            sections: {
                reservation: {
                    title: 'Réservation',
                    autoConfirmation: {
                        label: 'Confirmation automatique',
                        description: 'Les réservations sont confirmées automatiquement, sans validation de votre part.',
                        messageBox:
                            'Chaque demande devra être validée manuellement. Le client recevra son e-mail de confirmation (avec lien de paiement si activé) une fois la demande acceptée..',
                    },
                    minTime: {
                        label: 'Délai minimum avant réservation',
                        description: 'Le client ne peut pas réserver moins de X heures avant le créneau.',
                        suffix: 'heures',
                    },
                    basketLock: {
                        label: 'Durée de blocage dans le panier',
                        description: "Le créneau est libéré si la réservation n'est pas finalisée dans le délai indiqué.",
                        suffix: 'minutes',
                        error: 'La valeur doit être supérieure ou égale à 5 minutes.',
                    },
                    bankImprint: {
                        label: "Délai de libération de l'empreinte bancaire",
                        description: "L'empreinte est libérée après ce délai si la réservation n'a pas lieu.",
                        suffix: 'heures',
                    },
                    transparency: {
                        label: 'Affichage client (Transparence)',
                        options: {
                            displayCancellationPolicy: {
                                label: "Afficher la politique d'annulation sur la page de réservation",
                                description:
                                    "Affiche une explication claire de vos règles d'annulation au moment de la réservation.",
                            },
                            joinConditions: {
                                label: 'Joindre les conditions aux e-mails de confirmation',
                                description: "Les CGV ou conditions d'annulation sont jointes automatiquement aux emails.",
                            },
                            displayImprintInformation: {
                                label: 'Afficher les informations sur empreinte bancaire ou acompte',
                                description: "Précise au client qu'une empreinte ou un acompte est requis, si applicable.",
                            },
                        },
                        placesDisponibles: 'Afficher les places disponibles pour les clients (activités)',
                    },
                },
                cancellation: {
                    title: 'Annulation',
                    byCustomer: {
                        label: "Autoriser l'annulation par le client",
                        description: 'Le client peut annuler sa réservation en ligne.',
                    },
                    tiers: {
                        title: 'Paliers de remboursement',
                        description:
                            "Part remboursée au client selon la date d'annulation. Ex. : 20 % remboursés, vous conservez 80 %.",
                        columnDelay: "Délai d'annulation",
                        columnPercent: '% remboursé',
                        prefixDays: 'J \u2212',
                        suffixPercent: '%',
                        deleteTitle: 'Supprimer le palier',
                        addTier: 'Ajouter un palier',
                    },
                },
                modification: {
                    title: 'Modification',
                    enabled: {
                        label: 'Autoriser la modification par le client',
                        description: 'Le client peut modifier sa réservation en ligne.',
                    },
                    deadline: {
                        label: 'Délai limite de modification',
                        description: 'Passé ce délai, la réservation ne peut plus être modifiée.',
                        suffix: 'jours',
                    },
                    complement: {
                        title: '\u00c9cart sup\u00e9rieur \u2014 paiement de la diff\u00e9rence',
                        description: 'Le client r\u00e8gle la diff\u00e9rence \u2014 carte bancaire en priorit\u00e9.',
                        options: {
                            stripe: 'Carte bancaire (via Stripe)',
                            wallet: 'Wallet',
                            voucher: 'Bon cadeau',
                        },
                        error: 'Au moins un moyen de paiement doit \u00eatre s\u00e9lectionn\u00e9.',
                    },
                    refund: {
                        title: '\u00c9cart inférieur \u2014 remboursement de la différence',
                        description: 'Mode de remboursement',
                        keepOriginal: {
                            label: "Privilégier le moyen de paiement d'origine",
                            description:
                                'Le remboursement est effectué avec le même moyen que celui utilisé pour payer la réservation.',
                        },
                        fallback: "Si le remboursement sur le moyen d'origine n'est pas possible",
                        options: {
                            wallet: 'Wallet',
                            voucher: 'Bon cadeau',
                        },
                        error: 'Au moins un mode de remboursement doit être sélectionné.',
                    },
                },
            },
        },
        title: 'Paramètres',
        subtitle: '',
        description: '',
        infoMessage: 'Vous avez rempli seulement 45% de votre espace.',
        cards: {
            establishment: {
                title: 'Établissement',
                description: 'Renseignez toutes les informations de base de votre établissement.',
                button: 'Accéder',
            },
            schedule: {
                title: "Horaires d'ouverture",
                description: "Définissez vos horaires d'ouverture et périodes de fermeture.",
                button: 'Accéder',
                editDayTitle: "Éditer l'horaire",
            },
            billing: {
                title: 'Facturation & Paiements',
                description: 'Renseignez vos informations fiscales et gérez vos moyens de paiement.',
                button: 'Accéder',
            },
            legal: {
                title: 'Juridique, RGPD & RSE',
                description: 'Renseignez vos informations légales et de conformité.',
                button: 'Accéder',
            },
            rules: {
                title: 'Règles de réservation',
                description: 'Définissez les conditions de réservation de votre établissement.',
                button: 'Accéder',
            },
            booklet: {
                title: "Devis & Livrets d'accueil",
                description: 'Renseignez toutes les informations de base de votre établissement.',
                button: 'Accéder',
            },
        },
        integration: {
            title: 'Intégrations',
            apiKey: 'Clé API',
            secretKey: 'Clé secrète',
            authUrl: 'Authentification (optionnel)',
            baseUrl: 'Base URL',
            token: 'Token',
            secret: 'Secret',
            apiKeyPlaceholder: 'Clé API publique',
            tokenPlaceholder: "Votre token d'accès",
            authUrlPlaceholder: "URL d'authentification",
            success: 'Paramètres mis à jour avec succès',
            error: 'Une erreur est survenue lors de la mise à jour',
            activationError: "Impossible d'activer l'intégration car le formulaire est vide.",
            noSettings: 'Aucun paramètre disponible pour cette intégration.',
            notAvailable: 'Paramètres non disponibles pour cette intégration.',
            karafunDesc: 'Intégrez Karafun pour gérer vos sessions de karaoké.',
            googleDesc: 'Synchronisez vos réservations avec Google Agenda.',
            googleCalendarParams: 'Paramètres des notifications Google Agenda',
            authorizeGoogle: 'Autoriser Google Calendar',
            googleConnected: 'Connecté à Google Calendar',
            linkAnotherAccount: 'Lier un autre compte',
            selectRolesToNotify: 'Sélectionner les rôles à notifier',
            selectRolesPlaceholder: 'Sélectionner les rôles...',
            noRoleSelectedHint: 'Aucun rôle sélectionné : les événements ne seront partagés avec personne.',
            geminiDesc: "Utilisez l'IA Gemini pour activer l'assistant et optimiser vos contenus.",
            karafun: 'Karafun',
            google: 'Google Agenda',
            gemini: 'Gemini',
            mailjet: 'Mailjet',
            mailjetDesc: 'Configurez Mailjet pour envoyer vos emails transactionnels et marketing.',
            mailjetApiKeyPlaceholder: 'Votre clé API Mailjet',
            mailjetSecretKeyPlaceholder: 'Votre clé secrète Mailjet',
            sendTestEmail: 'Tester la configuration',
            testAndSave: 'Tester et enregistrer',
            testEmailSending: 'Test de la connexion en cours…',
            testEmailSuccess: 'Connexion à Mailjet réussie',
            testEmailError: 'Échec de la connexion — vérifiez vos clés',
            mailjetSecretKeyHelper: 'Disponible dans votre compte Mailjet, rubrique « Paramètres API ».',
            keyAlreadyConfigured: 'Clé déjà configurée — laissez vide pour la conserver',
            mcp: 'Assistant IA (MCP)',
            mcpDesc: 'Connectez Claude, ChatGPT ou Claude Desktop à votre établissement.',
            mcpUrlTitle: 'Adresse de votre serveur MCP',
            mcpUrlHint: 'Cette adresse est propre à votre établissement. Collez-la dans votre assistant IA.',
            mcpTokenTitle: "Jeton d'accès",
            mcpTokenHint:
                "Le jeton donne à l'assistant exactement vos permissions, ni plus ni moins. Il est valable {days} jours et peut être révoqué à tout moment.",
            mcpTokenNamePlaceholder: 'Nom du jeton (ex. « Claude — poste accueil »)',
            mcpGenerate: 'Générer un jeton',
            mcpTokenOnce: 'Copiez ce jeton maintenant : il ne sera plus jamais affiché.',
            mcpCopy: 'Copier',
            mcpCopied: 'Copié',
            mcpCopyError: 'Copie impossible — sélectionnez le texte manuellement.',
            mcpActiveTokens: 'Jetons actifs',
            mcpColAccess: 'Accès',
            mcpAccessRead: 'Lecture seule',
            mcpAccessReadWrite: 'Lecture + écriture',
            mcpAccessReadHint:
                "Lecture seule : l'assistant consulte vos données mais ne peut proposer aucune modification. Recommandé pour un widget ou un tableau de bord.",
            mcpAccessReadWriteHint:
                "Lecture + écriture : l'assistant peut aussi proposer des modifications (note, client, déplacement, tarifs), à confirmer par un humain dans le back-office.",
            mcpColName: 'Nom',
            mcpColOwner: 'Créé par',
            mcpColLastUsed: 'Dernière utilisation',
            mcpColExpires: 'Expire le',
            mcpNever: 'Jamais',
            mcpExpired: 'Expiré',
            mcpRevoke: 'Révoquer',
            mcpConfirmRevoke: 'Confirmer ?',
            mcpHowToTitle: 'Comment connecter votre assistant',
            mcpClaudeStep1: 'Ouvrez claude.ai → Paramètres → Connecteurs → Ajouter un connecteur personnalisé.',
            mcpClaudeStep2: 'Collez comme URL du serveur MCP :',
            mcpClaudeStep3: "Laissez l'authentification sur « None » (Aucune).",
            mcpClaudeStep4:
                "Ajoutez un en-tête personnalisé nommé x-api-key, avec le jeton comme valeur. claude.ai n'autorise pas l'en-tête",
            mcpBearerHint: "Ces clients acceptent l'en-tête standard : indiquez la même URL et le jeton en Bearer.",
            mcpYourToken: 'votre jeton',
            field_required: 'Ce champ est requis',
            modification_success: 'La modification a été effectuée avec succès',
        },
        inlineCards: {
            general: {
                title: 'Informations générales',
                description: 'Saisissez les informations légales et visibles de votre établissement pour bien démarrer.',
            },
            tax: {
                title: 'Informations fiscales',
                description: 'Déclarez vos informations fiscales pour assurer une facturation conforme.',
            },
            headOffice: {
                title: 'Adresse du siège',
                description: "Saisissez l'adresse administrative légale de votre société.",
            },
            location: {
                title: 'Adresse de l’établissement',
                description: "Indiquez l'adresse physique de votre établissement pour faciliter la recherche de vos clients.",
            },
            contacts: {
                title: "Coordonnées de l'établissement",
                description: 'Ajoutez des moyens de contact pour vos clients et votre équipe.',
            },
            billing: {
                title: 'Moyens de paiement acceptés',
                description: 'Sélectionnez les moyens de paiement que vous souhaitez proposer à vos clients.',
            },
            stripeSetup: {
                title: 'Configuration Stripe',
                description:
                    'Encaissez vos clients par carte, Apple Pay, Google Pay et plus — via <b>Stripe</b>, notre partenaire de paiement sécurisé.',
            },
            paymentPrepaidSolutions: {
                title: 'Configuration de vos solutions prépayées',
                description: 'Configurez l’utilisation de vos bons cadeaux, forfaits, abonnements, billets non datés.',
            },
            deposit: {
                title: 'Acompte',
                description: 'Définissez si vos clients doivent verser un acompte.',
            },
            billingPolicy: {
                title: 'Politique de facturation',
                description: 'Automatisez la génération et le suivi de vos factures.',
            },
            devis: {
                title: 'Politique des devis',
                description: 'Gérez la configuration de vos devis.',
            },
            bankDetails: {
                title: 'Coordonnées bancaires (RIB)',
                description: 'Enregistrez vos informations bancaires pour les paiements par virement.',
            },
            wallet: {
                title: 'Porte-feuille électronique',
                description: 'Proposez un système de porte-monnaie électronique à vos clients.',
            },
            loyaltyProgram: {
                title: 'Programme de fidélité',
                description: 'Récompensez vos clients avec un système de points de fidélité.',
            },
            invoiceFooter: {
                title: 'Pied de page des factures',
                description: 'Personnalisez le message légal affiché sur toutes vos factures.',
            },
        },
        generalInformation: {
            fields: {
                establishmentName: {
                    label: "Nom de l'établissement",
                    description: 'Nom connu du public si différent de la raison sociale.',
                    placeholder: "L'Aventure X Passion",
                    requiredError: "Le nom de l'établissement est requis",
                },
                companyName: {
                    label: 'Raison sociale',
                    description: 'Nom légal de votre entreprise.',
                    placeholder: 'AVENTURE GROUPE SAS',
                    requiredError: 'La raison sociale est requise',
                },
                legalForm: {
                    label: 'Forme juridique',
                    description: '',
                    requiredError: 'La forme juridique est requise',
                },
                registrationNumber: {
                    label: "Numéro d'enregistrement",
                    description: "Numéro d'identification officiel (SIREN, ICE...).",
                    placeholder: '80345678000015',
                    requiredError: "Le numéro d'enregistrement est requis",
                },
                activityCode: {
                    label: "Code d'activité",
                    description: 'Code APE / NAF ou équivalent.',
                    placeholder: 'APE 9329Z',
                },
                socialCapital: {
                    label: 'Capital social',
                    description: "Montant de capital déclaré lors de la création de l'entreprise.",
                    placeholder: '5000',
                },
                officialWebsite: {
                    label: 'Site web officiel',
                    placeholder: 'https://www.mon-site.com',
                },
                officialWebsiteActive: {
                    label: 'Site web officiel actif',
                    description: 'Activez cette option pour afficher le site web officiel de votre établissement.',
                },
                logo: {
                    label: "Logo de l'établissement",
                    description: 'Image carrée 512*512 (1Mo/JPG)',
                    requiredError: "Le logo de l'établissement est requis",
                },
            },
            legalFormOptions: {
                SAS: 'SAS',
                SARL: 'SARL',
                EI: 'EI',
                EURL: 'EURL',
                SA: 'SA',
                SNC: 'SNC',
                SCS: 'SCS',
                MICRO: 'Micro-entreprise',
            },
        },
        tax: {
            fields: {
                legalAddress: {
                    label: 'Informations fiscales',
                    description: 'Saisissez l’adresse légale de votre société.',
                    placeholder: '',
                },
                country: {
                    label: "Pays d'enregistrement",
                    description: 'Sélectionnez le pays où votre entreprise est enregistrée.',
                },
                vatApplicable: {
                    label: 'Facturez-vous avec la TVA ?',
                    description: 'Indiquez si vous appliquez la TVA sur vos factures.',
                    options: {
                        yes: 'Oui',
                        no: 'Non',
                    },
                },
                vatNumber: {
                    label: 'Numéro de TVA',
                    description: 'Saisissez votre numéro de TVA intracommunautaire ou national (si applicable).',
                    placeholder: 'FR12345678901',
                },
                currency: {
                    label: 'Devise de facturation',
                    description: 'Choisissez la devise principale utilisée pour émettre vos factures.',
                },
            },
        },
        contacts: {
            formDescription: 'Moyens de contact.',
            fields: {
                email_contact_client: {
                    label: 'E-mail pour vos clients.',
                    description: 'Utilisé pour l’envoi des confirmations, rappels et annulations à vos clients.',
                    placeholder: 'contact@votre-structure.com',
                },
                email: {
                    label: 'E-mail pour l’administrateur.',
                    description: 'Ce contact recevra les alertes techniques et rapports.',
                    placeholder: 'admin@votre-structure.com',
                },
                phone_number: {
                    label: 'Téléphone principal',
                    description: 'Numéro que les clients peuvent appeler.',
                    placeholder: '+33 1 23 45 67 89',
                },
                phone_number2: {
                    label: 'Téléphone secondaire',
                    description: 'Ligne de secours ou pour usage interne.',
                    placeholder: '+33 1 23 45 67 89',
                },
                phone_number_whatsapp: {
                    label: 'Numéro WhatsApp',
                    description: 'Pour discuter avec vos clients sur WhatsApp.',
                    placeholder: '+33 1 23 45 67 89',
                },
            },
            errors: {
                email_contact_client: {
                    required: "L'e-mail de contact client est requis",
                    invalid: "Format d'e-mail invalide",
                },
                email: {
                    required: "L'e-mail de contact administrateur est requis",
                    invalid: "Format d'e-mail invalide",
                },
                phone_number: {
                    required: 'Le téléphone principal est requis',
                    invalid: 'Format de téléphone invalide',
                },
                phone_number2: {
                    invalid: 'Format de téléphone invalide',
                },
                phone_number_whatsapp: {
                    invalid: 'Format de numéro WhatsApp invalide',
                },
            },
            visibilityBox: {
                title: 'Souhaitez-vous afficher vos numéros aux clients ?',
                description: '(Vous pouvez choisir de les cacher si vous préférez)',
                help: 'Confidentialité des numéros',
                options: {
                    show: {
                        label: 'Oui, afficher les numéros',
                        desc: 'Ils seront visibles dans les e-mails, devis, factures et sur votre site Internet.',
                        emails: 'les e-mails envoyés aux clients',
                        pdf: 'les devis et factures (PDF)',
                        booklets: "les livrets d'accompagnement",
                        website: 'le site internet et les widgets',
                    },
                    hide: {
                        label: 'Non, cacher les numéros',
                        desc: 'Ils ne seront visibles nulle part. Ils seront uniquement utilisés en interne.',
                        emails: 'tous les e-mails clients',
                        pdf: 'les devis, factures et livrets PDF',
                        website: 'le site et tout support visible par le client',
                        whatsapp: 'les boutons ou liens WhatsApp',
                    },
                },
            },
        },
        locationForm: {
            fields: {
                address: {
                    label: 'Adresse de l’établissement',
                    description: '(Numéro et rue, lieu-dit, etc.)',
                    placeholder: '12 Rue de résultat',
                },
                complement: {
                    label: "Complément d'adresse",
                    description: '(Bâtiment, étage, boîte postale…)',
                    placeholder: 'Bâtiment A - 3e étage',
                },
                city: {
                    label: 'Ville',
                    placeholder: 'Champagneux',
                },
                postalCode: {
                    label: 'Code postal',
                    placeholder: '73240',
                },
                country: {
                    label: 'Pays',
                },
                timezone: {
                    label: 'Fuseau horaire',
                    description: 'Fuseau horaire de votre établissement',
                },
                language: {
                    label: 'Langue',
                },
                isSameBillingAddress: {
                    label: 'L’adresse de facturation est-elle identique à l’adresse du siège social ?',
                    description:
                        'Si vous sélectionnez "Oui", l’adresse de l’établissement sera automatiquement reprise depuis l’adresse du siège social. Cela vous évite de la saisir une seconde fois.',
                },
            },
            interactiveMap: {
                label: 'Carte interactive',
                description: 'Positionnez votre établissement sur la carte pour aider vos clients à vous trouver facilement.',
            },
            errors: {
                addressRequired: "L'adresse est requise",
                cityRequired: 'La ville est requise',
                postalCodeRequired: 'Le code postal est requis',
                countryRequired: 'Le pays est requis',
                timezoneRequired: 'Le fuseau horaire est requis',
            },
        },
        colorPalette: {
            predefinedTitle: 'Palettes prédéfinies',
            selectPaletteLabel: 'Sélectionner une palette :',
            separator: 'OU',
            customTitle: 'Sélecteur de couleurs',
            customDescription: 'Personnalisez votre couleur en choisissant un code précis selon vos préférences.',
            palettes: {
                ocean_frais: 'Océan frais',
                foret_profonde: 'Forêt profonde',
                energie_vive: 'Énergie vive',
                terracotta_chic: 'Terracotta chic',
                noir_or: 'Noir & or',
            },
            fields: {
                primary: {
                    label: 'Couleur principale',
                    hint: 'Pour le header, boutons principaux',
                    description: 'Couleur dominante de votre charte.',
                    required: 'La couleur principale est obligatoire',
                    invalid: 'Format hexadécimal invalide',
                },
                secondary: {
                    label: 'Couleur secondaire',
                    hint: 'Pour les arrière-plans et sections secondaires',
                    description: 'Couleur d’arrière-plan ou complémentaire.',
                    required: 'La couleur secondaire est obligatoire',
                    invalid: 'Format hexadécimal invalide',
                },
                accent: {
                    label: "Couleur d'accent",
                    hint: 'Pour les éléments à mettre en avant',
                    description: 'Pour les liens et les boutons.',
                    invalid: 'Format hexadécimal invalide',
                },
            },
            globalError: 'Veuillez corriger les erreurs de couleurs',
        },
    },
    establishment: {
        scheduling: {
            save_success: 'La période de vacances a été ajoutée avec succès',
            update_success: 'La période de vacances a été mise à jour avec succès',
            confirm_delete_holiday:
                'Êtes-vous sûr de vouloir supprimer cette période de vacances ? Cette action est irréversible.',
            delete_success: 'Les horaires de vacances ont été supprimés avec succès',
            confirm_delete_exception: 'Êtes-vous sûr de vouloir supprimer cette exception ? Cette action est irréversible.',
            exception_saved: "L'exception a été enregistrée avec succès",
            exception_deleted: "L'exception a été supprimée avec succès",
            delete_error: 'Une erreur est survenue lors de la suppression de la période de vacances.',
        },
    },
    views: {
        list: 'Liste',
        calendar: 'Calendrier',
    },
    loading: 'Chargement du planning...',
    no_schedule: 'Aucun horaire disponible',
    remove_break: 'Supprimer cette pause',
    save: 'Sauvegarder',
    saving: 'Enregistrement...',
    editDay: {
        title: 'Modifier la journée',
        edit: 'Éditer',
    },
    day: {
        copy: 'Copier',
        addBreak: 'Ajouter une pause',
        periods: {
            start: 'Début',
            end: 'Fin',
        },
    },
    paymentMethods: {
        dragHint: 'Glisser pour réordonner les méthodes de paiement',
        details: {
            discount: {
                description: 'Méthode de remise applicable',
                infoMessage: "Ce mode s'applique uniquement aux remises spécifiques.",
            },
            cure: {
                description: 'Active les paiements via les abonnements clients.',
                infoMessage: 'Les abonnements sont automatiquement détectés lors de la réservation.',
            },
            series: {
                description: "Permet l'utilisation de forfaits multi-entrées ou multi-activités.",
                infoMessage:
                    'Aucune configuration supplémentaire requise. Les forfaits sont proposés automatiquement s’ils sont actifs.',
            },
            card: {
                description: 'Permettez le paiement par carte bancaire sur place.',
                infoMessage: '',
            },
            cheque: {
                description: "Acceptez les paiements par chèque à l'ordre de votre établissement.",
                infoMessage: '',
            },
            cash: {
                description: 'Permettez le paiement en espèces sur place.',
                infoMessage: '',
            },
            transfer: {
                description: 'Permettez les paiements par virement bancaire.',
                infoMessage: 'Vous devrez remplir vos coordonnées bancaires dans la section RIB.',
            },
            gift_card: {
                description: 'Permettez l’utilisation des bons cadeaux émis par votre établissement.',
                infoMessage: 'Une fois activé, des options apparaîtront dans la section <Paiement via solutions prépayées>.',
            },
            stripe: {
                description:
                    'Permettez le paiement en ligne via Carte Bancaire, Apple Pay, Google Pay et prochainement Bancontact.',
                infoMessage: '',
            },
            wallet: {
                description: 'Acceptez le paiement via le porte-monnaie électronique.',
                infoMessage:
                    'Vos clients peuvent créditer leur porte-monnaie à l’avance et l’utiliser facilement lors de leurs achats.',
            },
            undated_ticket: {
                description:
                    'Permettez à vos clients de prépayer un billet pour une utilisation future, sans y mentionner une date et un horaire.',
                infoMessage: 'Une fois activé, des options apparaîtront dans la section "Paiement via solutions prépayées".',
            },
            ancv: {
                description: 'Permettez le paiement par chèques-vacances ANCV',
                infoMessage: '',
            },
            culture_pass: {
                description: 'Permettez aux jeunes le paiement via leur Pass Culture.',
                infoMessage: '',
            },
            money_banking: {
                description: 'Permettez le paiement par téléphone via Money Banking.',
                infoMessage: 'Proposé uniquement sur le POS.',
            },
        },
    },
    messageBox: {
        payment: {
            start: {
                title: 'Sélectionnez les méthodes de paiement que vous souhaitez proposer à vos clients. Ces options seront visibles lors des réservations en ligne et en caisse.',
            },
            examples: {
                title: 'Exemple concret :',
                text: 'Un parc d’accrobranche propose CB, espèces, chèques, bons cadeaux et Stripe pour les réservations en ligne. Les clients peuvent ainsi réserver sur le site web avec Stripe ou utiliser un bon cadeau offert par un proche.',
            },
            advice: {
                title: 'Conseil de configuration :',
                text: 'Pour les établissements de loisirs, nous recommandons d’activer au minimum CB, espèces et Stripe. Les bons cadeaux sont particulièrement populaires pour les activités de loisirs et peuvent représenter jusqu’à 30% du chiffre d’affaires pendant les fêtes.',
            },
        },
        stripeSetup: {
            start: {
                title: 'Connectez votre compte Stripe pour accepter les paiements en ligne et proposer des méthodes modernes comme Apple Pay, Google Pay, Klarna ou PayPal.',
            },
        },
        paymentPrepaidSolutions: {
            start: {
                title: 'Acceptez les paiements via bons cadeaux, forfaits, abonnements ou billets non datés. Une manière simple de fidéliser vos clients et d’encaisser à l’avance.',
            },
        },
        depositForm: {
            start: {
                title: ' Définissez si vos clients doivent verser un acompte et choisissez son montant. Sécurisez vos créneaux tout en offrant de la flexibilité à vos clients.',
            },
        },
        billingPolicy: {
            start: {
                title: "Définissez votre politique de facturation et d'annulation. Ce texte sera affiché sur vos documents et en ligne.",
            },
        },
        devis: {
            start: {
                title: 'Définissez votre politique pour les devis. Configurez si les devis doivent être liés à des créneaux horaires.',
            },
        },
        bankDetails: {
            start: {
                title: 'Indiquez les coordonnées de votre compte bancaire pour les virements de vos clients et les prélèvements PlayPro. Ces informations figureront sur vos factures et devis.',
            },
        },
        wallet: {
            start: {
                title: 'Activez le portefeuille pour permettre à vos clients de stocker des crédits et de payer plus rapidement. Un excellent moyen de fidéliser !',
            },
        },
        loyaltyProgram: {
            start: {
                title: 'Récompensez vos clients fidèles en leur permettant de cumuler des points convertibles en avantages.',
            },
        },
        invoiceFooter: {
            start: {
                title: 'Personnalisez le texte affiché en bas de toutes vos factures. Vous pouvez y indiquer vos mentions légales, conditions de paiement ou notes internes.',
            },
        },
        reservationCancellationRulesForm: {
            start: {
                title: 'Configurez le comportement de vos réservations : validation automatique ou manuelle, délais, annulation client, pénalités, et transparence.',
            },
        },
    },
    prepaidSolutionsConfiguration: {
        fields: {
            prepaidVoucher: {
                label: 'Bon cadeau',
                tool_tip_msg: 'La période de validité commence à la date d’achat. Exemple : 365 = 1 an.',
                description: 'Validité du bon cadeau (en jours)',
            },
            prepaidUndatedTicket: {
                label: 'Billet non daté',
                tool_tip_msg: 'La période de validité commence à la date d’achat. Exemple : 180 = 6 mois.',
                description: 'Validité du billet non daté (en jours)',
            },
            prepaidPackages: {
                label: 'Forfaits (packs prépayés)',
                message: 'Les forfaits sont automatiquement proposés comme moyen de paiement s’ils sont actifs dans votre offre.',
            },
            prepaidActiveSubscriptions: {
                label: 'Abonnements actifs',
                message: 'Les abonnements valides sont détectés automatiquement pour les clients concernés.',
            },
            giftEnabled: {
                label: 'Activation de la vente de bons cadeaux',
                description: 'Activez cette option pour permettre à vos clients d’acheter des bons cadeaux sur votre site.',
                error: 'Une erreur est survenue lors de l’activation des bons cadeaux.',
            },
        },
    },
    depositForm: {
        fields: {
            isDeposit: {
                label: "Activer l'acompte",
                description: 'Permet de demander un paiement partiel lors de la réservation. Utile pour sécuriser vos créneaux.',
            },
            depositType: {
                label: 'Type d’acompte à sélectionner',
                description: 'Choisissez si l’acompte se calcule en montant fixe ou en pourcentage du total de la réservation.',
                options: {
                    amount: {
                        label: 'Montant fixe',
                        description: 'Vous demandez toujours le même montant, quel que soit le total de la réservation',
                    },
                    percent: {
                        label: 'Pourcentage',
                        description:
                            'Exemple : Si l’acompte est de 30 %, pour une réservation de 100 {symbol}, un montant de 30 {symbol} sera demandé.',
                    },
                },
            },
            depositValuePercent: {
                label: "Pourcentage d'acompte",
                placeholder: '30',
            },
            depositValueAmount: {
                label: "Montant d'acompte ",
                placeholder: 'Ex. 30',
            },
            depositIsRequested: {
                label: 'Définir où l’acompte est demandé (facultatif)',
                options: {
                    unicInSite: {
                        label: 'Forcer le paiement avec acompte uniquement sur le site de réservation',
                        description: 'Le client ne pourra pas payer l’intégralité en ligne.',
                    },
                    viaPaymentLink: {
                        label: 'Forcer le paiement avec acompte via les liens de paiement',
                        description: 'Les liens de paiement envoyés demanderont uniquement l’acompte.',
                    },
                },
            },
        },
    },
    billingPolicy: {
        fields: {
            policyText: {
                label: 'Politique de facturation',
                placeholder: "Saisissez ici vos conditions de facturation et d'annulation...",
            },
            activateAutoBilling: {
                label: 'Activer la facturation automatique',
                description:
                    'Si activé, les factures seront générées automatiquement à la fin de chaque réservation ou activité.',
                options: {
                    draftInvoices: {
                        label: 'Autoriser les factures provisoires',
                        description:
                            'Permet de generer des factures provisoires avant le paiement complet, utile pour les clients professionnels.',
                    },
                },
            },
            numberingFormat: {
                label: 'Format de numérotation ',
                infoMessage:
                    'Choisissez le format pour vos numéros de facture. YYYY: Année, MM: Mois, Numéro: Numéro séquentiel.',
            },
            startingNumber: {
                label: 'Numéro de départ de facturation',
                infoMessage: 'Indiquez le numéro à partir duquel la numérotation de vos factures commencera.',
            },
            paymentDeadline: {
                label: 'Échéance de paiement',
                infoMessage:
                    'Nombre de jours accordés à vos clients pour régler le solde après la prestation. Cette échéance figurera sur vos factures.',
            },
        },
    },
    bankDetails: {
        fields: {
            bankingInstitution: {
                label: 'Établissement bancaire',
                infoMessage: 'Indiquez le nom complet de votre banque.',
                placeholder: 'Crédit Mutuel',
            },
            accountName: {
                label: 'Indiquez le nom exact du titulaire tel qu’il apparaît sur votre RIB',
                infoMessage: 'Indiquez le nom exact du titulaire tel qu’il apparaît sur votre RIB.',
                placeholder: 'SARL LOISIRS AVENTURE',
            },
            iban: {
                label: 'IBAN',
                infoMessage: 'Numéro de compte au format international (27 caractères).',
                placeholder: 'FR76 XXXX XXXX XXXX XXXX XXXX XXX',
            },
            bic: {
                label: 'BIC/SWIFT ',
                infoMessage: 'Code d’identification de votre banque (8 ou 11 caractères).',
                placeholder: 'CMCIFR2A',
            },
            options: {
                accurateInformation: {
                    label: 'Je certifie que les informations bancaires fournies sont exactes et autorise PlayPro à les utiliser pour toutes les opérations nécessaires au bon fonctionnement du service.',
                },
            },
        },
    },
    wallet: {
        fields: {
            enableWallet: {
                label: 'Activer le portefeuille',
                description:
                    'Permettez à vos clients de stocker des crédits et de payer à l’avance. Sécurisez vos revenus et fidélisez vos clients.',
                labelCashback: 'Activer une récompense client (cashback)',
                descriptionCashback:
                    'Offrez un bonus à vos clients lorsqu’ils alimentent leur portefeuille. Recevez des paiements anticipés et boostez votre chiffre d’affaires.',
                additionalOfferDescription: 'Offrez un montant supplémentaire automatiquement ...',
            },
            bonusOffered: {
                label: 'Bonus offert',
                placeholder: 'Bonus offert',
                infoMessage:
                    'Le pourcentage de bonus que vous souhaitez créditer dans le portefeuille de vos clients. Exemple avec 5% : ils déposent 100{symbol} et reçoivent au total 105{symbol}.',
            },
        },
    },
    loyaltyProgram: {
        fields: {
            enableLoyaltyProgram: {
                label: 'Activer le programme de fidélité',
                description: 'Permet à vos clients de cumuler des points à chaque achat et de les convertir en avantages.',
            },
            pointsPerEuro: {
                label: 'Points gagnés pour 1{symbol}',
                infoMessage: 'Nombre de points crédités pour chaque euro dépensé.',
            },
            pointsValue: {
                label: 'Valeur des points',
                infoMessage: 'Détermine combien de points sont nécessaires pour obtenir 1{symbol} de crédit.',
            },
            autoTransferThreshold: {
                label: 'Seuil de transfert automatique',
                infoMessage:
                    'Seuil à partir duquel les points sont automatiquement transférés sur le porte-feuille électronique.',
            },
        },
    },
    invoiceFooter: {
        fields: {
            footerText: {
                label: 'Texte affiché en bas des factures',
                placeholder: 'Saisissez ici le texte du pied de page de votre facture...',
                infoMessage:
                    "Ce texte s'affichera automatiquement en bas de toutes vos factures. Il peut inclure des mentions légales obligatoires ou des conditions spécifiques (pénalités, délais, etc.). Vous pouvez le modifier ou revenir au modèle standard à tout moment.",
            },
        },
    },
    datatable_customer_email_v2_edit: {
        subject: 'Sujet',
        sentDate: "Date d'envoi",
    },
    title_datatable_customer_email_v2_edit: 'Emails',
    title_datatable_customer_booking_v2_edit: 'Réservations',
    datatable_customer_booking_v2_edit: {
        date: 'Date du réservation',
        created_at: 'Date de création',
        prestations: 'Activité',
        for: 'Destinataire',
        space: 'Salle',
        staff: 'Staff',
        status: 'Statut',
        payment: 'Paiement',
        action: 'Action',
        actions: {
            send_sms: {
                label: 'Envoyer SMS',
                title: 'Envoi SMS de rappel',
            },
            schedule_reservation: {
                label: 'Planifier réservation',
                title: 'Planifier rdv',
            },
            reschedule_reservations: {
                label: 'Replanifier réservation',
                title: '',
            },
            send_email: {
                label: 'Envoyer mail',
                title: 'Envoi mail de rappel',
            },
            historical: {
                label: 'Historique',
                title: 'Historique',
            },
        },
        status_item: {
            absent: 'Absent',
            present: 'Présent',
            booked: 'Réservé',
            payed: 'Payé',
            fenced: 'Clôturé',
            pre_recorded: 'Pré-enregistré',
            ruler: 'Réglé',
            canceled: 'Annulé',
        },
    },
    title_datatable_customer_products_purchased_v2_edit: 'Produits achetés',
    datatable_customer_products_purchased_v2_edit: {
        name: 'Nom du produit',
        type: 'Type',
        created_at: "Date d'achat",
        price: 'Prix',
        delivery: 'Livraison',
        status: 'Statut',
        staff: 'Vendeur',
        consumption: 'Consommation',
        action: 'Action',
        actions: {
            btn_box: {
                label: 'Créer une vente',
                title: 'Créer une vente',
            },
            btn_receipt: {
                label: 'Voir le reçu',
                title: 'Voir le reçu',
            },
        },
        status_item: {
            in_progess: 'En cours',
            on_hold: 'En attente',
            paid: 'Payée',
            delivered: 'Livrée',
            blocked: 'Bloquée',
            saved: 'Sauvegardée',
            fenced: 'Cloturée',
            finished: 'Terminée',
        },
    },
    title_datatable_customer_vouchers_purchased_v2_edit: 'Bons cadeaux',
    datatable_customer_vouchers_purchased_v2_edit: {
        code: 'Code',
        purchase: 'Achat',
        invoice: 'Facture',
        delivery: 'Offert par',
        to: 'Pour',
        send_date: "Date d'emission",
        date_end: "Date d'éxpiration",
        prestations_prices: 'Activité',
        balance: 'Solde restant',
        status: 'Statut',
        action: 'Action',
        days: 'Jours',
        actions: {
            btn_donwload: {
                label: 'Télécharger',
                title: 'Télécharger',
            },
            btn_modify: {
                label: 'Modifier',
                title: 'Modifier',
            },
            btn_history: {
                label: 'Historique',
                title: 'Historique',
            },
            btn_send_email: {
                label: 'Envoyer par mail',
                title: 'Envoyer par mail',
            },
            btn_disabled: {
                label: 'Désactiver',
                title: 'Désactiver bon cadeau',
            },
            btn_enabled: {
                label: 'Réactiver',
                title: 'Réactiver bon cadeau',
            },
        },
        status_item: {
            expired: 'Périmé',
            not_sent: 'Non envoyé',
            totally_used: 'Totalement utilisé',
            partially_used: 'Partiellement utilisé',
            not_used: 'Non utilisé',
        },
    },
    quotes: {
        title: 'Devis',
        create: 'Créer un devis',
        all_quotes: 'Tous les devis',
        accepted_quotes: 'Devis acceptés',
        pending_quotes: 'Devis en attente',
        expired_quotes: 'Devis expirés',
        edit_columns: 'Modifier les colonnes',
        columns_short: 'Colonnes',
        validate_quote: 'Valider devis',
        types: {
            all: 'Toutes',
            demande: 'Demandes',
            envoye: 'Envoyés',
            signe: 'Signés',
            paye: 'Payés en totalité',
            perdu: 'Perdus',
            anniversaire: 'Anniversaire',
            entreprise: 'Entreprise',
            evg_evjf: 'EVG/EVJF',
            manuel: 'Manuel',
        },
        send_modal: {
            title: 'Envoyer à « {client} »',
            subject_label: 'Sujet :',
            subject_value: 'Votre devis n° {number}',
            content_label: 'Contenu du message',
            content_placeholder: 'Rédigez le message qui accompagnera le devis...',
            content_required: 'Le contenu du message est obligatoire.',
            attachment_label: 'Pièce jointe',
            send: 'Envoyer',
        },
        answer_modal: {
            title: 'Demande #{id}',
            email: 'Adresse e-mail',
            phone: 'Numéro de téléphone',
            reply: 'Répondre',
        },
        view: {
            list: 'Vue Liste',
            kanban: 'Vue Kanban',
        },
        columns: {
            status: 'Statut',
            type: 'Type',
            created_at: 'Date de création',
            emission: 'Émission',
            due_date: 'Échéance',
            customer: 'Client',
            number: 'Numéro',
            amount_ht: 'Montant HT',
        },
        kanban: {
            columns: {
                brouillon: 'Brouillons',
                demande: 'Demandes',
                envoye: 'Envoyés',
                expire: 'Expirés',
                gagne: 'Gagnés',
                perdu: 'Perdus',
            },
            loading_board: 'Chargement du tableau...',
            empty: 'Aucun devis',
            loading: 'Chargement...',
            load_more: 'Afficher plus de devis',
            load_error: 'Erreur lors du chargement des devis',
        },
        card: {
            deleted_client: 'Client supprimé',
            default_type: 'Devis',
            created_by: 'Créé par {name}',
            relance_tag: 'Relance du {date}',
            already_invoiced: 'Déjà facturé',
            view_edit: 'Voir / Modifier',
            download: 'Télécharger',
            duplicate: 'Dupliquer',
            mark_won: 'Marquer gagné',
            mark_lost: 'Marquer perdu',
            delete: 'Supprimer',
            actions: {
                respond: 'Répondre',
                relaunch: 'Relancer',
                invoice_balance: 'Facturer solde',
                invoice: 'Facturer',
                validate: 'Valider',
                preview_invoice: 'Prévisualiser la facture',
                reopen: 'Rouvrir',
                send: 'Envoyer',
                send_simple: 'Envoi simple',
                send_custom: 'Envoi personnalisé',
            },
            toasts: {
                not_implemented: 'Action non implémentée dans cette démo',
                sent: 'Devis envoyé au client par email',
                draft_created: 'Brouillon de devis créé',
                downloading: 'Téléchargement...',
                duplicating: 'Duplication...',
                marked_won: 'Devis marqué comme gagné',
                error: 'Erreur',
                marked_lost: 'Marqué comme perdu',
                relaunched: 'Le devis a été relancé avec succès',
                reopened: 'Le devis a été rouvert et déplacé en brouillon',
                invoiced: 'Facture créée et envoyée au client',
                deleting: 'Suppression...',
            },
        },
        experience_dates: {
            title: 'Dates des expériences requises',
            section: 'Expériences à dater',
            date_label: 'Date :',
            choose_date: 'Choisir une date',
            required: 'Obligatoire',
            alert: "Une expérience n'a pas de date. Définissez-la avant de valider ce devis.",
            alert_plural: "Certaines expériences n'ont pas de date. Définissez-les avant de valider ce devis.",
            confirm: 'Définir les dates',
            slot_saved: 'Créneau enregistré',
            slot_error: "Erreur lors de l'enregistrement du créneau",
            capacity_ok: 'Capacité OK · {available}/{max} places',
            capacity_over: 'Capacité dépassée · {available}/{max} places',
            participants: '{count} participants',
            date_past: 'Date dépassée',
            modify_date: 'Modifier la date',
            alert_past: 'Une ou plusieurs dates sont dépassées. Vous pouvez les modifier ou convertir le devis tel quel.',
        },
    },
    devisV3: {
        clientSelector: {
            civility: {
                mme: 'Mme',
                m: 'M.',
                man: 'Homme',
                woman: 'Femme',
                other: 'Autre',
            },
            newClient: 'Nouveau client',
            editClient: 'Modifier le client',
            backToCreation: '+ Nouvelle fiche',
            save: 'Enregistrer',
            civilityLabel: 'Civilité',
            validate: 'Valider',
            placeholders: {
                lastName: 'ex. Dupont',
                firstName: 'ex. Marie',
                email: 'prenom.nom@domaine.fr',
                phone: '6 12 34 56 78',
                address: 'N° et rue, code postal, ville',
                socialReason: "Nom de l'entreprise ou de l'association",
                identificationNumber: 'SIREN, UID, etc.',
                phoneByCountry: {
                    fr: '6 12 34 56 78',
                    be: '470 12 34 56',
                    ch: '79 123 45 67',
                    lu: '621 123 456',
                    de: '1512 3456789',
                    es: '612 34 56 78',
                    it: '312 345 6789',
                    gb: '7400 123456',
                    tn: '20 123 456',
                    ma: '612 345 678',
                    dz: '551 23 45 67',
                    us: '(202) 555-0123',
                },
            },
            types: {
                individual: 'Particulier',
                company: 'Professionnel',
            },
            companyLookup: 'Rechercher une entreprise',
            companyLookupPlaceholder: 'Raison sociale, SIREN ou SIRET',
            companySearching: 'Recherche en cours…',
            companyNoResult: 'Aucun résultat — votre saisie sera conservée',
            companyDataSource: 'Données',
            companyDataSourceName: "API Recherche d'entreprises (data.gouv.fr)",
            changeCompany: "Changer d'entreprise",
            discardConfirmation: {
                title: 'Modifications non enregistrées',
                message: 'Si vous quittez maintenant, vos modifications seront perdues.',
                leaveWithoutSaving: 'Quitter sans enregistrer',
                saveAndExit: 'Enregistrer et quitter',
            },
            socialReason: 'Raison sociale',
            identificationNumber: "N° d'identification (recommandé)",
            siret: 'SIRET',
            function: 'Fonction',
            tva: 'Numéro TVA',
            firstName: 'Prénom',
            lastName: 'Nom',
            email: 'Adresse email',
            phone: 'Téléphone',
            address: 'Adresse',
            addressSearching: 'Recherche d’adresses…',
            addressNoResult: 'Aucune adresse trouvée — votre saisie sera conservée.',
            addressDataSource: 'Adresses Google Places',
            city: 'Ville',
            postalCode: 'Code postal',
            country: 'Pays',
            or: 'ou',
            add: 'Ajouter',
            errors: {
                invalidEmail: "L'adresse email doit être valide",
                updateSuccess: 'Fiche client mise à jour',
                loadError: 'Impossible de charger la fiche client',
                formError: 'Veuillez corriger les erreurs dans le formulaire',
                createSuccess: 'Client créé avec succès',
                createError: 'Erreur lors de la création',
            },
        },
        clientSearch: {
            label: 'Client',
            placeholder: 'Nom, société, email, téléphone',
            noResults: 'Aucun client trouvé',
            recent: 'Clients récents',
            createBlank: 'Créer un nouveau client',
            createTyped: 'Créer « {query} »',
            blankHint: 'Fiche vierge',
            prefillHints: {
                email: 'Email pré-rempli',
                phone: 'Téléphone pré-rempli, indicatif pays détecté',
                identifier: 'Mode professionnel, numéro d’identification pré-rempli',
                company: 'Mode professionnel, raison sociale et suggestions annuaire ouvertes',
                name: 'Nom pré-rempli',
                fullName: '1er mot → Nom, reste → Prénom',
            },
            change: 'Changer de client',
            edit: 'Modifier la fiche',
        },
    },
    voucherDatatable: {
        columns: {
            code: 'Code',
            send_date: "Date d'envoi",
            date_end: "Date d'expiration",
            import_note: "Note d'import",
            total_amount: 'Montant total',
            available_amount: 'Solde',
            gifted_by: 'Offert par',
            gifted_to: 'Offert à',
            actions: 'Actions',
            created_at: 'Date de création',
            status: {
                placeholder: 'Tous les statuts',
                options: {
                    active: 'Active',
                    used: 'Utilisé',
                    expired: 'Expiré',
                    blocked: 'Bloqué',
                    partially_used: 'Utilisé partiellement',
                },
            },
            items: {
                empty: 'Aucun objet lié.',
                article: 'Article',
            },
        },
        actions: {
            edit: 'Modifier',
            generate_invoice: 'Générer facture',
            reactivate: 'Réactiver',
            disable: 'Désactiver',
            history: 'Historique',
            resend_email: 'Renvoyer le mail',
            download: 'Télécharger',
        },
        modal: {
            title: {
                reactivate: 'Voulez-vous réactiver ce bon cadeau ?',
                disable: 'Voulez-vous désactiver ce bon cadeau ?',
            },
            button: {
                reactivate: 'Activer',
                disable: 'Désactiver',
            },
            cancel: 'Fermer',
        },
        notifications: {
            loadError: "Une erreur s'est produite lors du chargement des données.",
            exportSuccess: 'Le fichier Excel a été téléchargé avec succès.',
        },
    },
    title_datatable_customer_treatement_v2_edit: 'Forfaits',
    datatable_customer_treatement_v2_edit: {
        name: 'Nom',
        date_of_purchase: "date d'achat",
        price_of_purchase: "Prix d'achat",
        authorized_activities: 'Activités autorisées',
        initial_quantity: 'Quantité initiale',
        remaining_quantity: 'Quantité restante',
        expiry: 'Expiration',
        linked_reservation: 'Réservation liée',
        action: 'Action',
        actions: {
            btn_chedule: {
                label: 'Planifier réservation',
                title: 'Planifier une réservation',
            },
        },
        status_item: {
            expired: 'Expirée',
            valid_until: "Valide jusqu'au",
            none: 'Aucune',
        },
    },
    title_datatable_customer_serie_v2_edit: 'Abonnements',
    validation: {
        date_range_required: 'Veuillez sélectionner une date de début et une date de fin',
        schedule_data_required: 'Aucune donnée de planning disponible',
        label_required: 'Veuillez saisir un libellé',
        check_planning: 'Veuillez vérifier le planning',
        start_date_before_end_date: 'La date de début doit être avant la date de fin',
        start_time_before_end_time: "L'heure de début doit être avant l'heure de fin",
        title_required: 'Le titre est requis',
        start_date_required: 'La date de début est requise',
        end_date_required: 'La date de fin est requise',
        reason_required: 'Veuillez sélectionner un motif',
    },
    datatable_customer_serie_v2_edit: {
        name: 'Nom',
        date_of_purchase: "date d'achat",
        price_of_purchase: "Prix d'achat",
        authorized_activities: 'Activités autorisées',
        initial_quantity: 'Quantité initiale',
        remaining_quantity: 'Quantité restante',
        expiry: 'Expiration',
        payment: 'Paiement',
        next_collection: 'Prochain prélèvement',
        linked_reservation: 'Réservation liée',
        action: 'Action',
        actions: {
            btn_chedule: {
                label: 'Planifier réservation',
                title: 'Planifier une réservation',
            },
            btn_download: {
                label: 'Télécharger',
                title: 'Télécharger',
            },
            btn_delete: {
                label: 'Supprimer',
                title: 'Supprimer',
            },
        },
        duree_inline: {
            every_week: 'Toutes les semaines',
            every_fifteen_days: 'Tous les 15 jours',
            every_month: 'Tous les mois',
            every_two_months: 'Tous les 2 mois',
            every_three_months: 'Tous les 3 mois',
            once_a_year: 'Une fois par an',
            only: 'Unique',
        },
        status_item: {
            expires: 'Expire le',
            expired_on: 'A expiré le',
            none: 'Aucune',
        },
    },
    form_customer_v2: {
        action_setting: {
            loyalty_points: 'Points de fidélité',
            either: 'Soit',
            in_your_establishment: 'dans votre établissement',
            wallet_balance: 'Solde du portefeuille',
            btn_create_booking: 'Créer une réservation',
            btn_payment_subscription_management: 'Gestion des paiements & abonnements',
            btn_quick_sale: 'Vente rapide',
        },
        main_information: {
            title_infomation: 'Informations principales',
            label_professional_customer: 'Client professionnel',
            label_individual_customer: 'Client particulier',
            first_name: {
                label: 'Prénom',
                placeholder: 'Entrez un prénom',
                required: 'Le prénom est obligatoire.',
            },
            last_name: {
                label: 'Nom',
                placeholder: 'Entrez un nom',
                required: 'Le nom est obligatoire.',
            },
            function: {
                label: 'Fonction',
                placeholder: 'Entrez une fonction',
            },
            civility: {
                label: 'Civilité',
                placeholder: 'Entrez une civilité',
            },
            email: {
                label: 'Email',
                placeholder: 'Entrez un e-mail',
                required: "L'email est obligatoire.",
            },
            phone: {
                label: 'Téléphone',
                placeholder: 'Entrez un téléphone',
                required: 'Le téléphone est obligatoire.',
            },
            fix_phone: {
                label: 'Téléphone fixe',
                placeholder: 'Entrez un téléphone fixe',
            },
            customer_group: {
                label: 'Groupe de clients',
                placeholder: 'Sélectionnez un groupe de clients',
            },
            origin: {
                label: 'Origine',
                placeholder: '--Choisissez une origine--',
            },
            date_of_birth: {
                label: 'Date de naissance',
                placeholder: 'Date de naissance',
            },
            gender: {
                label: 'Genre',
                placeholder: '--Choisissez un genre--',
            },
            permissions: 'Autorisations',
            GDPR: 'GDPR',
            block_online_booking: 'Bloquer la réservation en ligne',
            block_payment_by_gift_voucher: 'Bloquer le paiement par bon cadeau',
            allow_receiving_emails: "Autoriser la réception d'emails",
            allow_receiving_sms_messages: 'Autoriser la réception de SMS',
            company_name: {
                label: "Nom de l'entreprise",
                placeholder: "Entrez le nom de l'entreprise",
            },
            siret: {
                label: "Numéro d'identification",
                placeholder: 'SIRET, UID, etc',
            },
            individual: {
                label: 'Particulier',
            },
            professional: {
                label: 'Professionnel',
            },
            customer_type: {
                label: 'Type',
            },
            subscribed_to_communications: 'Inscrit aux communications',
            vat: {
                label: 'Numéro de TVA intracommunautaire',
                placeholder: 'Entrez le numéro de TVA intracommunautaire',
            },
        },
        addresses: {
            title: 'Adresses',
            title_addresses: 'Adresses',
            country: {
                label: 'Pays',
                placeholder: 'Entrez un pays',
                required: 'Le pays est obligatoire.',
            },
            city: {
                label: 'Ville',
                placeholder: 'Entrez une ville',
                required: 'La ville est obligatoire.',
            },
            address: {
                label: 'Adresse',
                placeholder: 'Entrez une adresse',
                required: "L'Adresse est obligatoire.",
            },
            zip_code: {
                label: 'Code postal',
                placeholder: 'Entrez un code postal',
                required: 'Le code postal est obligatoire.',
            },
        },
        internal_notes: {
            title: 'Notes internes',
            important: 'Note importante',
            placeholder: 'Nouvelle note...',
            setting: 'Paramètres des catégories de notes',
        },
        customer_alerts: {
            title: 'Alertes client',
            no_present: 'Non voir',
            placeholder: 'Nouvelle note',
        },
        btn: {
            reset: 'Réinitialiser',
            validate: 'Valider',
        },
        breadcrum: {
            label_1: 'Clients',
            label_2: 'Base clients',
            label_mod: 'Modifier',
            label_new: 'Nouveau',
        },
    },
    form_model_template_v2: {
        breadcrum: {
            label_1: 'Modèle template',
            label_mod: 'Modifier',
            label_new: 'Ajouter',
        },
        main_information: {
            title_infomation: 'Informations générales',
            title: {
                label: 'Nom du modèle',
                placeholder: 'Nom du modèle',
                required: 'Titre est obligatoire',
            },
        },
        config_header: {
            title: 'Présentez vos offres comme une véritable brochure commerciale',
            description:
                'Créez des devis personnalisés avec une page de garde, des visuels ou contenus marketing, ainsi que vos mentions légales et CGV. Concevez plusieurs modèles adaptés à vos offres, intégrez des options comme la signature électronique et envoyez-les en un clic depuis votre interface de gestion.',
        },
        customize_label: 'Personnalisez chaque page de votre modèle :',
        breadcrumb_edit: 'Modifier un modèle de devis',
        breadcrumb_create: 'Créer un modèle de devis',
        btn_save: 'Enregistrer',
        btn_validate: 'Valider',
    },
    datatable_model_template_edit: {
        actions: {
            modify: {
                title: 'Modifier',
                label: 'Modifier',
            },
            gestion_template: {
                title: 'Template devis',
                label: 'Template devis',
            },
            delete: {
                title: 'Supprimer',
                label: 'Supprimer',
            },
        },
        title: 'Titre',
        action: 'Actions',
    },
    experience: {
        live_preview: 'Prévisualisation en direct',
        add_option: 'Ajouter une option',
        estimated_time: 'Temps total estimé : {time}',
        capacity_label: 'Capacité : {capacity}',
        preview_slots: 'Prévisualisation des créneaux :',
        total_amount: 'Montant total : {price}',
        prix: 'Prix : {price}',
        acompte_to_pay: 'Acompte à régler : {acompte}',
        number_of_tickets: 'Nombre de tickets: {count}',
        rules_selection: 'Règles de sélection : {min} - {max}',
        delay_between_activities: 'Délai entre activités : {delay} min',
        category_selected: 'Catégorie sélectionnée :',
        step: 'Étape',
        titleClosePopup: 'Vos changements seront perdus',
        descriptionClosePopup: 'En quittant cette page, toutes vos modifications seront perdues.',
        btnStay: 'Rester sur la page',
        btnLeave: 'Quitter',
        next: 'Suivant',
        finish: 'Terminer',
        btnSaveAndLeave: 'Enregistrer et quitter',
        backToExperiences: 'Retour aux expériences',
        errorDisponibility: 'Définissez les disponibilités de votre expérience',
        step1: {
            subtitle: 'Informations générales',
            content: "Quel type d'expérience souhaitez-vous créer aujourd'hui ?",
            startUp: 'Démarrer',
            card1: {
                title: 'Expérience',
                description: 'Une activité ou un événement que vos clients peuvent réserver.',
            },
            card2: {
                title: 'Formule<br/>combinée',
                description: 'Un regroupement de plusieurs expériences dans une même formule.',
            },
            card3: {
                title: 'Forfait',
                description:
                    'Un pass donnant accès à vos expériences, avec un nombre d’utilisations et des règles définies à l’avance.',
            },
            card4: {
                title: 'Abonnement',
                description: 'Un pass donnant accès à vos expériences de façon récurrente, avec renouvellement.',
            },
        },
        step2: {
            subtitle: 'Expérience',
            content: 'Créer une expérience',
            labelNom: 'Nom de votre expérience',
            nom: 'Donnez un nom à votre expérience',
            labelInternalName: 'Nom interne',
            internalName: 'Nom interne (usage gestion)',
            labelDescription: 'Description de votre expérience',
            description: 'Décrivez votre expérience',
            labelUpload: 'Illustration de votre expérience',
            importFile1: 'Cliquez pour importer',
            importFile2: 'ou glissez-déposez votre fichier',
            requiredTypeFile: 'JPG, JPEG, PNG, WEBP de moins de 1 Mo.',
            requiredTypeFileDimensions: 'Dimensions recommandées : {dimensions}',
            requiredTypeFileVideo: 'MP4, MOV, WEBM, AVI ou M4V de moins de 5 Mo.',
            errors: {
                imageOnly: 'Seules les images sont acceptées (JPG, JPEG, PNG, WEBP).',
            },
            improveInProgress: 'Amélioration en cours...',
            improveWithAI: "Améliorer avec l'IA",
            defaultText: 'Saisissez votre texte ici',
        },
        step3: {
            subtitle: "Capacité d'accueil",
            content: 'Configurez vos terrains, salles, équipements, qui définieront votre capacité d’accueil.',
            sub_content: 'Exemple : 1 terrain pouvant accueillir 10 personnes, ou 20 gilets de laser game en stock.',
            yourFacilites: 'Vos installations',
            yourEquipment: 'Vos équipements',
            example: 'Exemple',
            activated: 'activé',
            disabled: 'désactivé',
            people: 'personnes',
            stock: 'Stock',
            usedInExperience: 'utilisé dans {count} expérience',
            usedInExperiences: 'utilisé dans {count} expériences',
            name: {
                required: 'Le nom est obligatoire.',
            },
            capacity: {
                required: 'La capacité est obligatoire.',
                error: 'La capacité doit être un nombre positif.',
            },
            popup: {
                add: 'Ajouter {item}',
                edit: 'Modifier {item}',
                installation: 'une installation',
                equipment: 'un équipement',
                titleKarafun: 'Liason Karafun',
                selectKarafun: 'Choisissez un ou plusieurs espaces à lier',
            },
            equipment: {
                title: 'Configurez vos équipements',
                name: "Nom de l'équipement",
                capacity: 'Nombre de stock',
                placeholder: {
                    name: 'Lanceurs, gilets, baudriers, karts, etc.',
                },
                error_fetch: 'Erreur lors du chargement des matériels',
            },
            installation: {
                title: 'Configurez vos installations',
                name: "Nom de l'installation",
                capacity: "Capacité d'accueil",
                mixingGroup: 'Permettre le mixage des groupes',
                karafun: 'Activer la liaison avec Karafun',
                karafunNotConfigured: "L'intégration Karafun n'est pas configurée.",
                karafunGoToIntegration: 'Configurer dans les Intégrations',
                placeholder: {
                    name: 'Terrain, Salle, Parc, Circuit, etc.',
                },
                at_least_one: 'Vous devez sélectionner au moins une installation.',
                error_fetch: 'Erreur lors du chargement des espaces',
            },
            dashedCapacityOptions: {
                title: 'Options avancées',
                option_1: 'Permettre le mixage des groupes entre plusieurs espaces',
                option_2: "Interdire le mixage à partir d'un nombre de personne",
                option_3: 'Afficher le nom des installations au client lors de la réservation',
                option_dynamic_duration: 'Durée dynamique selon le nombre de personnes (bowling)',
                option_same_space: 'Mixer les groupes sur le même espace',
                at_least_one: 'Vous devez sélectionner au moins une option avancée.',
            },
            isOptionCard: {
                title: 'Configuration option',
                isOptionLabel: 'Est-ce que cette activité est une option ?',
                parentActivityLabel: 'Activité parent',
                selectParent: 'Sélectionner une activité parent',
            },
            oneScheduleOnlyOneInstallation:
                'Pour le mode "Un seul horaire pour tous", une seule installation peut être sélectionnée. Les autres ont été désélectionnées.',
            detection: {
                ambiguityHint: 'Plusieurs types possibles - précisez vos choix',
                waitingConfig: 'En attente de configuration...',
                detectedType: 'Type détecté: {typeName}',
                detectedTypeAmbiguous: 'Type détecté: {typeName} (ambiguïté détectée)',
                confidence_label: 'Confiance',
            },
        },
        // Billetterie — étape « Disponibilités » (StepTicketAvailability.vue).
        // Distinct de `step4`, qui reste l'étape Disponibilités d'une expérience classique.
        stepAvailability: {
            subtitle: 'Disponibilités',
            allDay: {
                title: 'Toute la journée',
                description: "Le billet est valable toute la journée, selon les horaires de l'établissement.",
            },
            fixed: {
                title: 'Créneaux fixes',
                description: 'Les créneaux sont générés automatiquement sur vos horaires d’ouverture.',
            },
            custom: {
                title: 'Créneaux personnalisés',
                description: 'Vous définissez chaque plage de validité.',
            },
            defaultBadge: 'Par défaut',
            validityDuration: 'Durée de validité',
            customDuration: 'Personnalisé',
            minutes: 'min',
            fixedHelp: 'Si la durée ne divise pas exactement la plage, le reliquat de fin n’est pas proposé.',
            name: 'Nom',
            bookingRange: 'Plage de réservation',
            addSlot: 'Ajouter un créneau',
            newSlotName: 'Nouveau créneau',
            edit: 'Modifier',
            delete: 'Supprimer',
            nextDay: '(J+1)',
            purgeConfirmTitle: 'Tarifs horaires à retirer',
            purgeConfirm:
                'Cette configuration retire {count} tarif(s) horaire(s) de l’étape « Options de billetterie » qui ne correspondent plus à ces disponibilités. Continuer ?',
            purgedToast: '{count} tarif(s) horaire(s) retiré(s) de l’étape « Options de billetterie ».',
            deleteConfirm: 'Supprimer le créneau « {name} » ? Cette action est définitive.',
            generatedCount: 'soit {count} créneau de {duration} | soit {count} créneaux de {duration}',
            errors: {
                nameRequired: 'Le nom du créneau est requis',
                nameTooLong: 'Le nom ne peut pas dépasser 40 caractères',
                endAfterStart: "L'heure de fin doit être postérieure à l'heure de début",
                endMax: 'Un créneau ne peut pas se terminer après 3h du matin le lendemain',
                rangeMax: 'Une plage de réservation ne peut pas dépasser 24 heures',
                overlap: 'Chevauchement avec « {name} ». Ajustez la plage.',
                rangeTooShort: 'Plage trop courte',
                durationRange: 'La durée doit être comprise entre 5 et 720 minutes',
                modeRequired: 'Choisissez un mode de disponibilité avant d’enregistrer',
                atLeastOneSlot: 'Ajoutez au moins un créneau',
                noFreeSpace: 'Plus d’espace libre dans la journée : ajustez un créneau existant avant d’en ajouter un.',
                invalidCustomSlotElsewhere:
                    'Un créneau personnalisé est invalide ({error}). Corrigez-le dans « Créneaux personnalisés » avant d’enregistrer.',
            },
        },
        step4: {
            subtitle: 'Disponibilités',
            advancedParams: 'Paramètres avancés',
            reservationMode: {
                title: 'Mode de réservation',
                Question: 'Comment les clients vont réserver votre expérience ?',
                ResponseTitle1: 'Plusieurs choix de créneaux dans la journée',
                Description1:
                    'Les clients choisissent parmi différents créneaux proposés dans la journée (ex : escape game, activité sportive).',
                ResponseTitle2: 'Un seul horaire pour tout le monde',
                Description2: 'Les clients réservent pour une date et un horaire précis (ex : spectacle, événement, etc.).',
                ResponseTitle3: 'Accès libre toute la journée',
                Description3: 'Les clients viennent quand ils veulent pendant les horaires d’ouverture (ex : parc, zoo, etc.).',
                Tooltip: 'Cet élément n’est pas modifiable après la création',
                tooltipPublished:
                    'Le mode de réservation ne peut pas être modifié pour une expérience publiée. Créez un brouillon pour effectuer des modifications.',
            },
            interval: {
                Question: "Quelle est l'intervalle de réservation ?",
                inputLabel: 'Intervalle',
                option1: 'Toutes les 15 minutes',
                option2: 'Toutes les 30 minutes',
                option3: 'Toutes les heures minutes',
            },
            duration: {
                Question: "Quelle est la durée de l'expérience ?",
                inputLabel: 'Durée',
                option1: '1 heure',
                option2: '1h30',
                option3: '2 heures',
            },
            add_start_time: {
                Question: 'Intervalle entre activités (en minutes)',
            },
            cleaning_time: {
                Question: 'Temps de rangement/nettoyage additionnel (en minutes)',
            },
            optionDuration: {
                title: 'Options de durée',
                Question: 'Option de durée',
                optionPrefix: 'Option',
                optionNameLabel: "Nom de l'option",
                durationLabel: 'Durée',
                customLabel: 'Personnalisée',
                addButton: 'Ajouter une option de durée',
                emptyHint: 'Aucune option de durée ajoutée.',
                option1: '2 heures',
                option2: '2h30',
                option3: '3 heures',
                confirmDelete: 'Supprimer la durée ?',
                confirmDeleteText: 'Êtes-vous sûr de vouloir supprimer ce bloc de durée ?',
            },
            specificMode: {
                disponibilityTitle: 'Définissez les disponibilités de votre expérience',
                emptyDisponibility: 'Aucune disponibilité n’a encore été ajoutée.',
                addDisponibility: 'Ajouter une disponibilité',
                popupTitleSection: 'Sélectionnez vos dates et horaires',
                editDisponibility: 'Modifier la disponibilité',
                specificDays: 'Jours spécifiques',
                saisieMode: 'Saisie',
                calendarMode: 'Calendrier',
                calendar: {
                    recurring: 'Récurrence',
                    confirmCheckbox: "Appliquer cette configuration à d'autres dates",
                    typeRecurrence: {
                        once: 'Une seule fois',
                        weekly: 'Toutes les semaines le {day}',
                        monthly: 'Tous les mois le premier {day}',
                        yearly: 'Tous les ans le {day} {month}',
                        weekdays: 'Tous les jours de la semaine (lun–ven)',
                        custom: 'Personnalisée',
                        card: {
                            title: 'Récurrence personnalisée',
                            label: 'Répéter tou(te)s les ',
                            labelDay: 'Répéter le ',
                            labelEnd: 'Se termine',
                            checkNever: 'Jamais',
                            checkLe: 'Le',
                        },
                    },
                },
            },
            multiMode: {
                schedule: {
                    btnEdit: 'Modifier les horaires',
                    titlePopup: 'Personnalisez les horaires pour cette expérience',
                    configSchedule: 'Configurer des horaires personnalisées',
                    legend: 'Ajustez les créneaux d’ouverture pour chaque jour de la semaine.',
                    addSlot: 'Ajouter un créneau',
                    removeSlot: 'Supprimer le créneau',
                    applyToAll: 'Appliquer à tous les jours',
                    applied: 'Appliqué',
                    copyToSelected: 'Copier vers certains jours seulement',
                    copyTo: 'Copier vers',
                    apply: 'Appliquer',
                    pause: 'Pause',
                    pauseUnavailable: 'Pause indisponible',
                    pauseUnavailableHint:
                        "Le système ne gère qu'une seule pause par journée : la nuit du jour précédent l'occupe déjà.",
                    nightFrom: 'Nuit du',
                    attachedToDay: 'rattaché à ce jour',
                    nightUntil: 'Nuit jusqu’à',
                    error: {
                        invalidTime: 'Heure invalide',
                        startTooLate: 'Le début doit être avant 24:00.',
                        endTooLate: 'La fin ne peut pas dépasser 05:00 (lendemain).',
                        slotTooShort: 'Un créneau doit durer au moins 30 minutes.',
                        pauseTooShort: 'La pause doit durer au moins 30 minutes.',
                        pauseTooLate: 'La pause doit se terminer avant 24:00.',
                    },
                },
            },
            custom_duration: {
                title: 'Personnalisée',
            },
            specifityHoraire: {
                Question: 'Voulez-vous configurer des horaires personnalisés ?',
                ResponseTitle1: 'Oui, définir des horaires personnalisés',
                Description1:
                    "Les horaires de cette expérience sont différents des horaires d'ouvertures de votre établissement.",
                ResponseTitle2: "Non, utiliser les horaires d'ouvertures de l'établissement",
                Description2: "Cette expérience suivra les horaires d'ouverture de votre établissmeent. Modifier les horaires",
            },
            reservationPeriods: {
                title: 'Personnaliser les créneaux affichés à la réservation',
                dayPreview: 'APERÇU DE LA JOURNÉE',
                noPeriods: 'Aucune plage définie, tous les créneaux sont affichés.',
                startTime: 'Heure de début',
                endTime: 'Heure de fin',
                active: 'Activé',
                add: 'Ajouter une plage horaire',
                addSuccess: 'La période a été ajoutée avec succès.',
                deleteSuccess: 'La période a été supprimée avec succès.',
                validationError: "L'heure de fin doit être postérieure à l'heure de début.",
                conflict: 'Cette période chevauche une période existante.',
                errorFetch: 'Erreur lors du chargement des périodes.',
                errorAdd: "Erreur lors de l'ajout de la période.",
                errorUpdate: 'Erreur lors de la mise à jour de la période.',
                errorDelete: 'Erreur lors de la suppression de la période.',
                addPeriodButton: 'Ajouter un créneau horaire',
            },
            sharedSpaceWarning: {
                bannerMessage:
                    "Cet espace est partagé avec d'autres expériences. Cette modification peut impacter leur planning.",
                modalTitle: 'Espace partagé détecté',
                modalMessage: "Cet espace est partagé avec d'autres expériences. Cette modification va impacter leur planning.",
                affectedExperiences: 'Expériences impactées :',
                confirmButton: 'Continuer quand même',
                cancelButton: 'Annuler',
            },
        },
        // Paliers « nb de personnes -> durée + prix ». Partagés par l'étape Disponibilités
        // (durée seule) et l'étape Tarification (durée + prix) : mêmes libellés des deux côtés.
        tiers: {
            configureLink: 'Configurer des durées par nombre de personnes',
            hideLink: 'Masquer les durées par nombre de personnes',
            configurePricingLink: 'Configurer des tarifs dégressifs',
            blockingError: "Corrigez les paliers en erreur avant d'enregistrer.",
            durationRequired: 'La durée est obligatoire.',
            durationInvalid: 'La durée doit être un nombre de minutes supérieur à 0.',
            palier: 'Palier',
            persons: 'Nbr. de pers.',
            duration: 'Durée',
            durationUnit: 'min',
            price: 'Prix',
            // Libellés explicites par mode tarifaire (étape Tarification) — la ligne DÉFAUT est
            // toujours « Prix / pers. » (hors liste des paliers, prix d'option × effectif) ;
            // seuls les paliers portent le total tout compris du groupe en mode « par groupe ».
            pricePerPerson: 'Prix / pers.',
            priceGroup: 'Prix groupe',
            add: 'Ajouter un palier',
            duplicatePersons: 'Un palier existe déjà pour {persons} personnes (palier {palier})',
            fallbackHint:
                "Un effectif sans palier reprend le palier juste en dessous ; hors de la liste des paliers (sous le premier ou au-delà du dernier), c'est la durée de l'option et son prix par personne qui s'appliquent.",
        },
        step5: {
            subtitle: 'Tarification',
            tva: {
                Question: 'Quel est le taux de TVA pour cette expérience ?',
            },
            price: {
                Question: 'Quel est le prix pour cette expérience ?',
                priceTTc: 'Prix',
            },
            reservationMode: {
                title: 'Comment voulez-vous fixer le prix de cette expérience ?',
                nbrParticipant: 'Nombre de participants',
                nbrParticipantShort: 'Nbr. de pers.',
            },
            tarif_mode: {
                person: {
                    label: 'Prix par personne',
                    subtitle: 'Le tarif est calculé en fonction du nombre de participants',
                },
                group: {
                    label: 'Prix par groupe',
                    subtitle: 'Un tarif fixe pour tout le groupe, quel que soit le nombre de participants',
                },
            },
            labelPricingMode: 'Mode de tarification',
            labelPrice: 'Prix',
            priceOptionalHint: 'Le prix est optionnel pour les tickets simples sans option',
            labelMinTickets: 'Nombre minimum de tickets',
            labelMaxTickets: 'Nombre maximum de tickets',
            unlimitedPlaceholder: '-1 pour illimité',
            isOptionLabel: "Est une option d'une autre expérience",
            labelParentExperience: 'Expérience parente',
            parentExperiencePlaceholder: "ID de l'expérience parente",
            pricingModeLockedByCircuit:
                "Le mode de tarification est défini automatiquement selon le type d'expérience ({circuit})",
            pricingModeLockedByBowling: 'Le bowling (durée dynamique) est toujours tarifé par groupe.',
            specificPricingUniformPriceOnly:
                'Cette option est disponible uniquement lorsque le prix par personne est identique sur tous les paliers.',
            pricingModeTooltipPublished:
                'Le mode de tarification ne peut pas être modifié pour une expérience publiée. Créez un brouillon pour effectuer des modifications.',
            many_options: {
                no: {
                    label: 'Non',
                    subtitle: 'Un seul tarif pour cette expérience',
                },
                yes: {
                    label: 'Oui',
                    subtitle: 'Plusieurs tarifs en fonction de la durée ou du nombre de personnes',
                },
            },
            multiMode: {
                title: 'Proposez-vous plusieurs options ?',
                schedule: {
                    configSchedule: 'Configurer des options et tarifs dégressifs',
                    configTarif: 'Configurer des tarifs spécifiques par jour et heure',
                    accompte: 'Demander un acompte',
                },
            },
            planningCalendar: {
                title: 'Planification des prix',
            },
            specificMode: {
                title: 'Tarifs spécifiques',
                emptyTarif: 'Aucun tarif spécifique n’a encore été ajouté.',
                addTarif: 'Ajouter un tarif spécifique',
                dates: 'Dates',
                tarif: 'Tarif',
                titlePopup: 'Configurer un tarif spécifique',
                popupTitleSection: 'Sélection des dates',
                applicableDays: 'Jours applicables',
            },
            demandeAcompte: {
                titleSelect: 'Type d’acompte',
                optionPercent: 'Pourcentage (%)',
                optionAmount: 'Montant ({symbol})',
                amountAcompte: 'Montant d’acompte',
                percentAcompte: 'Pourcentage d’acompte',
            },
            errors: {
                requiredPricingMode: 'Veuillez sélectionner un mode de tarification',
                minTicketOne: "Le nombre minimum de tickets doit être d'au moins 1",
                minGreaterThanMax: 'Le minimum ne peut pas être supérieur au maximum',
                maxLessThanMin: 'Le maximum ne peut pas être inférieur au minimum',
                duplicateTarif: 'Ce tarif existe déjà pour ces dates et ces horaires.',
            },
        },
        stepTicketOptions: {
            subtitle: 'Options de billetterie',
            createVariants: 'Créez des variantes pour ce billet',
            variantName: 'Nom',
            variantNamePlaceholder: 'Variante',
            price: 'Prix',
            tva: 'TVA',
            degressifLabel: 'Prix dégressifs',
            palierLabel: 'Palier',
            nbTickets: 'Nb. de billets',
            addPalier: 'Ajouter un palier',
            addVariant: 'Ajouter une variante',
            undatedLabel: 'Proposer cette variante en billet non daté',
            configModalTitle: 'Configuration variante',
            billetterieOptions: 'Options de billetterie',
            variantInfo: 'Informations de la variante',
            degressifTitle: 'Tarifs dégressifs',
            degressifSubtitle: 'Faites diminuer le prix unitaire selon des paliers.',
            specificPricingTitle: 'Prix spécifiques par jour / heure',
            specificPricingSubtitle: 'Faites varier vos tarifs pour des heures/jours spécifiques.',
            advancedOptions: 'Options avancées de billetterie',
            variantsTitle: 'VARIANTES',
            copy: 'Copier',
            delete: 'Supprimer',
            startingFrom: 'À partir de',
            unitPrice: 'Prix unitaire',
            tickets: 'billets',
            uniquePrice: 'Prix unique',
            sansNom: 'Sans nom',
            rulesCount: '{count} règle | {count} règles',
            configureSelectedDates: 'Configurer les dates sélectionnées',
            reduction: 'réduction',
            fromPrice: 'À partir de',
            // Forme des tarifs spécifiques selon le mode de l'étape « Disponibilités »
            duplicateTarifsIgnored:
                '{count} tarif(s) en double ignoré(s) (mêmes dates, mêmes horaires) : seul le tarif facturé est conservé, le doublon sera retiré à l’enregistrement.',
            pricingMode: {
                allDay: 'Un tarif par jour — mode « Toute la journée » (étape Disponibilités)',
                fixed: 'Tarifs par plage horaire — créneaux fixes de {duration} min (étape Disponibilités)',
                custom: 'Un tarif par créneau de l’étape Disponibilités',
                legacy: 'Tarifs par plage horaire — billet sans mode de disponibilité enregistré',
            },
            errors: {
                variantNameRequired: 'Le nom de la variante est requis',
                variantPriceRequired: 'Le prix est requis',
                palierNbRequired: 'Le nombre de billets est requis',
                palierPriceRequired: 'Le prix du palier est requis',
            },
        },
        step6: {
            subtitle: 'Ventes additionnelles',
            pro_banner_text: 'Cette fonctionnalité est réservée aux abonnements {type}',
            passer_pro: 'Passer à {type}',
            labelUpload: 'Image',
            labelNom: 'Nom du produit',
            nom: 'Nom',
            labelDescription: 'Description courte',
            description: 'Description',
            labelPrice: 'Prix',
            labelTva: 'TVA',
            switch1: 'Adapter par défaut la quantité au nombre de participant',
            switch2: 'Limiter à 1 exemplaire',
            switch3: 'Rendre obligatoire',
            popup: {
                title: 'Ajouter un produit',
            },
        },
        step7: {
            subtitle: 'Options',
            specificMode: {
                disponibilityTitle: 'Informations pratiques',
                emptyDisponibility: 'Aucune information n’a encore été ajoutée.',
                addDisponibility: 'Ajouter une information',
                popupTitle: 'Configurer vos consignes et questions fréquentes',
                popupTitleSection: 'Information pratique',
                confirmDelete: "Supprimer l'information ?",
                confirmDeleteText: 'Êtes-vous sûr de vouloir supprimer cette information pratique ?',
                editInfo: 'Modifier une information',
                addInfo: 'Ajouter une information',
            },
            putOnline: {
                title: 'Mise en ligne',
                description: 'Rendre cette expérience visible aux clients',
                visibilityPosLabel: 'Rendre cette expérience visible sur le POS',
            },
            displayOptions: {
                title: "Options d'affichage",
                showAvailableSpots: 'Afficher le nombre de places disponibles',
                showDifficultyLevel: 'Afficher le niveau de difficulté',
                showBookEntierSpace: "Afficher le choix de réservation de l'espace entier",
            },
            stock_management: {
                title: 'Gestion de stock',
                switch_label: 'Activer la gestion de stock',
                description:
                    'Le stock de chaque produit sera décrémenté automatiquement lors de chaque réservation, selon la quantité et la règle choisie.',
                products_consumed: 'Produits consommés',
                column_product: 'Produit',
                column_quantity: 'Qté.',
                rule_per_reservation: 'Par réservation',
                rule_per_person: 'Par personne',
            },
            ticketingOptions: {
                title: 'Options de billetterie',
                description_switch_1: 'Proposer cette expérience en billet non-daté',
                description_switch_2: 'Joindre un fichier à l’e-mail de confirmation',
                labelUpload: 'Joindre un fichier à l’email de confirmation',
                requiredTypeFile: 'JPG, JPEG, PNG, WEBP ou PDF moins de 5 Mo.',
                selectBtn: 'Tout sélectionner',
                deselectBtn: 'Tout déselectionner',
                viewPdf: 'Voir le fichier PDF',
            },
            labels: {
                required: 'Obligatoire',
                options: 'Options',
                option: 'Option',
                optionnel: 'Optionnel',
            },
            labelNom: 'Intitulé',
            nom: 'Titre',
            labelDescription: 'Information',
            description: 'Taper votre information',
            tickets_possibles: {
                title: 'Définir une capacité spécifique à l’expérience',
                label: 'Tickets possibles',
                min: 'Nombre de personnes min.',
                max: 'Nombre de personnes max.',
                player: 'Joueur',
            },
            questionCustomer: {
                title: 'Questions clients',
                emptyQuestion: 'Aucune question n’a encore été ajoutée',
                addQuestion: 'Ajouter une question',
                titlePopupQuestion: 'Questions destinées au client',
                labelNom: 'Question',
                type_reponse: 'Type de réponse',
                confirmDelete: 'Supprimer la question ?',
                confirmDeleteText: 'Êtes-vous sûr de vouloir supprimer cette question ?',
                question: 'Question',
            },
            question_types: {
                text: 'Texte court',
                textarea: 'Texte long',
                select: 'Liste déroulante',
                checkbox: 'Cases à cocher',
                multiple: 'Sélection multiple',
                radio: 'Choix unique',
            },
        },
        errors: {
            requiredName: 'Le nom est requis',
            requiredDuration: 'La durée est requis',
            requiredPrice: 'Le prix est requis',
            positivePrice: 'Le prix doit être supérieure à 0',
            requiredNbrParticipant: 'Le nombre de participants est requis.',
            required: 'Ce champs est requis.',
            requiredPricingMode: 'Veuillez sélectionner un mode de tarification',
            invalidNumber: 'Format invalide',
            requiredAcompteType: 'Le type d’acompte est obligatoire.',
            requiredAmount: 'La valeur d’acompte doit être supérieure ou égale à 0.',
            amountRange: "Le montant de l'acompte doit être inférieur au prix de la prestation.",
            percentageRange: 'Le pourcentage doit être entre 0 et 100.',
            incompatibleDateEnd: 'La date de fin doit être supérieure ou égale à la date de début',
            incompatibleTimeEnd: "L'heure de fin doit être postérieure à l'heure de début",
            incompatibleNbreMinMax: 'Le nombre minimum de tickets ne peut pas être supérieur au nombre maximum de tickets',
            overlapDisponibility: 'Une disponibilité existe déjà sur cette plage horaire.',
            save: "Erreur lors de l'enregistrement",
            selectInterval: 'Veuillez sélectionner un intervalle',
            selectDuration: "Veuillez sélectionner une durée d'expérience",
            productExists: 'Le produit "{productName}" existe déjà',
        },
        success: {
            title: 'Bravo, votre expérience est prête !',
            url: 'Obtenez votre 1ère réservation en la partageant sur vos réseaux !',
        },
        timeSpecific: {
            priceTTCPerPerson: 'Prix TTC par personne',
            timeType: "Type d'heure",
            allowMixing: 'Autoriser le mixage',
            activatePause: 'Activer la pause',
            forbidMixing: 'Interdire le mixage',
            allowMixingOption: 'Autoriser le mixage',
            peakHour: 'Heure pleine',
            offPeakHour: 'Heure creuse',
            days: {
                mon: 'L',
                tue: 'M',
                wed: 'M',
                thu: 'J',
                fri: 'V',
                sat: 'S',
                sun: 'D',
            },
        },
        planningModal: {
            title: 'Planning des dates sélectionnées',
            configureBtn: 'Configurer les dates sélectionnées',
            dateStart: 'Date de début',
            dateEnd: 'Date de fin',
            dayRepetition: 'Répétition par jours',
            creneau: 'Créneau',
            peakHour: 'Heure Pleine',
            offPeakHour: 'Heure Creuse',
            forbidMixing: 'Interdire le mixage',
            allowMixing: 'Autoriser le mixage',
            startTime: 'Heure de début',
            endTime: 'Heure de fin',
            vatRate: 'Taux de TVA',
            sellingPrice: 'Prix de vente',
            errorRequired: 'Veuillez remplir tous les champs obligatoires de chaque créneau.',
            errorTimeRange: "L'heure de fin doit être après l'heure de début.",
            conflictError: 'Des conflits existent entre les plages horaires.',
            duplicateError: 'Un tarif existe déjà pour ces dates et ce créneau horaire. Modifiez la date ou l’horaire.',
            errorEndDateRequired: 'Veuillez renseigner une date de fin lorsque des jours spécifiques sont sélectionnés.',
            addCreneau: 'Ajouter un créneau',
            allDayHint:
                'En mode « Toute la journée », le billet est vendu en un seul créneau par jour : un seul tarif par jour. Pour vendre plusieurs plages à des tarifs différents (matin, soir…), choisissez « Créneaux personnalisés » à l’étape Disponibilités.',
            fixedHint: 'Un tarif s’applique à chaque créneau de {duration} min qui commence dans sa plage horaire.',
            legacyHint:
                'Un tarif s’applique à chaque créneau qui commence dans sa plage horaire. Pour choisir les créneaux vendus, configurez l’étape Disponibilités.',
            nextDayHint:
                'Un créneau qui se termine le lendemain est tarifé jusqu’à 23:59 ; ses sous-créneaux après minuit restent au prix de base.',
            nextDaySuffix: '(J+1)',
            basePricePlaceholder: 'Prix de base',
            errorResetCoveredDay:
                'Ce jour est couvert par une plage tarifaire : saisissez le prix de base pour l’écraser, ou modifiez la plage.',
            deleteCreneau: 'Supprimer ce créneau',
            cannotEditTime:
                'Vous ne pouvez apporter aucune modification à la planification car cet événement a déjà des réservations',
            selectDateRange: 'Sélectionnez une date ou une période',
            ranges: {
                today: "Aujourd'hui",
                next7days: '+ 7 jours',
                next15days: '+ 15 jours',
                next30days: '+ 30 jours',
                thisMonth: 'Ce mois-ci',
                nextMonth: 'Le mois prochain',
                nextYear: "L'année prochaine",
            },
            reprogramTitle: 'Souhaitez-vous vraiment reprogrammer cet événement pour la date du {date}',
            periodUpdateSuccess: 'La période a été mise à jour avec succès.',
            periodAddSuccess: 'La période a été ajoutée avec succès.',
            requiredField: 'Ce champ est obligatoire',
        },
        saved: 'Expérience mise à jour',
    },
    tag: {
        loading: 'Chargement...',
        titleUpdateTag: 'Modifier la catégorie',
        titleTag: 'Créer une catégorie',
        nameLabel: 'Nom',
        namePlaceholder: 'Entrez le nom',
        parentLabel: 'Catégorie parente',
        parentPlaceholder: 'Sélectionnez une catégorie',
        descriptionLabel: 'Description',
        descriptionPlaceholder: 'Entrez une description',
        generalDescriptionLabel: 'Description générale',
        generalDescriptionPlaceholder: 'Entrez une description générale',
        activitiesAndCombosTitle: 'Activités & Combos',
        activitiesLabel: 'Choisir des activités',
        combosLabel: 'Choisir des combos',
        faqTitle: 'FAQ',
        faqEditTitle: 'Modifier FAQ',
        faqAddTitle: 'Ajouter FAQ',
        faqQuestionLabel: 'Question',
        faqQuestionPlaceholder: 'Entrez la question',
        faqAnswerLabel: 'Réponse',
        faqAnswerPlaceholder: 'Entrez la réponse',
        faqQuestionRequired: 'La question est requise',
        faqAnswerRequired: 'La réponse est requise',
        nameRequired: 'Le nom est requis',
        successMessage: 'Opération réussie',
        errorMessage: 'Une erreur est survenue',
        illustrationLabel: 'Illustration',
        chooseImage: 'Choisissez une image',
        visibilityLabel: 'Visible sur le site',
        activeLabel: 'Activé',
        updatedStatus: 'Catégorie mise à jour',
        viewOnSite: 'Voir sur le site',
        deleteSuccess: 'Supprimé avec succès',
        experiencesCount: "Nombre d'expériences",
        combosCount: 'Nombre de combos',
        selectItemNone: 'Aucun',
        deletePopupConfirm: 'supprimer',
    },
    widgetIntegration: {
        widgets: {
            listing: {
                title: 'Listing activités',
                description:
                    "Ce widget permet d'afficher la liste de vos produits/activités, de la réservation à la finalisation du paiement.",
            },
            activite: {
                title: 'Expériences',
                description: 'Vos expériences réservables.',
            },
            formules: {
                title: 'Formules combinées',
                description: 'Plusieurs expériences en une formule.',
            },
            bonCadeau: {
                title: 'Bons cadeaux',
                description: "La page d'achat de bons cadeaux.",
            },
            evenements: {
                title: 'Événements',
                description: 'Vos soirées et événements.',
            },
            forfaits: {
                title: 'Forfaits',
                description: 'Packs prépayés, pass et crédits.',
            },
            abonnements: {
                title: 'Abonnements',
                description: 'Vos abonnements récurrents.',
            },
            billetsNonDates: {
                title: 'Billets non datés',
                description: 'Vos expériences vendues en billet non daté.',
            },
            categorie: {
                title: 'Par catégorie',
                description: "Les expériences d'une catégorie.",
            },
            panier: {
                title: 'Panier',
                description: 'Le panier et le paiement.',
            },
            profile: {
                title: 'Espace client',
                description: 'Connexion, informations et réservations du client.',
            },
            devis: {
                title: 'Demande de devis',
                description: 'Les formulaires de devis sur-mesure.',
            },
            restaurant: {
                title: 'Menu restaurant',
                description: 'Votre carte et la commande en ligne.',
            },
        },
        stepHeaders: {
            integration: {
                title: 'Intégration widgets',
                description:
                    "Les widgets vous permettent d'intégrer nos modules de réservation et bon cadeau directement sur votre propre site Internet.",
            },
            activitySelection: {
                title: "Sélection d'expérience",
                description: "Choisissez l'expérience que vous souhaitez intégrer dans votre widget.",
            },
            activityPage: {
                title: 'Page de réservation',
                description:
                    "Cette page affiche le module de réservation (calendrier, disponibilités), une description, illustration et permet donc la réservation jusqu'à la finalisation du paiement.",
            },
        },
        headers: {
            activite: {
                title: 'Expériences',
                description: "Affiche vos expériences réservables — du choix de l'activité au paiement.",
            },
            restaurant: {
                title: 'Menu restaurant',
                description: "Votre carte de restauration et la commande en ligne, en complément d'une réservation.",
            },
            'bon-cadeau': {
                title: 'Bons cadeaux',
                description: "La page d'achat de vos bons cadeaux : montant, personnalisation et paiement.",
            },
            panier: {
                title: 'Panier',
                description: 'Le panier et le tunnel de paiement complet de vos visiteurs.',
            },
            evenements: {
                title: 'Événements',
                description: 'Vos soirées et événements ponctuels, avec billetterie en ligne.',
            },
            formules: {
                title: 'Formules combinées',
                description: 'Plusieurs expériences regroupées et vendues ensemble à un tarif avantageux.',
            },
            abonnements: {
                title: 'Abonnements',
                description: 'Vos abonnements récurrents et leurs avantages membres.',
            },
            'billets-non-dates': {
                title: 'Billets non datés',
                description: 'Toutes vos expériences proposées en billet non daté, à consommer plus tard.',
            },
            devis: {
                title: 'Demande de devis',
                description:
                    'Vos formulaires de demande de devis : privatisation, anniversaires, entreprises et événements sur-mesure.',
            },
            categorie: {
                title: 'Par catégorie',
                description: 'Affiche toutes les expériences associées à une catégorie (anniversaire, team building...).',
            },
            forfaits: {
                title: 'Forfaits',
                description: "Vos forfaits prépayés : packs d'entrées, pass et crédits à consommer.",
            },
            profile: {
                title: 'Espace client',
                description: "L'espace client avec connexion : informations personnelles et gestion des réservations.",
            },
            default: {
                title: 'Intégration widgets',
                description: 'Choisissez le module à intégrer sur votre site, puis générez le code à copier.',
            },
        },
        stepConfigs: {
            modifyExperience: 'Modifier cette expérience',
            createExperience: 'Créer une nouvelle expérience',
            modifyFormule: 'Modifier cette formule',
            createFormule: 'Créer une nouvelle formule combinée',
            modifyAbonnement: 'Modifier cet abonnement',
            createAbonnement: 'Créer un nouvel abonnement',
            modifyForfait: 'Modifier ce forfait',
            createForfait: 'Créer un nouveau forfait',
            modifyDevis: 'Modifier ce modèle de devis',
            createDevis: 'Créer un nouveau modèle de devis',
            selectCategory: 'Sélectionner une catégorie',
            noConfigNeeded: 'Ce module ne nécessite aucun réglage. Il est prêt à être intégré.',
        },
        selectActivity: 'Sélectionner une expérience',
        chooseActivity: 'Choisissez une expérience...',
        needChange: "Besoin d'effectuer un changement ?",
        modifyActivity: 'Modifier cette expérience',
        createNewActivity: 'Créer une nouvelle expérience',
        modifyCombo: 'Modifier ce combo',
        createNewCombo: 'Créer un nouveau combo',
        categories: {
            mostUsed: 'LES PLUS UTILISÉS',
            offres: 'OFFRES',
            ventes: 'VENTES',
            restaurant: 'RESTAURANT',
        },
        back: 'Retour',
        generateCode: 'Générer le code',
        next: 'Suivant',
        preview: 'Prévisualisation',
        loading: 'Chargement...',
        activityNotAccessible: 'Expérience non accessible',
        activityNotFound: 'Activité non trouvée',
        activityError: "Erreur lors de la vérification de l'expérience",
        completeConfiguration: "Veuillez d'abord compléter la configuration.",
        widgetTitle: 'Widget de réservation Playpro',
        live: 'En direct',
        backToWidgets: 'Retour aux widgets',
        fullListInfo: 'La liste complète sera affichée — aucun élément à sélectionner.',
        noSelection: 'Que voulez-vous afficher ?',
        modify: 'Modifier',
        create: 'Créer',
        defaultPreviewTitle: 'Choisissez un module à intégrer',
        defaultPreviewDescription: "Son aperçu en live s'affichera ici, tel que vos clients le verront.",
        statusPublished: 'Publiée',
    },
    codeModal: {
        installCodeOnSite: 'Installez ce code sur votre site',
        widgetCode: 'Code du widget',
        copyCode: 'Copier le code',
        copied: 'Copié ! ✅',
        copyError: 'Erreur lors de la copie',
        close: 'Fermer',
        integrationCode: "Code d'intégration",
        infoBanner: "Copiez ce code et collez-le sur votre site, à l'endroit exact où le module doit apparaître.",
        codeToPaste: 'Code à coller',
        cookieManagement: 'Gestion des cookies',
        withoutCookieBanner: 'Sans bannière cookies',
        withCookieBanner: 'Avec ma bannière cookies',
        cookieConsentHint: 'Le widget respecte les choix de votre bandeau cookies (CMP) avant de se charger.',
        noCookieConsentHint: 'Le plus simple. Le widget se charge directement, sans attendre de consentement.',
        whatToDisplay: 'Que voulez-vous afficher',
        allList: 'Toute la liste',
        oneInParticular: 'Une en particulier',
        title: "Code d'intégration",
    },
    experiences: {
        filters: {
            filterByType: 'Filtrer par type',
            all: 'Tous',
            experience: 'Expérience',
            pack: 'Formule combinée',
            forfait: 'Forfait',
            abonnement: 'Abonnement',
            filterByTag: 'Filtrer par catégorie',
        },
        actions: {
            export: 'Exporter',
            create: 'Créer',
            edit: 'Modifier',
            duplicate: 'Dupliquer',
            delete: 'Supprimer',
            deleteSelection: 'Supprimer la sélection',
            backToCategories: 'Retour aux catégories',
            viewSubcategories: 'Voir les sous-catégories',
            preview: 'Aperçu',
        },
        navigation: {
            experiences: 'Expériences',
            installations: 'Installations',
            equipements: 'Équipements',
            categories: 'Catégories',
        },
        table: {
            name: 'Nom',
            status: 'Statut',
            imageTag: 'Image',
            type: 'Type',
            state: 'État',
            actions: 'Actions',
            color: 'Couleur',
            category: 'Catégorie',
            subcategory: 'Sous-catégorie',
            tag: 'Catégorie',
            noTag: 'Aucune',
            duplicationSuccess: 'Duplication effectuée avec succès',
            lastModified: 'Modifié le',
            orderUpdated: 'Ordre mis à jour avec succès',
            orderUpdateFailed: "Erreur lors de la mise à jour de l'ordre",
        },
        status: {
            published: 'Publiée',
            draft: 'Brouillon',
        },
        export: {
            csv: 'Format CSV',
            pdf: 'Format PDF',
        },
        selection: {
            itemsSelected: '{count} élément sélectionné | {count} éléments sélectionnés',
        },
        deletePopup: {
            title: 'Confirmer la suppression',
            message: 'Êtes-vous sûr de vouloir supprimer cette catégorie ? Les sous-catégories seront supprimées également.',
            cancel: 'Annuler',
            confirm: 'Supprimer',
        },
        createPopup: {
            title: 'Créer une catégorie',
            titleUpdate: 'Modifier la catégorie',
            nameLabel: 'Nom',
            namePlaceholder: 'Entrez le nom',
            slugLabel: 'Slug',
            slugPlaceholder: 'slug-de-la-categorie',
            slugPlaceholderSub: 'slug-de-la-sous-categorie',
            colorLabel: 'Couleur',
            illustrationLabel: 'Illustration',
            chooseImage: 'Choisir une image',
            validate: 'Valider',
            titleSub: 'Créer une sous-catégorie',
            titleUpdateSub: 'Modifier la sous-catégorie',
            categoryLabel: 'Catégorie',
            selectCategory: 'Sélectionner une catégorie',
            nameRequired: 'Le nom est requis',
            categoryRequired: 'La catégorie est requise',
            createSuccess: 'Créé avec succès',
            updateSuccess: 'Modifié avec succès',
            errorOccurred: 'Une erreur est survenue',
        },
    },
    products: {
        stats: {
            products: 'Produits',
            categories: 'Catégories',
            suppliers: 'Fournisseurs',
            brands: 'Marques',
        },
        actions: {
            export: 'Exporter',
            add: 'Ajouter',
            edit: 'Modifier',
            duplicate: 'Dupliquer',
            delete: 'Supprimer',
            deleteSelection: 'Supprimer la sélection',
            filter: 'Filtrer',
        },
        filters: {
            title: 'Filtres avancés',
            categories: 'Catégories',
            selectCategories: 'Sélectionner des catégories',
            subcategories: 'Sous-catégories',
            selectSubcategories: 'Sélectionner des sous-catégories',
            brands: 'Marques',
            selectBrands: 'Sélectionner des marques',
            suppliers: 'Fournisseurs',
            selectSuppliers: 'Sélectionner des fournisseurs',
            tags: 'Tags',
            selectTags: 'Sélectionner des tags',
            priceRange: 'Fourchette de prix',
            minPrice: 'Min',
            maxPrice: 'Max',
            inventory: 'Inventaire',
            selectInventory: 'Sélectionner un statut',
            inventoryAlert: 'Stock en alerte',
            inventoryOut: 'Rupture de stock',
            inventoryOrdering: 'En commande',
            status: 'Statut (Actif)',
            selectStatus: 'Sélectionner un statut',
            visibleOnline: 'Visibilité en ligne',
            selectVisibility: 'Sélectionner la visibilité',
            isCabin: 'Mode cabine uniquement',
            reset: 'Réinitialiser',
            apply: 'Appliquer',
        },
        table: {
            name: 'Nom',
            status: 'Statut',
            brand: 'Marque',
            category: 'Catégorie',
            price: 'Prix',
            stock: 'Stock',
            visible: 'État',
            actions: 'Actions',
            duplicationSuccess: 'Produit dupliqué avec succès',
        },
        status: {
            active: 'Actif',
            inactive: 'Inactif',
            visible: 'Visible en ligne',
            hidden: 'Masqué',
        },
        export: {
            csv: 'Format CSV',
            xls: 'Format Excel',
        },
        deletePopup: {
            title: 'Confirmer la suppression',
            message: 'Voulez-vous vraiment supprimer la sélection ?',
            cancel: 'Annuler',
            confirm: 'Supprimer',
        },
    },
    equipements: {
        filters: {
            filterByType: 'Filtrer par type',
            all: 'Tous',
            materiel: 'Matériel',
            installation: 'Installation',
        },
        actions: {
            export: 'Exporter',
            create: 'Créer (bientôt)',
            create_original: 'Créer',
            edit: 'Modifier',
            duplicate: 'Dupliquer',
            delete: 'Supprimer',
            deleteSelection: 'Supprimer la sélection',
        },
        table: {
            name: 'Nom',
            used_by: 'Utilisé par',
            experience_singular: 'expérience',
            experiences_plural: 'expériences',
            status: 'Statut',
            type: 'Type',
            capacity: 'Capacité',
            actions: 'Actions',
        },
        status: {
            active: 'Actif',
            inactive: 'Inactif',
        },
        types: {
            salle: 'Salle',
            materiel: 'Matériel',
            equipement: 'Équipement',
        },
        export: {
            csv: 'Format CSV',
            xls: 'Format XLS',
        },
        selection: {
            itemsSelected: '{count} élément sélectionné | {count} éléments sélectionnés',
        },
        deletePopup: {
            title: 'Confirmer la suppression',
            message: 'Voulez-vous vraiment supprimer la sélection ?',
            messageMultiple: 'Voulez-vous vraiment supprimer ces sélections ?',
            deleteWarning:
                'Attention : Cet élément est lié à {count} expérience(s). La suppression pourrait impacter ces prestations.',
            deleteWarningMultiple:
                'Attention : Ces éléments sont liés à {count} expérience(s). La suppression pourrait impacter ces prestations.',
            deleteSuccess: 'Élément(s) supprimé(s) avec succès.',
            cancel: 'Annuler',
            confirm: 'Supprimer',
        },
        disablePopup: {
            title: 'Confirmer la désactivation',
            message: 'Voulez-vous vraiment désactiver cette ressource ?',
            usageWarning:
                "Attention : cette ressource est utilisée par {count} expérience. Elle restera configurée avec une ressource indisponible, et la ressource n'apparaîtra plus dans cette liste. | Attention : cette ressource est utilisée par {count} expériences. Elles resteront configurées avec une ressource indisponible, et la ressource n'apparaîtra plus dans cette liste.",
            unusedWarning:
                "Cette ressource n'est utilisée par aucune expérience, mais elle disparaîtra de cette liste et ne pourra plus être réactivée depuis cet écran.",
            cancel: 'Annuler',
            confirm: 'Désactiver',
        },
        modal: {
            info_materiel: 'Gérez ici vos équipements et matériels mis à disposition.',
            info_salle: 'Gérez ici vos installations et espaces de réservation.',
        },
        notifications: {
            success_add: 'Abonnement ajouté',
            success_update: 'Abonnement mis à jour',
            statusError: 'Impossible de mettre à jour le statut de la ressource.',
            positions_updated: 'Ordre des ressources mis à jour avec succès',
            positionsError: 'Erreur lors de la mise à jour de l’ordre des ressources.',
            savingPositions: 'Veuillez attendre la fin de la sauvegarde en cours...',
        },
        form: {
            name: {
                label: "Nom de l'équipement",
                placeholder: 'Nom',
            },
            type: {
                label: 'Statut',
                placeholder: '',
            },
            capacity: {
                label: 'Nombre en stock',
                placeholder: 'Nombre',
            },
            diseable: {
                label: 'Combien sont hors service ?',
                placeholder: 'Maximum : 6',
            },
            title_edit: "Modifier l'équipement",
            title_create: 'Ajouter un équipement',
            options: {
                disabled: 'Désactivé',
                free: 'Libre',
                repair: 'En réparation',
            },
        },
    },
    spaces: {
        form: {
            name: {
                label: "Nom de l'installation",
                placeholder: 'Nom',
            },
            type: {
                label: "Type d'espace ",
                placeholder: '',
            },
            capacity: {
                label: "Capacité d'accueil",
                placeholder: 'Capacité',
            },
            price: {
                label: 'Prix',
                placeholder: 'Veuillez remplir',
            },
            diseable: {
                label: 'Combien sont hors service ?',
                placeholder: 'Maximum:6',
            },
            title_edit: 'Modifier une installation',
            title_create: 'Ajouter une installation',
            switches: {
                authorize_mixing: 'Permettre le mixage',
                link_space: 'Lier des espaces',
            },
            types: {
                private: 'Privé',
                public: 'Public',
            },
            hours: {
                customTitle: 'Configurer des horaires personnalisées',
                sharedSpaceWarning:
                    "Cet espace est utilisé par {count} expérience. Modifier un horaire modifiera l'horaire de ces expériences. | Cet espace est utilisé par {count} expériences. Modifier un horaire modifiera l'horaire de ces expériences.",
            },
        },
    },
    package: {
        notifications: {
            validationStepFirst: "Veuillez valider l'étape actuelle avant de continuer.",
            success_update: 'Formule mise à jour',
            success_add: 'Formule ajoutée',
            saveErrorDefault: 'Une erreur est survenue lors de la sauvegarde.',
        },
        step1: {
            subtitle: 'Informations générales',
            content: 'Informations générales',
            description: 'Sélectionnez le type de formule que vous souhaitez créer',
            typeLabel: 'Type de formule',
            types: {
                specific: {
                    label: 'Formule avec activités spécifiques',
                    subtitle: 'Choisissez les activités qui composent votre formule',
                },
                family: {
                    label: 'Formule familiale',
                    subtitle: 'Les participants peuvent choisir des activités différentes',
                },
            },
            errors: {
                typeRequired: 'Veuillez sélectionner un type de formule',
            },
        },
        step2: {
            subtitle: 'Informations générales',
            content: 'Créer une formule combinée',
            nameLabel: 'Nom de la formule',
            namePlaceholder: 'Donnez un nom à votre formule',
            internalNameLabel: 'Nom interne',
            internalNamePlaceholder: 'Nom interne (usage gestion)',
            descriptionLabel: 'Description de votre formule',
            descriptionPlaceholder: 'Décrivez votre formule (optionnel)',
            imageLabel: 'Illustration de votre formule',
            errors: {
                nameRequired: 'Ce champ est obligatoire',
            },
            notifications: {
                success_add: 'Informations enregistrées avec succès',
                success_update: 'Informations enregistrées avec succès',
            },
            saveError: "Erreur lors de l'enregistrement",
        },
        step3: {
            subtitle: 'Choix de la formule',
            title: 'Sélectionnez vos expériences pour composer votre formule',
            emptyState: {
                message: "Aucune expérience n'a été créée pour le moment.",
                button: 'Créer une expérience',
            },
            choiceLabel: 'Choix',
            activityLabel: 'Sélectionner une activité',
            noActivity: 'Aucune activité disponible',
            durationLabel: 'Durée',
            durationPlaceholder: 'Durée',
            toggles: {
                required: 'Obligatoire',
                hidden: 'Masquer',
            },
            addButton: 'Ajouter un élément au combo',
            sameTimeQuestion: 'Les durées et horaires sont-elles identiques pour chaque expérience ?',
            confirmChangeSameTime: 'Changer cette option supprimera toutes les activités sélectionnées. Voulez-vous continuer ?',
            confirmChangeSameTimeTitle: 'Confirmer le changement',
            slotSuccessionLabel: 'Délai entre les activités',
            slotSuccessionHelp: 'Définit un intervalle de temps entre chaque activité (0 pour les enchaîner).',
            errors: {
                atLeastOne: 'Veuillez ajouter au moins une expérience',
                incomplete: 'Veuillez compléter toutes les expériences sélectionnées',
                durationMismatch: 'Les durées sélectionnées ne sont pas les mêmes.',
            },
            success: 'Formule enregistrée avec succès',
            saveError: "Erreur lors de l'enregistrement",
        },
        step4: {
            subtitle: 'Tarification',
            specificPrice: 'Définir un tarif propre à la formule',
            pricingType: {
                label: 'Type de tarif',
                group: 'Par groupe',
                per_person: 'Par personne',
                group_hint: 'Un tarif unique, quel que soit le nombre de participants.',
                per_person_hint: 'Le tarif est multiplié par le nombre de participants de la réservation.',
                per_person_suffix: ' / participant',
            },
            packagePrice: 'Prix de la formule',
            discountApply: 'Appliquer une remise',
            vat: 'TVA',
            deposit: 'Demander un acompte',
            priceHT: 'Prix HT',
            barcode: 'Code-barres',
            placeholderBarcode: 'Code EAN',
            discountLabel: 'Appliquer les remises aux activités',
            discountPercent: 'Pourcentage de remise',
            differentParticipants: {
                question: 'Les durées et horaires sont-elles identiques pour chaque expérience ?',
            },
            errors: {
                priceRequired: 'Veuillez définir un prix de vente',
                vatRequired: 'Veuillez sélectionner un taux de TVA',
                remiseRequired: 'Le pourcentage de remise doit être entre 1 et 100',
            },
        },
        step5: {
            subtitle: 'Paramètres',
            selectionRules: 'Configurer des règles de sélection des expériences',
            minItems: 'Minimum d’expériences à choisir',
            maxItems: 'Maximum d’expériences à choisir',
            breakTime: 'Prévoir un temps de pause entre chaque expérience',
            breakDuration: 'Durée de la pause',
            minutes: 'minutes',
            select: 'Veuillez sélectionner',
            errors: {
                breakDurationRequired: 'La durée de la pause est obligatoire',
                maxItemsInvalid: 'Le maximum doit être supérieur ou égal au minimum',
            },
            sameOrder: {
                question: 'Les participants doivent-ils suivre l’ordre défini ?',
                yes: "Oui - L'ordre défini doit être suivi",
                yesSubtitle: "Les participants devront suivre l'ordre tel que vous l'avez défini.",
                no: 'Non',
                noSubtitle: "Les participants sont libres de choisir l'ordre.",
            },
            sameSchedule: {
                question: 'Les plannings sont-ils identiques pour chaque activité ?',
                yes: 'Oui',
                yesSubtitle: 'Même durée, même horaire et mêmes intervalles de départ pour tous.',
                no: 'Non',
                noSubtitle: 'Chaque élément a sa propre durée et ses propres horaires.',
            },
            differentParticipants: {
                question: 'Le nombre de participants peut-il être différent pour chaque élément ?',
                yes: 'Oui',
                yesSubtitle: 'Le nombre de participants peut être différent pour chaque élément.',
                no: 'Non',
                noSubtitle: 'Le nombre de participants sera toujours identique pour chaque élément sélectionné dans la formule.',
            },
        },
        step6: {
            subtitle: 'Options',
            onlineDisplay: {
                title: 'Mise en ligne et affichage',
                visibilityLabel: 'Rendre cette formule visible à mes clients',
                visibilityPosLabel: 'Rendre cette formule visible sur le POS',
                mergeQuestionsLabel: 'Regrouper les questions clients identiques pour éviter les doublons',
            },
            categories: {
                title: 'Catégories',
                label: 'Sélectionnez les catégories dans lesquelles cette formule sera visible',
                placeholder: 'Sélectionnez une ou plusieurs catégories',
            },
        },
        step7: {
            subtitle: 'Terminer',
        },
    },
    treatment: {
        step_label: 'Étape',
        step1: {
            subtitle: 'Informations générales',
            content: 'Nom du forfait',
            namePlaceholder: 'Donnez un nom à votre forfait',
            descriptionLabel: 'Description de votre forfait',
            descriptionPlaceholder: 'Décrivez votre forfait (optionnel)',
            illustrationLabel: 'Illustration',
            nameRequired: 'Ce champ est obligatoire',
            descriptionRequired: 'Ce champ est obligatoire',
            saveError: 'Erreur lors de la sauvegarde des informations générales',
        },
        notifications: {
            success_add: 'le forfait a été ajouté avec succès',
            success_update: 'Forfait mis à jour',
            validationStepFirst: "Veuillez valider l'étape actuelle avant de continuer.",
        },
        step2: {
            subtitle: 'Tarification',
            content: 'Définissez le prix de votre forfait',
            price_label: 'Prix de vente',
            vat_label: 'Taux de TVA',
            price_ht_label: 'Prix HT',
            placeholder_select: 'Sélectionner...',
            validation: {
                price_required: 'Veuillez définir un prix de vente',
                vat_required: 'Veuillez sélectionner un taux de TVA',
            },
        },
        step3: {
            subtitle: 'Paramètres',
            content: 'Configurez les règles et paramètres du forfait',
            reservation_mode: 'Mode de réservation',
            utilisations_label: "Nombre d'utilisations",
            limit_period: 'Limiter par période',
            limit_usage_period: "Nombre d'utilisation par periode",
            limit_total_peak: "Limiter nombre total d'heures pleines",
            limit_total_off_peak: "Limiter nombre total d'heures creuses",
            limit_max_off_peak_per: "Limiter nombre maximum d'heures creuses par période",
            limit_max_peak_per: "Limiter nombre maximum d'heures pleines par période",
            allow_peak_for_off_peak: "Autoriser l'utilisation des heures pleines pour les heures creuses",
            empty_state: "Aucune activité n'a été ajoutée pour le moment.",
            add_activity: 'Ajouter une activité',
            select_activities_title: 'Sélectionnez vos activités pour composer votre forfait',
            activity_label: 'Activité',
            duration_label: 'Durée',
            quantity_label: 'Quantité',
            options: {
                participant_label: 'Par participant',
                participant_subtitle: 'Le forfait est vendu par place, chaque participant doit disposer de son propre billet.',
                space_label: 'Par espace',
                space_subtitle:
                    'Le forfait s’applique à l’ensemble de l’espace réservé, quel que soit le nombre de participants.',
                week: 'Semaine',
                month: 'Mois',
            },
            validation: {
                add_one_activity: 'Veuillez ajouter au moins une activité',
                complete_all_activities: 'Veuillez compléter toutes les activités',
            },
        },
        step4: {
            subtitle: 'Activités',
            content: 'Sélectionnez vos activités pour composer le forfait',
            empty_state: "Aucune activité n'a été ajoutée pour le moment.",
            add_activity: 'Ajouter une activité',
            select_title: 'Sélectionnez vos activités pour composer votre forfait',
            activity_label: 'Activité',
            duration_label: 'Durée',
            quantity_label: 'Quantité',
            validation: {
                add_one_activity: 'Veuillez ajouter au moins une activité',
                complete_all_activities: 'Veuillez compléter toutes les activités',
            },
        },
        step5: {
            subtitle: 'Options',
            content: 'Paramétrez la visibilité et les options de billetterie',
            visible_label: 'Rendre ce forfait visible à mes clients',
            undated_label: 'Proposer ce forfait en billet non daté',
            visible_section: 'Mise en ligne et affichage',
            ticketing_section: 'Options de billetterie',
            success_save: 'Forfait enregistré avec succès',
            error_save: 'Erreur lors de la finalisation du forfait',
        },
        preview: {
            live_preview: 'Prévisualisation en direct',
            estimated_time: 'Temps total estimé',
            minutes: 'minutes',
            hours_config: 'Configuration heures',
            peak_hours: 'Heures pleines',
            off_peak_hours: 'Heures creuses',
            max_peak_hours: 'Max heures pleines',
            max_off_peak_hours: 'Max heures creuses',
            visible_online: 'Visible en ligne',
            hidden_online: 'Masqué en ligne',
            undated_ticket: 'Billet non daté',
            list_prestations: 'Liste des prestations :',
            nb_utilisations: "Nombre d'utilisations :",
        },
    },
    invoices: {
        deferred_modal: {
            title: 'Créer une facture',
            order: 'Commande',
            total_amount: 'Montant total',
            info_banner_1: 'Une facture sera générée immédiatement pour cette commande.',
            info_banner_2: 'Aucun paiement ne sera enregistré automatiquement.',
            due_date: 'Date d’échéance',
            due_date_required: 'La date d’échéance est obligatoire.',
            due_date_must_be_future: 'La date d’échéance doit être postérieure à aujourd’hui.',
            error_occured: 'Une erreur est survenue.',
            success_message: 'Facture {fiscal_number} créée — échéance le {due_date}',
            generate_invoice: 'Générer facture',
        },
        credit_note_modal: {
            title: "Créer une facture d'avoir",
            invoice: 'Facture',
            total_amount: 'Montant total',
            remaining_to_credit: 'Restant à avoirer',
            already_credited: 'Déjà avoiré : {amount}',
            refundable: 'Remboursable',
            paid_minus_refunded: '{paid} payé − {refunded} déjà remboursé',
            cap_error:
                "Un montant dépasse ce qui reste remboursable sur son moyen de paiement : on ne peut pas rembourser sur un moyen de paiement plus que ce qu'il a encaissé.",
            reason: 'Motif',
            select_reason: '- Sélectionner un motif -',
            reasons: {
                entry_error: 'Erreur de saisie',
                customer_cancellation: 'Annulation client',
                commercial_gesture: 'Geste commercial',
                product_unavailable: 'Produit indisponible',
                other: 'Autre',
            },
            emit_refund: 'Émettre un remboursement',
            emit_refund_hint: 'Rembourser le client et générer un avoir comptable',
            payment_method: 'Méthode de paiement',
            paid: 'Payé',
            to_refund: 'À rembourser',
            total: 'Total',
            badge_auto: 'Remboursé automatiquement',
            badge_credited: 'Crédité automatiquement',
            badge_manual: 'Opération manuelle',
            balance_error: 'La somme des montants doit être égale à {total}.',
            refund_total: 'Remboursement total',
            refund_partial: 'Remboursement partiel',
            partial_error: 'Le montant doit être supérieur à 0 et au maximum {total}.',
            submit_refund: "Créer l'avoir et rembourser",
            submit_only: "Créer l'avoir",
            cancel: 'Annuler',
            error_occured: "Une erreur est survenue lors de la création de l'avoir.",
        },
        loading: 'Chargement des données...',
        loading_invoices: 'Chargement des factures...',
        type_filters: {
            all: 'Toutes',
            draft: 'Brouillon',
            upcoming: 'À venir',
            overdue: 'En retard',
            paid: 'Payée',
        },
        columns: {
            type: 'Type',
            order_status: 'Statut',
            order_status_label: 'Statut',
            emission: 'Émission',
            due_date: 'Échéance',
            customer: 'Client',
            fiscal_number: 'Numéro',
            price_ht: 'Montant HT',
            price_ttc: 'Montant TTC',
            order_number: 'N° commande',
            articles: 'Articles',
            total: 'Total',
            status: 'Statut',
            date: 'Date',
            actions: 'Actions',
            e_invoice: 'E-facture',
        },
        payment_status: {
            pending: 'En attente',
            partially_paid: 'Partiellement payée',
            paid: 'Payée',
            cancelled: 'Annulée',
            avoir: 'Avoir',
        },
        status_labels: {
            unknown: 'Inconnu',
        },
        invoice: 'Facture',
        amount_refunded: 'Montant remboursé',
        validated_order_invoice: 'Facture validée',
        deleted_customer: 'Client supprimé ou inexistant',
        deleted_order: 'Commande supprimée ou inexistante',
        send_by_email: 'Envoyer par email',
        generate_pdf: 'Générer un PDF',
        confirm_send_email: 'Voulez-vous envoyer cette facture par email ?',
        export_error_msg: 'Erreur lors de l’export :',
        export_filename_prefix: 'factures',
        export_filename_drafts: 'commandes_en_attente',
        title: 'Factures et avoirs',
        create_invoice: 'Créer une facture',
        preview_title: 'Aperçu de la facture',
        download: 'Télécharger',
        option_1: 'Option 1',
        option_2: 'Option 2',
        filter_type: 'Type',
        filter_event_type: 'Type d’événement',
        filter_due_date: 'Échéance',
        filter_advanced: 'Filtres',
        filter_status: 'Statut',
        remove_all_filters: 'Retirer tous les filtres',
        advanced_filters_title: 'Filtres avancés',
        has_refund: 'A un remboursement',
        promo_code_used: 'Code promo utilisé',
        payment_method: 'Méthode de paiement',
        staff_concerned: 'Membre du personnel',
        amount: 'Montant',
        active_filters: 'filtre(s) actif(s)',
        reset_all: 'Réinitialiser tout',
        apply_filters: 'Appliquer les filtres',
        filters_applied: 'Filtres appliqués',
        filters_saved_success: 'Les filtres ont été sauvegardés avec succès',
        filters_save_error: 'Erreur lors de la sauvegarde des filtres',
        saving: 'Sauvegarde...',
        orders: 'Commandes',
        orders_count: 'Nbr. de commandes',
        total_ttc: 'Total TTC',
        type: 'Type',
        export_csv: 'CSV',
        export_excel: 'Excel',
        loading_orders: 'Chargement des commandes...',
        walk_in_customer: 'Client de passage',
        articles: 'article(s)',
        article: 'Article',
        draft: 'Brouillon',
        view_details: 'Voir plus de détails',
        view_invoice: 'Voir une copie de facture',
        view_invoice_action: 'Voir la facture',
        view_order: 'Voir la commande',
        download_invoice: 'Télécharger la facture',
        create_credit_note: 'Créer un avoir',
        credit_note_created_success: 'Avoir créé avec succès',
        types: {
            anniversaire: 'Anniversaire',
            entreprise: 'Entreprise',
            evg_evjf: 'EVG/EVJF',
            manuel: 'Manuel',
        },
        stats: {
            ca_factured: 'Total facturé',
            ca_paid: 'Total encaissé',
            overdue_invoices: 'Factures en retard',
            ht: 'HT',
            ttc: 'TTC',
            invoices_count: 'Factures émises',
            total_invoiced: 'Total facturé',
            paid: 'Payé',
            transformation_rate: "Taux d'encaissement",
        },
        export_filename_selection: 'factures_selection',
        filters_updated_success: 'Les filtres ont été mis à jour avec succès',
        date_filter: {
            today: "Aujourd'hui",
            yesterday: 'Hier',
            this_month: 'Ce mois-ci',
            last_month: 'Le mois dernier',
            this_year: 'Cette année',
            last_year: "L'année dernière",
            apply: 'Appliquer',
            cancel: 'Annuler',
            custom: 'Personnalisé',
            select_period: 'Sélectionner une période',
            type: 'Type',
            order_status: 'Statut',
            status: 'Statut',
            emission: 'Émission',
            due_date: 'Échéance',
            customer: 'Client',
            order_number: 'N° Commande',
            articles: 'Articles',
            total: 'Montant TTC',
            date: 'Date',
            actions: 'Actions',
            fiscal_number: 'Numéro',
            remaining: 'Restant HT',
            price_ht: 'Montant HT',
            price_ttc: 'Montant TTC',
            order_status_label: 'Statut Commande',
            invoice_number: 'Facture n°',
            open_date: 'Date d’ouverture',
            close_date: 'Date de fermeture',
            total_products: 'Total produits (cas échéant)',
            total_prestations: 'Total activités (cas échéant)',
            total_series: 'Total abonnements (cas échéant)',
            base_price: 'Prix de base',
            paid_price: 'Prix payé',
            total_packages: 'Total forfaits (cas échéant)',
            total_vouchers: 'Total bon cadeau (cas échéant)',
            total_promo: 'Total code promo (cas échéant)',
            refund_amount: 'Montant remboursement (cas échéant)',
            email: 'Email',
            phone: 'Numéro de téléphone',
            payment_method: 'Méthode de paiement',
            voucher_promo_used: 'Bon cadeau / Code promo utilisé',
        },
        edit_columns: 'Modifier les colonnes',
        columns_short: 'Colonnes',
        export_selection: 'Exporter la sélection',
        selected_items: '{count} élément{plural} sélectionné{plural}',
        status: {
            all: 'Toutes',
            paid: 'Payées',
            partial: 'Partielles',
            due: 'Dûes',
        },
        clear_filters_dialog: {
            title: 'Retirer tous les filtres ?',
            message: 'Êtes-vous sûr de vouloir retirer tous les filtres actifs ? Cette action ne peut pas être annulée.',
            confirm: 'Oui, retirer tout',
            cancel: 'Annuler',
        },
        selected_elements: 'éléments sélectionnés',
        export: 'Exporter',
        errors: {
            load_reference: 'Erreur lors du chargement des données de référence.',
            update_filters: 'Erreur lors de la mise à jour des filtres',
            validation: 'Erreur de validation',
            connection: 'Erreur de connexion',
            connection_retry: 'Erreur de connexion au serveur. Veuillez réessayer.',
            server_connection: 'Erreur de connexion au serveur',
            generic: 'Une erreur est survenue',
            export_drafts: 'Erreur export {format} brouillons',
            server_error: 'Erreur serveur',
        },
        filters: {
            refund: 'Remboursement',
            voucher: 'Bon cadeau',
            promo_code: 'Code promo',
            payment_method: 'Paiement',
            activities: 'Activités',
            products: 'Produits',
            packages: 'Forfaits',
            subscriptions: 'Abonnements',
            employee: 'Employé',
            order_status: 'Statut',
            status: 'Statut',
            min_amount: 'Montant min',
            max_amount: 'Montant max',
        },
        selected: 'sélectionné(s)',
        yes: 'Oui',
        no: 'Non',
        loading_drafts: 'Chargement des brouillons...',
        view_copy_invoice: 'Voir une copie de facture',
        more_options: "Plus d'options",
        modify: 'Modifier',
        modify_order: 'Modifier la commande',
        encaisser_order: 'Encaisser la commande',
        create_proforma: 'Créer une facture pro-forma',
        cancel_order: 'Annuler la commande',
        confirm_cancel_order: 'Êtes-vous sûr de vouloir annuler la commande',
        yes_cancel: 'Oui, annuler',
        order_cancelled_success: 'Commande annulée avec succès',
        order_cancel_error: "Erreur lors de l'annulation de la commande",
        success: 'Succès',
        error: 'Erreur',
        ok: 'OK',
    },
    devis: {
        status: {
            request: 'Demande',
            sent: 'Envoyé',
            signed: 'Gagné',
            fully_paid: 'Entièrement payé',
            lost: 'Perdu',
            draft: 'Brouillon',
            expired: 'Expiré',
        },
        fields: {
            makeDevisWithTimeSlot: {
                label: 'Création de devis avec créneau horaire',
                description: 'Si activé, les devis seront créés avec un créneau horaire spécifique bloquant la disponibilité.',
            },
        },
        v3: {
            create_title: 'Créer un devis',
            quote_label: 'DEVIS',
            preview_pdf: 'Aperçu PDF',
            save: 'Enregistrer',
            send: 'Envoyer',
            view_client_request: 'Voir la demande client',
            show_client_request: 'Afficher la demande client',
            hide_client_request: 'Masquer la demande client',
            add_at_least_one_line: 'Vous devez ajouter au moins une ligne',
            no_template: 'sans modèle template',
            select_template: 'Sélectionner un modèle',
            template_label: 'Modèle :',
            issue_date: "Date d'émission :",
            due_date: "Date d'échéance :",
            iban_label: 'IBAN :',
            swift_label: 'SWIFT :',
            view_client_record: 'Voir la fiche client',
            select_or_add_client: 'Sélectionner ou ajouter un client',
            associate_or_create_client: 'Associez ou créez un nouveau client',
            change_client: 'Changer',
            passage_client: 'Client de passage',
            designation: 'Désignation',
            qty: 'Qté',
            unit_price_ht: 'PU HT',
            unit_price_ttc: 'PU TTC',
            price_display_label: 'Prix affichés :',
            price_display_title: 'Choisir les prix affichés (HT ou TTC)',
            price_display_ttc: 'TTC',
            price_display_ht: 'HT',
            price_display_option_ht: 'Total HT',
            price_display_option_ttc: 'Total TTC',
            discount: 'Remise',
            tva: 'TVA',
            total: 'Total',
            total_ht: 'Total HT',
            total_ttc: 'TOTAL TTC',
            edit_total: 'Modifier le total (recalcule le PU)',
            edit_total_error: 'Impossible de modifier ce total avec la quantité ou la remise actuelle.',
            add_line: 'Ajouter une ligne',
            edit: 'Modifier',
            custom_line_title: 'Ajouter',
            custom_line_subtitle: 'Ligne personnalisée',
            catalog_line_title: 'Choisir',
            catalog_line_subtitle: 'Depuis le catalogue',
            or: 'ou',
            custom_line_default: 'Article personnalisé',
            draft_validate: 'Valider la ligne',
            option: 'option',
            add_option: 'Ajouter une option',
            optional_line: 'Option',
            suggest_products: 'Options',
            suggest_experiences: 'Expériences',
            suggest_foods: 'Restauration',
            locked_accepted: 'Devis accepté par le client — modification impossible (sauf options)',
            locked_banner: 'Ce devis a été accepté par le client. Seules les options restent modifiables.',
            accepted_badge: 'Accepté',
            signed_by: 'Signé par {name} le {date}',
            signature_alt: 'Signature du client',
            apply_discount: '+ Appliquer une remise',
            discount_code: 'Code',
            remove_discount: 'Retirer la remise',
            manual_discount: 'Montant de la remise',
            discount_amount_placeholder: '0',
            discount_mode: 'Type de remise',
            discount_percentage: 'Pourcentage',
            discount_amount: 'Montant fixe',
            discount_code_group_percentage: 'Pourcentage',
            discount_code_group_amount: 'Montant fixe',
            remise_specific: 'Remise spécifique',
            remises_specific: 'Remises spécifiques',
            cancel: 'Annuler',
            deposit_title: 'Demander un acompte',
            deposit_subtitle: 'En % ou montant fixe — optionnel',
            deposit_label: 'Acompte',
            remove_deposit: 'Retirer l’acompte',
            deposit_amount_placeholder: 'ex. 30',
            deposit_mode: 'Type d’acompte',
            must_select_client: 'Vous devez choisir un client',
            payment_conditions: 'CONDITIONS DE PAIEMENT',
            payment_methods_text: 'Virement / Carte bancaire / Chèque',
            notes_header: 'NOTES',
            add_note: 'Ajouter une note',
            note_field_placeholder: 'Ajouter une note…',
            signature_header: 'SIGNATURE',
            add_at_least_reservation: 'Veuillez ajouter au moins une réservation',
            select_client_first: 'Veuillez sélectionner un client',
            finalized_success: 'Devis finalisé avec succès',
            error_finalizing: 'Erreur lors de la finalisation',
            send_simple: 'Envoi simple',
            send_custom: 'Envoi personnalisé',
            sent_success: 'Devis envoyé au client par email',
            sent_error: "Erreur lors de l'envoi du devis",
            no_quote_generated: 'Aucun devis généré pour le moment. Ajoutez un article.',
            item_added: 'Article ajouté',
            error_adding: "Erreur lors de l'ajout",
            item_removed: 'Article supprimé',
            error_removing: 'Erreur lors de la suppression',
            item_duplicated: 'Article dupliqué',
            error_duplicating: 'Erreur lors de la duplication',
            cannot_remove_last: 'Vous ne pouvez pas supprimer le dernier article du devis.',
            container_line: 'Prestation à 0 € : le montant est porté par les billets ci-dessous',
            confirm_remove_last_child: "C'est le dernier billet : la prestation entière sera retirée du devis. Continuer ?",
            confirm_remove: 'Voulez-vous vraiment supprimer cet article ?',
            note_saved: 'Note enregistrée',
            note_error: "Erreur lors de l'enregistrement de la note",
            item_note_placeholder: 'Ajouter une note (Maj + Entrée pour sauter une ligne)',
            remove_item_title: 'Supprimer cet article',
            remove_item_confirm: 'Supprimer',
            select_client_first_long: "Veuillez d'abord sélectionner un client",
            template_updated: 'Modèle mis à jour',
            error_template: 'Erreur lors de la mise à jour du modèle',
            order_updated: 'Ordre des lignes mis à jour',
            note_placeholder: 'Saisissez la demande du client...',
            client_creation_soon: 'Création de client bientôt disponible',
            unnamed_article: 'Article',
            date_prefix: 'Le',
            options_title: 'Options',
            conditions_title: 'Conditions',
            conditions_desc: 'Configurez la durée de validité et les conditions de paiement de votre devis.',
            validity_label: 'Durée de validité',
            validity_1month: '1 mois',
            validity_15days: '15 jours',
            validity_7days: '7 jours',
            validity_custom_days: '{days} jours',
            due_date_computed_hint: "Calculée : date d'émission + durée de validité (panneau Options)",
            due_date_before_last_item:
                'Échéance impossible : le {due} précède la dernière prestation du devis ({item}). Déplacez ou supprimez cette ligne avant de raccourcir la durée de validité.',
            error_due_date: "La durée de validité n'a pas pu être enregistrée.",
            error_auto_reminder: "Le délai de relance automatique n'a pas pu être enregistré.",
            error_payment_methods: "Les moyens de paiement n'ont pas pu être enregistrés.",
            error_quote_client: "Le client n'a pas pu être enregistré sur le devis.",
            no_payment_method_selected: 'Aucun moyen de paiement sélectionné',
            auto_reminder_label: 'Relance automatique',
            reminder_7before: '7 jours avant échéance',
            reminder_3before: '3 jours avant échéance',
            reminder_1before: '1 jour avant échéance',
            payment_methods_title: 'Méthodes de paiement',
            no_payment_methods: 'Aucun moyen de paiement configuré pour cet établissement.',
            virement: 'Virement',
            activate_evirement: 'Activer le e-virement automatique',
            etablissement: 'Établissement',
            iban: 'IBAN',
            bic: 'BIC',
            participants_outside_recommended_range:
                "Attention, ce nombre de personnes est hors de la plage recommandée pour l'espace associé (entre {min} et {max}).",
            bank_first_entry_hint:
                "Aucun RIB n'est encore enregistré : votre saisie sera ajoutée aux paramètres de l'établissement.",
            bank_saved_success: "RIB enregistré dans les paramètres de l'établissement.",
            bank_save_error: "Impossible d'enregistrer le RIB.",
            online_payment: 'Paiement en ligne',
            carte: 'Carte bancaire',
            cheque: 'Chèque',
            especes: 'Espèces',
            esignature_title: 'Signature électronique',
            request_esignature: 'Demander une signature électronique',
            e_virement_banner_text:
                'Un IBAN dédié sera créé par Stripe pour ce devis. Dès réception du réglement, le devis sera automatiquement validé.',
            block_resources_label: 'Bloquer les ressources',
            block_resources_none: 'Ne pas bloquer',
            step_selection: 'Sélectionner une expérience',
            step_participants: 'Nombre de personnes',
            step_planning: 'Date & Créneau',
            experiences: 'Expériences',
            packages: 'Formules combinées',
            resto: 'Resto',
            food_menus: 'Menus',
            food_open_category: 'Voir la sélection',
            no_food_in_category: 'Aucun plat dans cette catégorie.',
            no_food_available: 'Aucun plat disponible.',
            food_loading: 'Chargement du plat…',
            food_detail_error: 'Impossible de charger ce plat.',
            food_no_addon: 'Aucun supplément pour ce plat.',
            food_required: 'Requis',
            food_required_missing: 'À compléter : {groups}',
            food_included: 'Inclus',
            food_min: 'min. {min}',
            food_max: 'max. {max}',
            food_min_max: 'min. {min} · max. {max}',
            food_confirm: 'Confirmer',
            food_pack_choose_hint: 'Veuillez choisir un produit à chaque niveau.',
            all_filter: 'Tous',
            nav_loading: 'Chargement des catégories…',
            search_results: 'Résultats',
            add_to_quote: 'Ajouter au devis',
            choose_date: 'Choisir la date',
            planning_mode_date: 'Choisir une date',
            planning_mode_slot: 'Bloquer un créneau',
            planning_mode_none: 'Sans date',
            planning_none_title: 'Aucune date sur cette ligne',
            planning_none_text: 'La date pourra être définie plus tard directement depuis le devis.',
            planning_none_summary: 'À planifier plus tard',
            daypart_morning: 'Matin',
            daypart_afternoon: 'Après-midi',
            daypart_evening: 'Soir',
            edit_price: 'Modifier le prix',
            rename_line: 'Renommer la ligne',
            remove_line: 'Retirer du devis',
            remove_option: "Retirer l'option",
            qty_decrease: 'Diminuer la quantité',
            qty_increase: 'Augmenter la quantité',
            qty_edit: 'Modifier la quantité',
            food_options_to_configure: 'Options à configurer',
            food_choices_count: '{count} choix | {count} choix',
            summary_title: 'Récapitulatif',
            summary_lines: '{count} ligne | {count} lignes',
            summary_col_article: 'Article',
            summary_col_qty: 'Qté',
            summary_col_unit_ht: 'P.U. HT',
            summary_col_total: 'Total',
            summary_subtotal_ht: 'Sous-total HT',
            summary_vat_on: 'sur',
            summary_close: 'Fermer le récapitulatif',
            summary_edit_line: 'Modifier cette ligne',
            summary_no_date: 'Sans date',
            summary_negotiated_price: 'Prix négocié',
            summary_duration_minutes: '{count} min',
            participants_less: 'Une personne de moins',
            participants_more: 'Une personne de plus',
            participants_whole_space: 'Tout l’espace',
            participants_shared_slot: 'Créneau partageable',
            edit_slot: 'Modifier le créneau',
            no_item_found: 'Aucun article trouvé.',
            no_item_available: 'Aucun article disponible pour cette catégorie.',
            options: 'Options',
            confirm: 'Confirmer',
            next: 'Suivant',
            back: 'Retour',
        },
    },
    marketing: {
        abandoned_cart: {
            title: 'Relance panier abandonné',
            subject: "Objet de l'email",
            subject_placeholder: 'Ex : Faites vite, ce créneau est très demandé !',
            message_body: 'Corps du message',
            usable_variables: 'Variables utilisables dans votre message',
            button_text: 'Texte du bouton de réservation',
            button_text_placeholder: 'Finaliser ma réservation',
            sending_delay: 'Délai d’envoi après abandon',
            select_delay: 'Sélectionner un délai',
            preview_title: "Prévisualisation de l'email",
            subject_label: 'Objet :',
        },
        campaigns: {
            title: 'Campagnes email',
            create: 'Créer une campagne',
            untitled: 'Sans titre',
            edit_name: 'Modifier le nom',
            step_recipients: 'A qui envoyez-vous cet e-mail ?',
            step_from: 'Qui envoie cet e-email ?',
            step_subject: 'Quelle est la ligne d’objet de cet e-mail ?',
            step_time: "Heure d'envoi",
            step_content: 'Contenu',
            add_recipients: 'Ajout destinataires',
            send_to: 'Envoyer à',
            add_filters: 'Ajouter des filtres',
            customer_list: 'liste des clients',
            no_results_for: 'Aucun résultat trouvé pour',
            no_element_found: "Aucun élément n'est trouvé.",
            do_not_send_to: 'Ne pas envoyer à (facultatif)',
            remove_emails: 'Retirez les emails',
            no_user_found: "Aucun utilisateur n'est trouvé.",
            who_sends: 'Qui envoie cet e-email ?',
            add_sender: "Ajouter d'expéditeur",
            instance_name: 'Nom instance',
            marketing_email: 'E-mail marketing',
            required: 'Obligatoire',
            subject: 'Objet',
            add_subject: "Ajouter d'objet",
            subject_tip: "Découvrez les performances de vos dernières lignes d'objet. Consultez notre guide.",
            preview_text: 'Texte d’aperçu',
            preview_text_tip: "Le texte d'aperçu s'affiche dans la boîte de réception après la ligne d'objet.",
            when_to_send: 'Quand devons-nous envoyer cet e-mail ?',
            send_now_label: 'Envoyer maintenant vos e-mails',
            send_prog_label: "Programmer l'envoi",
            modify_send_time: "Modifier l'heure d'envoi",
            optimize_timing: 'Optimisez votre timing',
            make_email_reach_now: 'Faites parvenir e-mail maintenant',
            send_date: "Date d'envoi",
            design_content: 'Concevez le contenu de votre e-mail',
            create_email: 'Créer un e-mail',
            choose_ready_email: 'Choisir un email prêt',
            finish_later: 'Terminer plus tard',
            send_test: 'Envoyer un test',
            send: 'Envoyer',
            security_tip:
                "Pour éviter l'envoi d'e-mails aux clients qui ont reçu des e-mails au cours de la dernière heure, il est recommandé d'activer la sécurité.",
            test_email_placeholder: 'E-mail',
            test_subject_placeholder: 'Objet',
            save_model: 'Enregistrer le modèle',
            design_filename: 'modèle',
            status: {
                all: 'Toutes',
                draft: 'Brouillon',
                scheduled: 'Planifiée',
                in_progress: 'En cours',
                canceled: 'Annulée',
                failed: 'Échouée',
                sent: 'Envoyée',
                finished: 'Terminée',
            },
            success: 'Succès',
            failed: 'Échec',
            actions: {
                duplicate: 'Dupliquer',
                edit: 'Modifier',
                delete: 'Supprimer',
            },
            empty_state: "Les campagnes par e-mail créées s'affichent ici.",
            empty_state_title: 'Touchez votre audience en quelques minutes seulement',
            no_subject: 'Sans objet',
            filter_results: 'Filtrer les résultats de recherche',
            no_results: "Aucun élément n'a été trouvé.",
            emails_sent_count: "Nbre d'email envoyé",
            creation_date: 'Date de création',
            which_subject: 'Quelle est la ligne d’objet de cet e-mail ?',
            placeholder_search_emails: 'Rechercher des e-mails...',
            status_header: 'Statut',
            actions_header: 'Action(s)',
            list_view: 'Vue Liste',
            calendar_view: 'Vue Calendrier',
            stats_view: 'Vue Statistique',
            indicate_filename: 'Indiquer le nom du fichier ...',
            models: {
                halloween: 'Halloween',
                new_year: 'Nouvel an',
                christmas: 'Noël',
            },
            config_checks: {
                instance_name: 'nom instance',
                marketing_email: 'e-mail marketing',
                subject: 'objet',
                customer_list: 'liste des clients',
                confirmation: 'confirmation',
                content: 'contenu',
            },
            view_detail: 'Voir le détail',
            last_modification: 'Dernière modification',
            free_models: 'Modèles gratuits',
        },
        messages: {
            saved_success: 'Enregistré avec succès.',
            sending_started: "L'envoi des E-mails sera lancé",
            test_sending_started: "L'envoi de l'email de test sera lancé.",
            operation_success: 'Opération réalisée avec succès.',
        },
    },
    checkout: {
        title: 'Caisse',
        version_banner: {
            v3: {
                title: 'Bienvenue sur la nouvelle version !',
                badge: 'NOUVEAU',
                description:
                    "Une interface repensée, plus rapide et plus claire. Certaines fonctionnalités continuent d'évoluer — votre retour nous aide à l'améliorer.",
                cta: "Revenir à l'ancienne version",
            },
            v2: {
                title: 'La nouvelle version est disponible',
                badge: 'BÊTA',
                description:
                    'Découvrez une interface repensée, plus rapide et plus intuitive. Vous pouvez basculer dès maintenant — et revenir ici à tout moment.',
                cta: 'Passer à la nouvelle version',
            },
        },
        categories: {
            activity: 'Expériences',
            products: 'Ventes additionnelles',
            subscriptions: 'Abonnements',
            vouchers: 'Bons cadeaux',
            undated_ticket: 'Billets non datés',
            bundles: 'Forfaits',
            wallet: 'Wallet',
            treatments: 'Cures',
        },
        cart: {
            title: 'Panier',
            empty_cart: 'Vider le panier',
            empty_cart_confirm: 'Voulez-vous vider le panier ?',
            price: 'Prix',
            action: 'Action',
            total: 'Total',
            validate_selection: 'Valider la sélection',
            select_article: 'Sélectionner un article',
            no_results_found: 'Aucun résultat trouvé',
            no_results_subcategory: 'Aucun résultat pour cette sous-catégorie.',
            available_qty: 'Qté disponible :',
        },
        sale: {
            title: 'Vente',
            add_company: 'Ajouter une société sur la facture',
            address: 'Adresse',
            postal_code: 'Code postal',
            country: 'Pays',
            close_sale_title: 'Clôturer la vente',
            close_sale_confirm: 'Voulez-vous clôturer la vente ?',
            invoice: 'Facture',
            cash_in_only: 'Encaisser seulement',
            close: 'Clôturer',
            waiting_sales: 'Commandes en cours',
            order_number: 'Commande n°',
            prepayment: 'Prépaiement',
            remain_amount: 'Montant restant :',
            load_cart: 'Charger le panier',
            no_waiting_sales: 'Pas de ventes en attente.',
            tracking: 'Suivi de la vente',
            seller: 'Vente',
            adviser: 'Conseil',
            none: 'Aucun',
        },
        serie_modal: {
            select_activities_title: 'Sélectionner les activités',
            select_activities_label: 'Sélectionner les activités auxquelles il faut appliquer :',
            no_activities: 'Aucune activité pour ce forfait',
        },
        security: {
            title: 'Sécurisation',
            date: 'Date',
            type: 'Type',
            amount: 'Montant',
            voucher: 'Bon cadeau',
            subscription: 'Abonnement',
            package: 'Forfait',
            collect_title: 'Collecter la sécurisation',
            delete_title: "Supprimer l'empreinte",
            collect_btn: 'Collecter',
            delete_btn: 'Supprimer',
        },
        fingerprint: {
            collect_title: 'Collecter la sécurisation',
            delete_title: "Supprimer l'empreinte",
            amount: 'Montant',
            invalid_value: 'Valeur incorrecte.',
            required: 'Élément requis.',
            wrong_format: 'Format incorect',
            cancel: 'Annuler',
            collect: 'Collecter',
            delete: 'Supprimer',
            error: 'Une erreur est survenue',
        },
        contributor: {
            title: 'Participant(s)',
            last_name: 'Nom',
            first_name: 'Prénom',
            email: 'Email',
            price: 'Prix',
            status: 'Statut',
            paid: 'Payé',
            not_paid: 'Non Payé',
            no_participants: 'Aucun participant disponible.',
        },
        add_card: {
            title: 'Ajouter une carte bancaire',
            holder_name: 'Nom du titulaire du compte',
            close: 'Fermer',
            add: 'Ajouter',
            stripe_load_error: 'Impossible de charger Stripe.',
            success: 'La carte a été ajoutée avec succès.',
            error: 'Erreur',
        },
        payment_klarna: {
            three_times: 'Paiement en 3 fois',
            pay_three_times: 'Payer sur 3 fois',
            error: 'Une erreur est survenue',
        },
        refund: {
            title: 'Effectuer un remboursement',
            amount_to_refund: 'Montant à rembourser',
            max_amount_error: 'Le montant ne doit pas dépasser {amount}.',
            initial_amount: 'Montant initial :',
            cancel: 'Annuler',
            processing: 'Traitement...',
            submit: 'Rembourser',
            required: 'Élément requis.',
            wrong_format: 'Format incorrect',
            wrong_float_format: 'Format décimal incorrect',
            error_message: 'Une erreur est survenue lors du remboursement',
        },
        v3: {
            nomad_checkout: 'Caisse nomade',
            new_sale: 'Nouvelle vente',
            open_sales: 'Ventes en attente',
            cancel_btn: 'Annuler',
            load_error: "Impossible de charger l'état de la caisse",
            empty_cart: 'Le panier est vide',
            sale_closed: 'Vente clôturée',
            deposit_collected: 'Acompte encaissé',
            client_label: 'CLIENT',
            search_client_placeholder: 'Rechercher un client…',
            walk_in_customer: 'Client de passage',
            no_email: "Pas d'email",
            registered_clients: 'CLIENTS ENREGISTRÉS',
            loading: 'Chargement…',
            no_clients: 'Aucun client',
            new_client: 'Nouveau client',
            guest_client: 'Client de passage',
            none: 'Aucun',
            error_selecting_client: 'Impossible de sélectionner ce client',
            error_creating_client: 'Erreur lors de la création du client',
            search_item_placeholder: 'Rechercher un article…',
            caisse_crumb: 'Caisse',
            soon: 'bientôt',
            no_category: 'Aucune catégorie',
            free_amount: 'Montant libre',
            validate: 'Valider',
            no_item: 'Aucun article',
            unit_h: 'h',
            unit_m: 'min',
            all_day: 'Journée',
            tile_soon_toast: '« {label} » arrive dans une prochaine phase',
            pos_only: 'POS uniquement',
            pos_only_toast: '« {label} » est disponible uniquement sur le POS',
            error_loading_items: 'Erreur de chargement des articles',
            error_loading_products: 'Erreur de chargement des produits',
            select_client_wallet: 'Sélectionnez un client pour créditer le wallet',
            select_client_subscription: 'Sélectionnez un client pour vendre un abonnement',
            item_added: '{name} ajouté',
            error_adding_item: "Impossible d'ajouter l'article",
            cart_title: 'Panier',
            global_note_placeholder: 'Ajouter une note globale',
            voucher_tag: 'Bon cadeau',
            validate_voucher: 'Valider le bon cadeau',
            add_note: 'Note',
            locked_line_tip: 'Liée à une réservation — non supprimable depuis la caisse',
            last_line_tip: 'Dernier article de la vente — supprimez la vente pour l’annuler',
            line_total: 'Total',
            subtotal_label: 'Sous-total',
            old_price_label: 'Prix initial',
            promo_already_applied: 'Une remise est déjà appliquée à cette commande',
            closed_readonly: 'Vente clôturée — lecture seule',
            // Vente au comptoir d'une activité qui exige une vraie réservation (bowling) —
            // walk-in du jour : deux champs (effectif, durée) puis créneau.
            booking_participants: 'Nombre de joueurs',
            booking_duration: 'Durée',
            booking_players: '{n} joueur | {n} joueurs',
            booking_confirm: 'Valider',
            closed_readonly_payment: 'Vente clôturée — lecture seule. Remboursements depuis la page factures.',
            view_btn: 'Voir le détail',
            new_sale_btn: 'Nouvelle vente',
            total_ttc: 'TOTAL TTC',
            remaining_to_pay: 'Déjà payé {paid} · reste {remains}',
            already_paid: 'Déjà payé',
            remaining_to_pay_label: 'Reste à payer',
            cash_in_btn: 'Encaisser',
            validate_voucher_first: "Validez d'abord le bon cadeau pour pouvoir encaisser.",
            on_hold_soon: 'Bientôt disponible',
            on_hold_btn: 'Mettre en attente',
            sale_on_hold: 'Vente mise en attente',
            error_deleting: 'Suppression impossible',
            error_changing_price: 'Modification du prix impossible',
            error_changing_quantity: 'Modification de la quantité impossible',
            add_item_first: 'Ajoutez d’abord un article au panier',
            note_global_title: 'Note globale',
            note_line_title: 'Note — {name}',
            note_saved: 'Note enregistrée',
            error_saving_note: 'Enregistrement de la note impossible',
            payment_title: 'Encaissement',
            recap_title: 'Récapitulatif',
            already_paid_label: 'DÉJÀ PAYÉ',
            refund_btn: 'Rembourser',
            discount_label: 'Remise',
            already_collected: 'Déjà encaissé',
            overpaid_warning: 'Le client a payé {amount} € de trop. Pensez à le rembourser avant de clôturer la commande.',
            confirm_close_title: 'Confirmer la clôture ?',
            confirm_close_overpaid:
                'Le client a payé {amount} € de trop. Vous pourrez le rembourser depuis la page factures. Clôturer quand même ?',
            confirm_close_anyway: 'Clôturer quand même',
            reste_label: 'RESTE',
            to_pay_label: 'À PAYER',
            total_ttc_short: 'TOTAL TTC',
            paid_status: 'SOLDÉ',
            remaining_status: 'RESTE À ENCAISSER',
            promo_placeholder: 'Code de réduction / promo…',
            custom_discount_placeholder: 'Remise instantanée',
            custom_discount_applied: 'Remise instantanée appliquée',
            reductions_group: 'Réductions',
            promos_group: 'Codes promo',
            apply_btn: 'Appliquer',
            payment_methods_label: 'MOYENS DE PAIEMENT',
            no_payment_methods: 'Aucun moyen de paiement configuré pour cet établissement.',
            voucher_code_placeholder: 'Code du bon cadeau…',
            verify_btn: 'Vérifier',
            saved_cards_btn: 'Charger les cartes enregistrées',
            no_saved_cards: 'Aucune carte enregistrée pour ce client.',
            choose_card_placeholder: 'Choisir une carte…',
            wallet_balance: 'solde {balance}',
            use_balance_btn: 'Utiliser le solde',
            dedicated_flow_soon: 'Flux dédié à venir',
            fidelity_label: 'Fidélité',
            fidelity_balance: '{points} pts ≈ {amount}',
            no_points: 'Aucun point disponible',
            cash_in_acompte: "Encaisser l'acompte",
            close_sale_btn: 'Clôturer la vente',
            error_invalid_refund_amount: 'Montant de remboursement invalide',
            refund_success: 'Remboursement effectué',
            error_refund_failed: 'Remboursement impossible',
            error_voucher_already_added: 'Ce bon cadeau est déjà ajouté',
            error_loading_cards: 'Impossible de charger les cartes',
            error_choose_card: 'Choisissez une carte enregistrée',
            error_payment_failed: "L'encaissement a échoué",
            error_max_amount: 'Montant maximum dépassé',
            error_min_amount: 'Montant minimum non atteint',
            error_promo_failed: 'Code promo invalide ou expiré',
            error_voucher_failed: 'Bon cadeau invalide ou expiré',
            promo_applied: 'Code promo appliqué',
            note_title_default: 'Note',
            note_placeholder_default: 'Saisir une note…',
            save_btn: 'Enregistrer',
            open_sales_title: 'Ventes ouvertes',
            open_sales_sub: '{count} en attente · max {max}',
            no_open_sales: 'Aucune vente ouverte.',
            client_sales_label: 'Ventes de {name}',
            global_sales_label: 'Ventes globales',
            open_sale_success: 'Vente ouverte',
            open_sale_btn: 'Ouvrir la vente',
            error_opening_sale: "Impossible d'ouvrir la vente",
            recipient_label: 'Destinataire',
            recipient_none: 'Sans destinataire',
            recipient_other: 'Autre personne',
            first_name_placeholder: 'Prénom',
            last_name_placeholder: 'Nom',
            email_placeholder: 'Email',
            phone_placeholder: 'Téléphone',
            recipient_first_name_placeholder: 'Prénom destinataire',
            recipient_last_name_placeholder: 'Nom destinataire',
            recipient_email_placeholder: 'Email destinataire',
            given_by_label: 'Offert par',
            sending_label: 'Envoi',
            no_mail_label: "Ne pas envoyer d'email",
            message_placeholder: 'Message (optionnel)',
            voucher_validated: 'Bon cadeau validé',
            error_validating_voucher: 'Validation du bon cadeau impossible',
            prepaid_title: 'Séries & cures prépayées',
            session: 'séance',
            sessions: 'séances',
            remaining_f: 'restante',
            remaining_f_plural: 'restantes',
            invoice_company_label: 'Établir une facture société',
            send_thank_you_email: 'Envoyer le mail de remerciement',
            include_review_links: "Inclure les liens d'avis (Google, Facebook…)",
            seller_label: 'Vendeur',
            adviser_label: 'Conseiller',
            error_assigning_seller: 'Affectation du vendeur impossible',
            error_assigning_adviser: 'Affectation du conseiller impossible',
            no_experience: 'Aucune expérience',
            error_loading_catalog: 'Erreur de chargement du catalogue',
            experiences_label: 'Expériences',
            all_tags: 'Tous',
            uncategorized: 'Sans catégorie',
            tickets_selection_total: '{count} billet(s) · {total}€',
            no_info_required_hint: 'Aucune information requise — vous pouvez valider directement.',
            client_type_label: 'Type de client',
            client_individual: 'Particulier',
            client_professional: 'Professionnel',
            gender_label: 'Civilité',
            gender_male: 'Homme',
            gender_female: 'Femme',
            gender_other: 'Autre',
            identity_label: 'Identité',
            social_reason_placeholder: 'Raison sociale',
            siret_placeholder: 'SIRET',
            tva_placeholder: 'N° TVA',
            fonction_placeholder: 'Fonction',
            required_fields_hint: 'Les champs Prénom, Nom et Email sont obligatoires.',
            add_btn: 'Ajouter',
            client_created: 'Client créé',
        },
        payment_stripe: {
            card_label: 'Carte de paiment',
            no_results: 'Aucun résultat',
            currency_suffix: 'en {currency}',
            collect: 'Prélever',
            wrong_format: 'Format incorrect {format}',
            required: 'Élément requis.',
            rest_is: 'Le reste est : {amount}{currency}',
            error: 'Une erreur est survenue',
        },
        devis: {
            change_template: 'Changer',
            add_template: 'Ajouter',
            template_model: 'modèle template',
            no_template: 'sans modèle template',
            due_date: "Date d'échéance :",
            saving: 'Enregistrement…',
            loading: 'Chargement…',
            configure_signature: 'Configurer signature',
            save: 'Enregistrer',
            generate: 'Géneration Devis',
            send: 'Envoyer Devis',
            validating: 'Validation…',
            validate: 'Valider Devis',
            prepare_signature: 'Préparer la signature électronique',
        },
        payment: {
            title: 'Moyen de paiement',
            remain_to_pay: 'Reste dû :',
            collect: 'Encaissement',
            cash_in: 'ENCAISSER',
            cash_in_and_close: 'ENCAISSER & CLÔTURER',
            paid: 'Déjà payé',
            excess_amount_warning: "Attention, vous allez encaisser plus d'argent que la valeur du panier.",
            advantages: 'Avantages',
            promo_code_limit: "(*) Vous ne pouvez utiliser qu'un seul code promo par commande.",
            add_promo_code: 'Ajouter un code de réduction',
            add_another_promo_code: 'Ajouter un autre code promo',
            apply: 'Appliquer',
            applied: 'Appliqué',
            global_discount: '(remise globale)',
            quantity: 'Quantité',
            amount_category: 'Montant {category}',
            errors: {
                expired: 'Le code promo a expiré.',
                expired_since: 'Le code promo a expiré depuis le {date}.',
                disabled: 'Le code promo est désactivé.',
                limit_reached: "Le nombre maximum d'utilisation du code promo à été atteint.",
                min_amount: 'Montant minimum requis : {amount} {symbol}',
                max_amount: 'Montant maximum requis : {amount} {symbol}',
                already_used: 'Code promo déjà utilisé.',
                not_applicable: 'Code promo non applicable.',
                not_found: 'Code promo introuvable.',
                internal_error: "Une erreur interne s'est produite",
                overpaid_warning: "Attention, vous allez encaisser plus d'argent que la valeur du panier.",
            },
            info: {
                applicable: 'Code promo applicable.',
            },
        },
        series: {
            title: 'Abonnements',
            remaining_quantity: 'Quantité restante :',
            remaining_qty: 'Quantité restante :',
            no_subscriptions: 'Aucun abonnement pour ce client.',
            no_series: 'Aucun abonnement pour ce client.',
            remove: 'Retirer',
            apply: 'Appliquer',
        },
        treatments: {
            remaining_quantity: 'Quantité restante :',
            no_treatments: 'Aucune cure pour ce client.',
            title: 'Formules',
        },
        voucher: {
            title: 'Bons cadeaux',
            setup_title: 'Paramètrage du bon cadeau',
            validate_undated: 'Valider le billet non daté',
            validate_gift: 'Valider le bon cadeau',
            valid_until: "valable jusqu'au",
            total_available: 'Montant total de {type} {amount} disponible',
            blocked: 'Ce {type} a été bloqué.',
            already_used: 'Ce {type} a déjà été utilisé.',
            beneficiary: 'Bénéficiaire',
            this_customer: 'Ce client',
            another_customer: 'À un autre client',
            search_customer: 'Rechercher un client',
            choose_customer: 'Choisir un client',
            no_email: "Pas d'email",
            new_beneficiary: 'Nouveau bénéficiaire',
            first_name: 'Prénom*',
            last_name: 'Nom*',
            email: 'Email*',
            phone: 'Téléphone*',
            email_beneficiary: 'Email du bénéficiaire',
            phone_beneficiary: 'Téléphone du bénéficiaire',
            no_beneficiary: 'Pas de bénéficiaire',
            undated_ticket: 'Billet non daté',
            gift_voucher: 'Bon cadeau',
            send_by_email: 'Envoyer par email',
            send_date_email: "Date d'envoi par mail",
            custom_message: 'Message personnalisé',
            custom_message_placeholder: 'Ajoutez un message personnalisé (optionnel)...',
            characters: 'caractères',
            total_amount_of: 'Montant total de',
            available: 'disponible',
            errors: {
                fill_required: 'Veuillez remplir',
                blocked: 'Ce ... a été bloqué.',
                already_used: 'Ce ... a déjà été utilisé.',
            },
        },
        treatment_modal: {
            select_activities: 'Sélectionner les activités',
            select_activities_for: 'Sélectionner les activités auxquelles il faut appliquer :',
            no_activities: 'Aucune activité pour ce forfait',
        },
        thanks_mail: {
            title: 'E-mail de remerciement',
            setup_title: "Paramètres de l'e-mail de remerciement",
            notice_links: "Liens d'avis",
            rebooking: 'Offre de re-réservation',
            review_links: "Liens d'avis",
            send_thanks_mail: "Envoyer l'e-mail de remerciement",
            rebooking_offer: 'Offre de re-réservation',
        },
    },
    product: {
        title: 'Produits',
        edit_title: 'Modifier un produit',
        add_title: 'Ajouter un produit',
        general_info: 'Informations générales',
        name: 'Nom',
        name_placeholder: 'Ex : T-shirt, Jeton...',
        category: 'Catégorie',
        category_placeholder: 'Sélectionner une catégorie',
        description: 'Description',
        description_placeholder: 'Décrivez votre produit',
        usage: 'Illustration',
        usage_placeholder: 'Comment utiliser ce produit ?',
        change_image: "Changer l'image",
        choose_image: 'Choisir une image ou glissez-déposez votre fichier',
        pricing: 'Tarification',
        apply_discount: 'Appliquer une remise',
        sale_price: 'Prix de vente',
        vat_rate: 'Taux de TVA',
        new_price: 'Prix après remise',
        discount_percentage: 'Réduction en pourcentage',
        variants_features: 'Variantes et caractéristiques',
        available_sizes: 'Tailles disponibles',
        sizes_placeholder: 'Ex: XS, S, M, L...',
        unit: 'Unité',
        unit_placeholder: 'Sélectionner une unité',
        value: 'Valeur',
        active: 'Activé',
        visible_online: 'Afficher sur le site',
        history: 'Historique',
        published_on: 'Publié le',
        by: 'par',
        modified_on: 'Modifié le',
        access_product_sheet: 'Accéder à la fiche produit',
        supply: 'Approvisionnement',
        supplier: 'Fournisseur',
        supplier_placeholder: 'Sélectionner un fournisseur',
        supplier_reference: 'Référence fournisseur',
        brand: 'Marque',
        brand_placeholder: 'Sélectionner une marque',
        purchase_cost: "Coût d'achat",
        recommanded_quantity: 'Quantité à commander',
        stock: 'Stock',
        consumable_product: 'Produit consommable',
        stock_quantity: 'Quantité en stock',
        stock_quantity_help:
            'Laissez vide pour un stock illimité. Renseigné, il est décrémenté à chaque vente additionnelle et peut devenir négatif.',
        threshold_alert: "Seuil d'alerte",
        consumption_duration: 'Durée de consommation en jours',
        days: 'jours',
        back: 'Retour',
        validate: 'Valider',
        exit_dialog: {
            title: 'Voulez-vous quitter ?',
            message: 'Vous avez des modifications non enregistrées. Voulez-vous vraiment quitter ?',
            exit: 'Quitter',
            stay: 'Rester',
        },
        validation: {
            name_required: 'Le nom du produit est obligatoire.',
            category_required: 'La catégorie est obligatoire.',
            description_required: 'La description est obligatoire.',
            price_required: 'Le prix de vente doit être supérieur ou égal à 0.',
            vat_required: 'Le taux de TVA est obligatoire.',
            purchase_cost_required: "Le coût d'achat est obligatoire et doit être positif.",
            recommanded_quantity_required: 'La quantité à commander est obligatoire et doit être positive.',
            stock_quantity_required: 'La quantité en stock est obligatoire et doit être positive.',
            threshold_alert_required: "Le seuil d'alerte est obligatoire et doit être positif.",
        },
        notifications: {
            price_warning: 'Le nouveau prix doit être inférieur au prix de base',
            update_success: 'Produit mis à jour avec succès',
            add_success: 'Produit ajouté avec succès',
            save_error: "Une erreur est survenue lors de l'enregistrement",
        },
    },
    productCategories: {
        title: 'Catégories',
        title2: 'Catégorie',
        table: {
            name: 'Nom',
            products_count: 'Nombre de produits',
            subcategories_count: 'Nombre de sous-catégories',
            status: 'État',
            actions: 'Actions',
        },
        status: {
            active: 'Activé',
            inactive: 'Désactivé',
        },
        deletePopup: {
            title: 'Supprimer la catégorie',
            message: 'Êtes-vous sûr de vouloir supprimer cette catégorie ? Cette action est irréversible.',
            cancel: 'Annuler',
            confirm: 'Supprimer',
        },
        actions: {
            create: 'Ajouter',
            edit: 'Modifier la catégorie',
            delete: 'Supprimer la catégorie',
            deleteSelection: 'Supprimer la sélection',
        },
        createPopup: {
            titleCategory: 'Ajouter une catégorie',
            titleSubcategory: 'Ajouter une sous-catégorie',
            titleUpdateCategory: 'Modifier la catégorie',
            titleUpdateSubcategory: 'Modifier la sous-catégorie',
            nameLabel: 'Nom de la catégorie',
            nameSubcategoryLabel: 'Nom de la sous-catégorie',
            namePlaceholder: 'Ex : Burgers, Desserts...',
            slugLabel: 'Slug personnalisé',
            slugPlaceholder: 'Ex : burgers-maison',
            illustrationLabel: 'Illustration',
            chooseImage: 'Choisir une image ou glissez-déposez votre fichier',
            uploadText: 'Cliquez pour importer ou glissez-déposez votre fichier',
            formatText: 'JPG, JPEG, PNG - moins de 5 Mo',
            validate: 'Valider',
            successCategory: 'Catégorie créée avec succès',
            successSubcategory: 'Sous-catégorie créée avec succès',
        },
        validation: {
            nameRequired: 'Le nom est obligatoire',
            slugRequired: 'Le slug est obligatoire',
        },
    },
    productSupplier: {
        title: 'Fournisseurs',
        table: {
            name: 'Nom',
            email: 'Email',
            phone: 'Téléphone',
            ref: 'Référence',
            address: 'Adresse',
            actions: 'Actions',
        },
        actions: {
            create: 'Ajouter',
            edit: 'Modifier',
            delete: 'Supprimer',
            deleteSelection: 'Supprimer la sélection',
            export: 'Exporter',
        },
        createPopup: {
            title: 'Ajouter un fournisseur',
            editTitle: 'Modifier un fournisseur',
            nameLabel: 'Nom',
            namePlaceholder: 'Ex : Mon Fournisseur',
            emailLabel: 'Email',
            emailPlaceholder: 'Ex : contact@fournisseur.com',
            phoneLabel: 'Téléphone',
            phonePlaceholder: 'Ex : 0123456789',
            refLabel: 'Référence',
            refPlaceholder: 'Ex : REF-123',
            addressLabel: 'Adresse',
            addressPlaceholder: 'Ex : 123 Rue Principale',
            validate: 'Valider',
            success: 'Fournisseur créé avec succès',
        },
        validation: {
            nameRequired: 'Le nom est obligatoire',
            emailRequired: "L'email est obligatoire",
            phoneRequired: 'Le téléphone est obligatoire',
            refRequired: 'La référence est obligatoire',
            addressRequired: "L'adresse est obligatoire",
        },
        deletePopup: {
            title: 'Supprimer le fournisseur',
            message: 'Êtes-vous sûr de vouloir supprimer ce fournisseur ? Cette action est irréversible.',
            cancel: 'Annuler',
            confirm: 'Supprimer',
        },
    },
    productBrand: {
        title: 'Marques',
        table: {
            name: 'Nom',
            email: 'Email',
            phone: 'Téléphone',
            actions: 'Actions',
        },
        actions: {
            create: 'Ajouter',
            edit: 'Modifier',
            delete: 'Supprimer',
            deleteSelection: 'Supprimer la sélection',
            export: 'Exporter',
        },
        createPopup: {
            title: 'Ajouter une marque',
            nameLabel: 'Nom',
            namePlaceholder: 'Ex : Ma Marque',
            emailLabel: 'Email',
            emailPlaceholder: 'Ex : contact@marque.com',
            phoneLabel: 'Téléphone',
            phonePlaceholder: 'Ex : 0123456789',
            validate: 'Valider',
            success: 'Marque créée avec succès',
        },
        editPopup: {
            title: 'Modifier la marque',
            success: 'Marque modifiée avec succès',
        },
        validation: {
            nameRequired: 'Le nom est obligatoire',
            emailRequired: "L'email est obligatoire",
            phoneRequired: 'Le téléphone est obligatoire',
        },
        deletePopup: {
            title: 'Supprimer la marque',
            message: 'Êtes-vous sûr de vouloir supprimer cette marque ? Cette action est irréversible.',
            cancel: 'Annuler',
            confirm: 'Supprimer',
        },
    },
    food: {
        title: 'Restauration',
        sellingPrice: 'Prix de vente',
        vat_rate: 'TVA',
        noCategory: 'Aucune catégorie',
        navigation: {
            products: 'Produits',
            menu: 'Catalogue',
            categories: 'Catégories',
            packs: 'Formules',
            options: 'Variantes & Extras',
            tables: 'Tables & QR Codes',
            options_supplements: 'Variantes & Extras',
            qr_codes: 'Tables & QR Codes',
            table_categories: 'Catégories de tables',
            tags: 'Tags',
        },
        status: {
            active: 'Actif',
            inactive: 'Inactif',
        },
        columns: {
            name: 'Nom',
            price: 'Prix',
            category: 'Catégorie',
            type: 'Type',
            status: 'Statut',
            stock: 'Stock',
            actions: 'Actions',
        },
        options: {
            add_option: 'Ajouter une variante',
            add_supplement: 'Ajouter un extra',
            info_option: 'Les variantes permettent à vos clients de personnaliser leurs produits (ex: cuisson, sauce, etc.).',
            type: 'Type',
            select_type: 'Sélectionner un type',
            name_label: 'Nom',
            name_placeholder: 'Ex: Cuisson, Sauce...',
            price_label: 'Prix',
            description_label: 'Description',
            description_placeholder: 'Description de la variante...',
            modal_title_option: 'Modifier la variante',
            info_option_group: 'Créez un groupe de variantes pour permettre à vos clients de choisir parmi plusieurs choix.',
            group_name_label: 'Nom du groupe',
            group_name_placeholder: 'Ex: Choisissez votre cuisson',
            option_item_placeholder: 'Nom de la variante',
            modal_title_supplement: "Modifier l'extra",
            info_supplement_group:
                'Les extras sont des produits additionnels que vos clients peuvent ajouter (ex: frites, boisson, etc.).',
            supplement_name_label: "Nom de l'extra",
            supplement_name_placeholder: 'Ex: Choisissez vos accompagnements',
            min_quantity: 'Quantité min',
            max_quantity: 'Quantité max',
            optional: 'Optionnel',
            supplement_item_placeholder: "Nom de l'extra",
            included: 'Inclus',
            required: 'Obligatoire',
            limit_one: 'Limiter à 1',
            add_modal_title: 'Ajouter',
            unclassified: 'Non catégorisé',
            info_addon_modal_addon:
                'Le client peut choisir <strong>un ou plusieurs extras</strong> parmi ceux proposés.<br />Le choix est <strong>facultatif</strong> et chaque extra peut avoir un prix spécifique.',
            info_addon_modal_option:
                'Le client doit choisir <strong>une seule variante</strong> parmi celles proposées.<br />Le choix est <strong>obligatoire</strong> et chaque variante peut avoir un prix spécifique.',
            option_category_name_label: 'Nom de la catégorie de la variante',
            addon_category_placeholder: 'Ex: Sauces, Garnitures...',
            option_category_placeholder: 'Ex: Taille, Cuisson...',
            choice_name_placeholder: 'Nom du choix',
            create_supplement: 'Créer un groupe d’extras',
        },
        tables: {
            title: 'QR Codes',
            add_modal_title: 'Ajouter un QR Code',
            edit_modal_title: 'Modifier un QR Code',
            download_qr: 'Télécharger le code QR',
            info_message: 'Créez un QR code pour partager facilement votre carte avec vos clients.',
            count_label: 'Nombre de QR Codes à générer',
            count_placeholder: '0',
            categories_label: 'Catégories cibles',
            categories_placeholder: 'Toute la carte (par défaut)',
            name_label: 'Nom',
            name_placeholder: 'Nom du QR Code',
            columns: {
                name: 'Nom',
                order_link: 'Lien de commande',
                actions: 'Actions',
            },
            delete_single_confirm: 'Supprimer ce QR Code ?',
            delete_multiple_confirm: 'Supprimer {count} QR Code(s) ?',
            duplicate_confirm: 'Êtes-vous sûr de vouloir dupliquer ce QR Code ?',
            duplicate_success: 'QR Code dupliqué avec succès',
            update_success: 'QR Code modifié avec succès',
            create_success: 'QR Codes créés avec succès',
            copy_link_title: 'Copier le lien',
            download_all_qr: 'Exporter les QR Codes',
            selected_items: '{count} sélectionné(s)',
            errors: {
                generic: 'Erreur',
                duplicate: 'Erreur lors de la duplication',
                update: 'Erreur lors de la modification du QR Code',
                create: 'Erreur lors de la création des QR Codes',
                export: "Une erreur est survenue lors de l'exportation.",
            },
            added_success: 'Tables ajoutées avec succès',
            select_at_least_one: 'Veuillez sélectionner au moins une table.',
            deleted_success: 'Table supprimée avec succès',
            order_cutoff: {
                label: 'Fin des commandes',
                block_title: 'Bloquer les commandes à table',
                disabled: 'Désactivé',
                min_before_close: '{count} min avant la fermeture',
                short_min_before: '{count} min avant',
                one_hour_before_close: '1 h avant la fermeture',
                short_one_hour: '1 h avant',
                save_success: 'Commande bloquée {count} min avant la fermeture',
                disabled_success: 'Blocage des commandes désactivé',
                save_error: 'Erreur lors de la sauvegarde',
                today_last_order: "Aujourd'hui - dernière commande à {time}",
                closed_today: "Fermé aujourd'hui",
            },
        },
        table_categories: {
            columns: {
                category: 'Catégorie',
                tables: 'Tables',
                actions: 'Actions',
            },
            add_title: 'Ajouter une catégorie de tables',
            edit_title: 'Modifier la catégorie de tables',
            name_label: 'Nom',
            save: 'Enregistrer',
            delete_title: 'Supprimer la catégorie',
            delete_cancel: 'Annuler',
            delete_confirm: 'Supprimer',
            confirm_delete: 'Confirmer la suppression de cette catégorie ?',
            confirm_delete_multiple: 'Confirmer la suppression de {count} catégorie(s) ?',
            linked_tables: '{count} table(s) seront remises sans catégorie. Confirmer la suppression ?',
            selected: '{count} catégorie sélectionnée | {count} catégories sélectionnées',
            added_success: 'Catégorie ajoutée avec succès.',
            updated_success: 'Catégorie modifiée avec succès.',
            deleted_success: 'Catégorie(s) supprimée(s) avec succès.',
            save_error: "Erreur lors de l'enregistrement de la catégorie.",
            delete_error: 'Erreur lors de la suppression.',
            export_error: "Erreur lors de l'export.",
        },
        messages: {
            confirm_bulk_tags: 'Gérez {count} tag(s)',
            confirm_bulk_category: 'Gérez {count} catégorie(s)',
            load_error: 'Impossible de charger les détails',
            save_error: "Erreur lors de l'enregistrement",
            delete_error: 'Erreur lors de la suppression',
            create_error: 'Erreur lors de la création',
            status_update_error: 'Erreur lors de la mise à jour du statut',
            export_error: "Une erreur est survenue lors de l'exportation.",
            confirm_delete_option: 'Êtes-vous sûr de vouloir supprimer cette variante ?',
            confirm_delete_options: 'Êtes-vous sûr de vouloir supprimer {count} variante(s) ?',
            name_required: 'Le nom est obligatoire',
            option_name_required: 'Le nom de la variante est obligatoire',
            option_item_name_required: 'Le nom de la variante {index} est obligatoire',
            option_item_price_required: 'Le prix de la variante {index} doit être supérieur à 0',
            supplement_name_required: "Le nom de l'extra est obligatoire",
            selected_items: '{count} élément sélectionné | {count} éléments sélectionnés',
            confirm_bulk_discount: 'Appliquer une remise sur les {count} produits sélectionnés',
            confirm_delete_product: 'Êtes-vous sûr de vouloir supprimer ce produit ?',
            confirm_delete_products: 'Êtes-vous sûr de vouloir supprimer {count} produit(s) ?',
            confirm_delete_category: 'Êtes-vous sûr de vouloir supprimer cette catégorie ?',
            confirm_delete_categories: 'Êtes-vous sûr de vouloir supprimer {count} catégorie(s) ?',
            confirm_duplicate_category: 'Êtes-vous sûr de vouloir dupliquer cette catégorie ?',
            product_saved_success: 'Produit enregistré avec succès',
            product_save_error: "Erreur lors de l'enregistrement du produit",
            confirm_duplicate_option: 'Êtes-vous sûr de vouloir dupliquer cette variante ?',
            confirm_duplicate_supplement: 'Êtes-vous sûr de vouloir dupliquer cet extra ?',
            option_duplicated_success: 'Variante dupliquée avec succès',
            supplement_duplicated_success: 'Extra dupliqué avec succès',
            duplicate_error: 'Erreur lors de la duplication',
            save_success: 'Produit enregistré avec succès',
        },
        carte: {
            title: 'Produits',
            clear_filter: 'Effacer le filtre',
            add: 'Créer',
            add_product: 'Créer un produit',
            add_pack: 'Créer une formule',
            select: 'Sélectionner',
            create_category: 'Créer une catégorie',
            bulk: {
                edit_category: 'Modifier catégorie',
                edit_tag: 'Modifier tag',
                apply_discount: 'Appliquer une remise',
                discount_percent: 'Remise (%)',
                discount_amount: 'Montant ({symbol})',
                discount_type: 'Type de remise',
                percentage: 'Pourcentage (%)',
                fixed_amount: 'Montant fixe ({symbol})',
                value: 'Valeur',
                tags_label: 'Tags',
                tags_placeholder: 'Sélectionner ou créer des tags...',
            },
            savingPositions: 'Veuillez attendre la fin de la sauvegarde en cours...',
            positions_updated: 'Ordre mis à jour avec succès',
        },
        categories: {
            columns: {
                subcategories_count: 'Nbr. sous-catégories',
                content: 'Nbr. produits',
            },
            bulk: {
                edit_tag: 'Modifier tag',
            },
            modal: {
                title_create: 'Ajouter une catégorie',
                title_edit: 'Modifier la catégorie',
                title_create_sub: 'Ajouter une sous-catégorie',
                title_edit_sub: 'Modifier la sous-catégorie',
                name_label: 'Nom de la catégorie',
                name_placeholder: 'Ex : Burgers, Desserts...',
                name_label_sub: 'Nom de la sous-catégorie',
                name_placeholder_sub: 'Ex : Burger Classique, Frites...',
                parent_label: 'Catégorie parente',
                parent_placeholder: 'Sélectionnez une catégorie parente',
                slug_label: 'Slug personnalisé',
                slug_placeholder: 'Ex : burgers-maison',
                tags_label: 'Tags',
                tags_placeholder: 'Ajouter des tags...',
                status_label: 'État',
                active: 'Activé',
                inactive: 'Désactivé',
                color_label: "Couleur d'affichage sur la caisse",
                image_label: 'Image de la catégorie',
            },
            updated_success: 'La catégorie a été mise à jour avec succès !',
        },
        packForm: {
            name: 'Nom',
            namePlaceholder: 'Ex : Formule enfant, Formule gourmande, etc...',
            titleEdit: 'Modifier la formule',
            titleCreate: 'Ajouter une formule',
            imageLabel: 'Illustration',
            pricingTitle: 'Tarification',
            newPriceLabel: 'Nouveau prix',
            discountPercentLabel: 'Réduction en pourcentage',
            compositionTitle: 'Composez votre formule',
            compositionNameLabel: 'Nom',
            compositionNamePlaceholder: 'Ex : Accompagnement, Boisson, Dessert, etc...',
            compositionSelectPlaceholder: '- Sélectionner une ou plusieurs options -',
            activeLabel: 'Activer',
            showOnMenuLabel: 'Afficher sur la carte',
            viewOnMap: 'Voir la formule sur la carte',
            takeawayTitle: 'Disponible à emporter',
            availableDelivery: 'Disponible en livraison',
        },
        productForm: {
            titleEdit: 'Modifier le produit',
            titleCreate: 'Ajouter un produit',
            nameLabel: 'Nom',
            namePlaceholder: 'Ex: Burger Maison, Pizza Royale...',
            categoryLabel: 'Catégorie',
            categoryPlaceholder: '- Sélectionner une catégorie -',
            descriptionLabel: 'Description',
            descriptionPlaceholder: 'Décrivez votre produit...',
            imageLabel: 'Illustration',
            pricingTitle: 'Tarification',
            optionsTitle: 'Variantes',
            createOption: 'Créer un groupe de variantes',
            addOption: 'Ajouter une variante',
            option: 'Une variante',
            supplementsTitle: 'Extras',
            createSupplement: 'Créer un groupe d’extras',
            addSupplement: 'Ajouter un extra',
            boissonsTitle: 'Boissons',
            createBoisson: 'Créer une boisson',
            addBoisson: 'Ajouter une boisson',
            saucesTitle: 'Sauces',
            createSauce: 'Créer une sauce',
            addSauce: 'Ajouter une sauce',
            complementsTitle: 'Compléments',
            createComplement: 'Créer un complément',
            addComplement: 'Ajouter un complément',
            activeLabel: 'Activé',
            showOnMenuLabel: 'Afficher sur la carte',
            viewOnMap: 'Voir le produit sur la carte',
            stockTitle: 'Gestion du stock',
            stockLabel: 'Quantité en stock',
            stockPlaceholder: '0',
            stockInfo: 'Laissez vide ou 0 pour rupture de stock.',
            isOutOfStockLabel: 'Forcer la rupture de stock',
            isOutOfStockInfo: 'Activez cette option pour forcer l\'état "Rupture de stock", même si la quantité est positive.',
            stockUnlimited: 'Le stock est illimité pour ce produit.',
            takeawayTitle: 'Disponible à emporter',
            deliveryTitle: 'Disponible en livraison',
            back: 'Retour',
            availableValues: 'Valeurs disponibles',
            noValueConfigured: 'Aucune valeur configurée pour cette variante.',
            noChoiceConfigured: 'Aucun choix configuré pour ce groupe.',
        },
        packs: {
            created_success: 'Le pack a été créé avec succès',
            updated_success: 'Le pack a été mis à jour avec succès',
        },
        menus: {
            updated_success: 'Le menu a été mis à jour avec succès !',
            included_items_exceeds_supplements: "Le nombre d'élément(s) inclus doit être inférieur ou égal aux supplements",
            included_items_exceeds_drinks: "Le nombre d'élément(s) inclus doit être inférieur ou égal aux boissons",
            included_items_exceeds_sides: "Le nombre d'élément(s) inclus doit être inférieur ou égal aux compléments",
            included_items_exceeds_sauces: "Le nombre d'élément(s) inclus doit être inférieur ou égal aux sauces",
        },
        illustration: 'Illustration',
    },
    tags: {
        title: 'Tags',
        columns: {
            name: 'Nom',
            slug: 'Slug',
            foods_count: 'Nombre de produits',
            category_count: 'Nombre de catégories',
            printer: 'Imprimante',
            status: 'Statut',
            actions: 'Actions',
        },
        form: {
            name_label: 'Nom du tag',
            name_placeholder: 'Ex : Burgers, Desserts...',
            slug_label: 'Slug',
            slug_placeholder: 'Ex : burgers, desserts (laisser vide pour auto-générer)',
            printer_label: 'Imprimante',
            printer_placeholder: 'Sélectionnez une imprimante',
            status_label: 'État',
            status_active: 'Activé',
            status_inactive: 'Désactivé',
            modal_title_create: 'Ajouter un tag',
            modal_title_edit: 'Modifier le tag',
        },
        actions: {
            create: 'Ajouter',
            edit: 'Modifier',
            delete: 'Supprimer',
            deleteSelection: 'Supprimer la sélection',
            export: 'Exporter',
            confirm_bulk_printer: "Modifier l'imprimante pour les {count} tags sélectionnés",
            confirm_delete_tag: 'Confirmer la suppression du tag',
            confirm_delete_tags: 'Confirmer la suppression des tags sélectionnés',
        },
        create_success: 'Le tag créé avec succès !',
        update_success: 'Le tag a été mis à jour avec succès !',
    },
    statistics: {
        welcome: 'Hello',
        welcomeSuffix: 'voici vos performances',
        lastUpdate: 'Dernière mise à jour il y a',
        minutes: 'minutes',
        vsLastWeek: 'Vs semaine dernière',
        experiences: 'Expériences',
        dateRange: {
            today: "Aujourd'hui",
            yesterday: 'Hier',
            last7Days: '7 derniers jours',
            last30Days: '30 derniers jours',
            custom: 'Choisir',
            selectPeriod: 'Sélectionner une période',
        },
        kpi: {
            caRealise: 'CA réalisé',
            caEncaisse: 'CA encaissé',
            panierMoyen: 'Panier moyen',
            entrees: 'Entrées réalisées',
        },
        charts: {
            turnover: "Chiffre d'affaires",
            paymentMethods: 'Moyens de paiement',
            salesTypes: 'Types de vente',
            productTypes: 'Types de produit',
            prestationTypes: 'Types de prestation',
            bookingStats: 'Statistiques réservations',
            occupancyRate: "Taux d'occupation",
            honored: 'Réservations honorées',
            noshow: 'No-show',
            cancelled: 'Annulations',
            salesStats: 'Statistiques de ventes',
            topSales: 'Meilleures ventes',
            clientStats: 'Statistiques clients',
            clientBase: 'Base clients',
            frequencyStats: 'Statistiques de fréquentation',
            frequency: 'Fréquentation',
        },
        legend: {
            encaisse: 'Encaissé',
            realise: 'Réalisé',
            currentYear: 'N',
            previousYear: 'N-1',
        },
        clientStats: {
            men: 'Hommes',
            women: 'Femmes',
            retentionRate: 'Taux de rétention',
            newClients: 'Nouveaux clients',
            noShowRate: 'Taux de no-show',
            cancellationRate: "Taux d'annulation",
            subscribers: 'Abonnés aux communications',
        },
        frequencyStats: {
            todayBookings: "Réservations aujourd'hui",
            mostRequestedSlot: 'Créneau le plus demandé',
            occupancyRate: "Taux d'occupation",
            averageVisitTime: 'Temps moyen de visite',
            peakTime: 'Pic de fréquentation',
            average: 'En moyenne',
            vsYesterday: 'Vs hier',
        },
        salesMiniStats: {
            tickets: 'Tickets',
            orders: 'Commandes',
            groupSize: 'Taille moyenne des groupes',
        },
        downloadExcel: 'Télécharger Excel',
        loading: 'Chargement des données...',
        noData: 'Aucune donnée disponible',
        error: 'Erreur lors du chargement des données',
        total: 'Total',
        ttc: 'TTC',
        ht: 'HT',
    },
    dashboard: {
        greeting: {
            hello: 'Hello',
            morning: 'Bonjour',
            evening: 'Bonsoir',
        },
        periods: {
            today: "Aujourd'hui",
            tomorrow: 'Demain',
            yesterday: 'Hier',
            choose: 'Choisir',
            last7Days: 'Les 7 derniers jours',
            thisMonth: 'Ce mois-ci',
            thisYear: 'Cette année',
        },
        kpis: {
            upcomingReservations: 'Réservations à venir',
            completedEntries: 'Entrées réalisées',
            noShows: 'No-shows',
            cancellations: 'Annulations',
            vsYesterday: 'Vs hier',
        },
        tables: {
            arrivingToday: "Ils arrivent aujourd'hui",
            orderedToday: 'Dernières ventes',
            viewCalendar: 'Voir le calendrier',
            viewAll: 'Voir tout',
            hour: 'Heure',
            reservation: 'Réservation',
            client: 'Client',
            count: 'Nbr.',
            quantity: 'Nbr./Qté',
            status: 'Statut',
            note: 'Note',
            name: 'Nom',
            empty: 'Aucune réservation',
            anonymous: 'Anonyme',
            reservation_id: 'Réservation #{id}',
            order_id: 'Commande #{id}',
            vue_stats: 'Vue statistiques',
            vue_ops: 'Vue opérationnelle',
        },
        statuses: {
            paid: 'Payée',
            pending: 'À payer',
            partial: 'Reste à payer',
            cancelled: 'Annulée',
            confirmed: 'Confirmée',
            noshow: 'No-show',
        },
        trends: {
            title: 'Tendances de réservations',
            today: "Aujourd'hui",
            tomorrow: 'Demain',
            nextSaturday: 'Samedi prochain',
            nextSunday: 'Dimanche prochain',
        },
        delays: {
            title: 'Délais moyens avant réservation',
            days: 'jours',
            vsLastWeek: 'Vs semaine dernière',
        },
        tooltip: {
            reservation: 'Réservation',
            confirmed: 'Confirmée',
            viewDetail: 'Voir détail',
            modify: 'Modifier',
            cancel: 'Annuler',
            total: 'Total',
            formula: 'Formule',
            persons: 'personnes',
            room: 'Salle',
        },
        loading: 'Chargement...',
        noData: 'Aucune info disponible pour le moment',
        takeReservation: 'Prendre une réservation',
    },
    sidebar: {
        dashboard: 'Tableau de bord',
        calendar: 'Calendrier',
        nomad_checkout: 'Caisse nomade',
        nomad_checkout_v3: 'Caisse nomade V3',
        sales: 'Ventes',
        customers: 'Clients',
        quotes: 'Devis',
        orders: 'Commandes',
        invoices: 'Factures et avoirs',
        marketing: 'Marketing',
        promo_codes: 'Codes promo',
        abandoned_cart: 'Paniers abandonnés',
        premium_badge: 'Premium',
        newsletters: 'Campagnes email',
        auto_mails: 'Mails automatiques',
        push_notifications: 'Notifications push',
        blog: 'Blog',
        team: 'Équipe',
        planning: 'Planning',
        users: 'Utilisateurs',
        roles_access: 'Rôles & accès',
        rewards: 'Récompenses',
        accounting: 'Comptabilité',
        exports: 'Exports',
        sales_reports: 'Rapports de ventes',
        settings: 'Paramètres',
        establishment: 'Établissement',
        experiences: 'Expériences',
        quote_templates: 'Modèles de devis',
        installations: 'Installations',
        website: 'Site Internet',
        widgets: 'Widgets',
        products: 'Ventes additionnelles',
        restoration: 'Catalogue POS',
        tables_qr_codes: 'Tables & QR Codes',
        google_calendar: 'Google Agenda',
        pos_devices: 'Points de vente (POS)',
        api: 'API',
        api_documentation: 'Documentation API',
        support: 'Support',
        client: 'Clients',
        annonces: 'Annonces',
        formQuestion: 'Demandes de devis',
        resource: 'Ressources',
        integration: 'Intégrations',
    },
    navbar: {
        light_theme: 'Thème clair',
        dark_theme: 'Thème sombre',
        manage_account: 'Gérer mon compte',
        change_account: 'Changer de compte',
        subscription_billing: 'Abonnement',
        product_news: 'Actualités produits',
        help_center: 'Support',
        training_solutions: 'Formations et solutions',
        referral: 'Parrainage',
        offered: 'offerts',
        days_remaining: 'jour restant | jours restants',
        logout: 'Se déconnecter',
    },
    header: {
        titles: {
            editViewEstablishmentV2: 'Paramètres',
            indexViewEquipementsV3: 'Équipements',
            indexViewFoodV3: 'Catalogue',
            indexViewProductV3: 'Produits',
            createProductV3: 'Ajouter un produit',
            editProductV3: 'Modifier un produit',
            default: 'Page',
            adminHome: 'Tableau de bord',
            adminPlanning: 'Calendrier',
            getCheckouts: 'Caisse nomade',
            getCustomersBOV2: 'Ventes',
            getDevis: 'Ventes',
            getInvoices: 'Ventes',
            getPromotions: 'Marketing',
            newsletters_index: 'Marketing',
            getMailsCustoms: 'Marketing',
            notifications_index: 'Marketing',
            blog_list: 'Marketing',
            staffPlanning: 'Planning du personnel',
            getStaffs: 'Utilisateurs',
            getRoles: 'Rôles',
            GamificationViewAll: 'Récompenses',
            getStats: 'Comptabilité',
            list_categ: 'Paramètres',
            getSpaces: 'Paramètres',
            getWebsiteSettings: 'Paramètres',
            widgets_index: 'Paramètres',
            getProduit: 'Paramètres',
            bo_foods_index: 'Paramètres',
            google_calendar: 'Paramètres',
            adminIndexPos: 'Paramètres',
            adminIndexApplication: 'Paramètres',
            getInvoicesV2: 'Ventes',
            getInvoicesV3: 'Ventes',
            getInvoicesEnAttente: 'Ventes',
            indexViewExperienceV3: 'Expériences',
        },
    },
    serie: {
        step_label: 'Étape',
        step1: {
            subtitle: 'Informations générales',
            content: 'Créer un abonnement',
            name_label: "Nom de l'abonnement",
            name_placeholder: 'Donnez un nom à votre abonnement',
            description_label: 'Description de votre abonnement',
            description_placeholder: 'Décrivez votre abonnement (optionnel)',
            image_label: "Illustration de l'abonnement",
            validation: {
                name_required: 'Ce champ est obligatoire',
                description_required: 'Ce champ est obligatoire',
            },
            error_save: 'Erreur lors de la sauvegarde des informations générales',
        },
        notifications: {
            success_add: "l'abonnement a été ajouté avec succès",
            success_update: "l'abonnement a été modifié avec succès",
            validationStepFirst: "Veuillez valider l'étape actuelle avant de continuer.",
        },
        step2: {
            subtitle: 'Règles d’utilisation',
            content: '',
            renewal_period: 'Période de renouvellement',
            subscription_duration: 'Durée de l’abonnement',
            end_date_optional: 'Date de fin (optionnelle)',
            auto_renewal: 'Renouvellement automatique',
            accumulate_prestations: 'Cumuler les prestations lors du renouvellement',
            included_usages: 'Utilisations incluses (à chaque renouvellement)',
            limit_total_usages: "Limiter le nombre total d'utilisations",
            limit_peak_hours: 'Limiter le nombre d’utilisations en heures pleines',
            limit_off_peak_hours: 'Limiter le nombre d’utilisations en heures creuses',
            allow_peak_for_off_peak: 'Les heures pleines peuvent être consommées pendant les heures creuses',
            limit_usage_rate: 'Limiter le rythme d’utilisation',
            per_period: 'Par période',
            limit_max_peak_per_period: "Limiter nombre maximum d'heures pleines par période",
            limit_max_off_peak_per_period: "Limiter nombre maximum d'heures creuses par période",
            limit_access_experiences: 'Choisir les expériences accessibles via l’abonnement',
            add_activity: 'Ajouter une activité',
            select_activity: 'Sélectionner une activité',
            duration: 'Durée',
            select_duration: 'Sélectionner la durée...',
            choice: 'Choix',
            tickets: {
                participant_label: 'Par participant',
                participant_subtitle: 'Le forfait est vendu par place, chaque participant doit disposer de son propre billet.',
                space_label: 'Par espace',
                space_subtitle:
                    'Le forfait s’applique à l’ensemble de l’espace réservé, quel que soit le nombre de participants.',
            },
            options: {
                week: 'Semaine',
                month: 'Mois',
                days_7: '7 jours',
                days_15: '15 jours',
                month_1: '1 mois (30 jours)',
                month_2: '2 mois (60 jours)',
                month_3: '3 mois (90 jours)',
                month_4: '4 mois (120 jours)',
                month_6: '6 mois (180 jours)',
                year_1: '1 an (365 jours)',
            },
            validation: {
                add_one_activity: 'Veuillez ajouter au moins une activité',
                complete_all_activities: 'Veuillez compléter toutes les activités',
            },
            error_save: 'Erreur lors de la sauvegarde de la configuration',
        },
        step3: {
            subtitle: 'Tarification',
            content: '',
            price: 'Prix',
            vat: 'Taux de TVA',
            pricing_title: 'Tarif de l’abonnement',
            price_ht: 'Prix HT',
            select: 'Sélectionner...',
            validation: {
                price_required: 'Veuillez définir un prix de vente',
                vat_required: 'Veuillez sélectionner un taux de TVA',
                duration_required: 'Veuillez sélectionner une durée',
            },
            error_save: 'Erreur lors de la sauvegarde de la tarification',
        },
        step4: {
            subtitle: 'Activités',
            content: '',
        },
        step5: {
            subtitle: 'Options',
            content: '',
            online_display: 'Mise en ligne et affichage',
            visible_label: 'Rendre cet abonnement visible à mes clients',
            ticketing_options: 'Options de billetterie',
            undated_label: 'Proposer cet abonnement en billet non daté',
            success_save: 'Abonnement enregistré avec succès',
            error_save: "Erreur lors de la finalisation de l'abonnement",
        },
        preview: {
            live_preview: 'Prévisualisation en direct',
            estimated_time: 'Temps total estimé',
            minutes: 'minutes',
            subscription_name: "Nom de l'abonnement",
            subscription_description: 'Description de votre abonnement',
            hours_config: 'Configuration heures',
            peak_hours: 'Heures pleines',
            off_peak_hours: 'Heures creuses',
            price_label: "Prix de l'abonnement",
            price_value: 'Prix : {price}{symbol}',
            vat: 'TVA',
            undated_ticket: 'Billet non daté',
            visible_online: 'Visible en ligne',
            hidden_online: 'Masqué en ligne',
        },
    },
    registration: {
        welcome: 'Bienvenue sur PlayPro',
        welcome_text: 'Passez au niveau supérieur — rejoignez PlayPro et commencez à créer des expériences incroyables.',
        play_like_pro_text:
            'Améliorez votre flux de travail — découvrez nos fonctionnalités pour planifier, suivre, gérer, rapporter et connecter. Tous les outils, en un seul endroit.',
        no_credit_card: 'Aucune carte de crédit requise pour commencer.',
        where_is_located: 'Où est situé votre établissement?',
        other_country: 'Autre pays',
        personal_info: 'Informations personnelles',
        tell_us_more: 'Parlez-nous un peu de vous',
        create_workspace: 'Créez votre espace de travail',
        configure_access: 'Configurez votre accès sécurisé et votre adresse personnalisée.',
        ready_to_launch: 'Prêt à décoller ?',
        final_step: 'Dernière étape',
        seconds_away: "Plus que quelques secondes avant d'accéder à votre nouvel outil de travail.",
        finish_registration: "Terminer l'inscription",
        creating_account: 'Création en cours...',
        back: 'Retour',
        next: 'Continuer la configuration',
        terms_label: "J'accepte les {cgvu} et la {privacy}.",
        offers_label: 'Je souhaite recevoir des conseils et offres exclusives pour mon activité.',
        start_now: 'Démarrer maintenant',
        testimonials_title: 'Des témoignages authentiques de professionnels - découvrez pourquoi ils adorent PlayPro.',
        play_like_pro: 'Jouez comme un Pro.',
        create_account: 'Créez votre compte',
        subdomain_label: 'URL de votre site de réservation',
        subdomain_description:
            'C’est l’adresse que vos clients utiliseront pour réserver en ligne. Vous pourrez configurer un domaine personnalisé plus tard.',
        subdomain_hint: 'Veuillez saisir uniquement des lettres, des chiffres et des tirets.',
        password_label: 'Mot de passe',
        confirm_password_label: 'Confirmer le mot de passe',
        privacy_policy: 'politique de confidentialité',
        terms_suffix: 'CGVU',
        your_store: 'Votre boutique',
        administration: 'Administration',
        firstName: 'Prénom',
        lastName: 'Nom',
        email: 'Adresse email professionnelle',
        phone: 'Téléphone',
        company: "Nom légal de l'entreprise",
        company_address: 'Adresse du siège',
        city: 'Ville',
        country: 'Pays',
        placeholders: {
            firstName: 'Jean',
            lastName: 'Dupont',
            email: 'jean.dupont@entreprise.fr',
            phone: '06 00 00 00 00',
            company: 'Ma Super Entreprise',
            company_address: '123 rue de la Paix, Paris',
            city: 'Paris',
            subdomain: 'nom-etablissement',
            password: 'Au moins 8 caractères',
            country: 'Pays',
        },
        validation: {
            subdomain_format: 'Format invalide (seules les lettres, chiffres et tirets sont autorisés).',
            subdomain_unavailable: 'Ce nom est déjà utilisé.',
            password_length: 'Le mot de passe doit contenir au moins 8 caractères.',
            password_mismatch: 'Les mots de passe ne correspondent pas.',
        },
        countries: {
            FR: 'France',
            BE: 'Belgique',
            LU: 'Luxembourg',
            CH: 'Suisse',
            US: 'États-Unis',
            GB: 'Royaume-Uni',
            ES: 'Espagne',
            IT: 'Italie',
            AD: 'Andorre',
            GP: 'Guadeloupe',
            MQ: 'Martinique',
            RE: 'La Réunion',
            PF: 'Polynésie française',
            NC: 'Nouvelle-Calédonie',
            CA: 'Canada',
            MG: 'Madagascar',
            OTHER: 'Autre pays',
        },
        reviews: {
            title: 'Approuvé par des leaders mondiaux.',
            subtitle: "PlayPro aide déjà plus de 5,000 établissements à travers l'Europe à digitaliser leur expérience client.",
            quote1: "PlayPro a totalement transformé notre manière de gérer les réservations. C'est intuitif et extrêmement puissant.",
            author1: 'Marc Robs',
            role1: 'Directeur Sports Club',
            quote2: "Le support est exceptionnel et l'interface est la plus propre que j'ai pu voir sur le marché.",
            author2: 'Jane Copper',
            role2: 'Manager Centre Aquatique',
            quote3: "Le processus d'onboarding de PlayPro est le plus simple que j'ai jamais utilisé. En 2 minutes, tout était configuré et prêt.",
            author3: 'Camila Souza',
            role3: 'Gestionnaire de Franchise',
            quote4: 'Une solution complète qui nous fait gagner des heures chaque semaine. Incontournable pour tout gestionnaire.',
            author4: 'Antoine Leroy',
            role4: 'CEO Fitness Group',
        },
        email_verification_error: "Une erreur est survenue lors de la vérification de l'email.",
        subdomain_setup_later: 'Vous pourrez configurer un domaine personnalisé plus tard.',
    },
    profil: {
        canBeClient: 'Attribuer le rôle de client ',
        title: 'Mon profil',
        first_name: {
            label: 'Prénom',
            placeholder: 'Entrez un prénom',
            required: 'Le prénom est obligatoire.',
        },
        last_name: {
            label: 'Nom',
            placeholder: 'Entrez un nom',
            required: 'Le nom est obligatoire.',
        },
        email: {
            label: 'Email',
            placeholder: 'Entrez un email',
            required: "L'email est obligatoire.",
        },
        phone_number: {
            label: 'Téléphone',
            placeholder: 'Entrez un numéro de téléphone',
            required: 'Le numéro de téléphone est obligatoire.',
        },
        pin: {
            label: 'Code PIN caisse',
            placeholder: 'Entrez un code PIN',
            required: 'Le code PIN est obligatoire.',
        },
        edit: 'Modifier',
        edit_profile: 'Modifier mon profil',
        change_password: 'Modifier mon mot de passe',
        admin: 'Admin',
        user: 'Utilisateur',
        password_modal: {
            title: 'Modifier le mot de passe',
            current: 'Mot de passe actuel',
            new: 'Nouveau mot de passe',
            confirm: 'Confirmer le nouveau mot de passe',
            current_placeholder: 'Entrez votre mot de passe actuel',
            new_placeholder: 'Entrez votre nouveau mot de passe',
            confirm_placeholder: 'Confirmez votre nouveau mot de passe',
        },
    },
    exports_v3: {
        comptable_title: 'Documents comptables',
        comptable_description:
            "Documents officiels destinés à la comptabilité et à l'expert-comptable : écritures comptables (FEC), rapports de ventes et factures de ventes PDF.",
        date_range_label: 'Date ou période',
        ticket_x_period_hint: 'Période : la journée en cours, depuis la dernière clôture de caisse.',
        document_label: 'Document',
        options: {
            ticket_z_pdf: 'Ticket Z (PDF)',
            fec: 'Écritures comptables',
            ticket_z_excel: 'Ticket Z (Excel)',
            factures_pdf: 'Factures de ventes (PDF)',
            ticket_x_encaissements: 'Ticket X des encaissements (PDF)',
            ticket_x_ventes: 'Ticket X des ventes (PDF)',
            ticket_x_encaissements_excel: 'Ticket X des encaissements (Excel)',
            ticket_x_ventes_excel: 'Ticket X des ventes (Excel)',
            mes_commandes: 'Mes commandes (Excel)',
            reservations: 'Réservations (Excel)',
        },
        operationnel_title: 'Rapports opérationnels',
        operationnel_description:
            "Visualisez l'activité du jour et contrôlez vos caisses. Non comptables – à usage interne uniquement.",
        report_label: 'Rapport',
        history_title: 'Historique',
        columns: {
            file: 'Fichier',
            period: 'Période',
            generated_at: 'Généré le',
            size: 'Taille',
            generated_by: 'Généré par',
            action: 'Action',
        },
        messages: {
            fetch_history_error: "Erreur lors du chargement de l'historique",
            select_dates_error: 'Veuillez sélectionner une date de début et une date de fin.',
            export_success: 'Export lancé avec succès!',
            export_error: 'Erreur lors de la génération du document',
            operationnel_success: 'Rapport opérationnel généré!',
            operationnel_error: 'Erreur lors de la génération du rapport',
            download_error: 'Lien de téléchargement indisponible',
        },
        period_popup: {
            title: 'Période non disponible',
            message:
                'Le téléchargement ne peut être effectué en une fois sur la période sélectionnée. Veuillez sélectionner une période se terminant ou débutant au 1er juin 2026.',
            button: "D'accord",
        },
        generate: 'Générer',
    },
    promotions: {
        in_use: {
            title: 'Supprimer ce code promo ?',
            description:
                "Il est actuellement utilisé sur {count} devis en attente. Vous pouvez le désactiver (il reste sur ces devis, mais n'est plus proposé pour de nouveaux) ou le révoquer (il en est également retiré).",
            disable: 'Désactiver seulement',
            revoke: 'Révoquer sur les devis',
        },
        title_promotion: 'Codes promo',
        add: 'Ajouter un code promotionnel',
        edit: 'Modifier un code promotionnel',
        btn_add: 'Créer',
        not_defined: 'Non défini',
        every_day: 'Tous les jours',
        description: 'Gérez vos codes promotionnels et remises.',
        description_title: 'Description',
        description_placeholder: 'Décrivez votre code promotionnel (optionnel)',
        form_description: 'Configurez les détails de votre promotion, les limites d’utilisation et les articles liés.',
        no_expiration: 'Pas de date d’expiration',
        generate_randomly: 'Générer aléatoirement',
        title_eligibility: 'Éligibilité',
        number_of_uses: "Nombre d'utilisations",
        total_uses: "Nombre total d'utilisations",
        uses_per_user: 'Définir un nombre maximal d’utilisations par client',
        unlimited_uses: 'Illimité',
        validation_uses_required: "Le nombre d'utilisations est obligatoire.",
        amount_limits: 'Limites de montant',
        min_amount: 'Montant minimum du panier',
        max_amount: 'Montant maximum du panier',
        options: 'Options',
        back_office_only: 'Caisse uniquement (Back-office)',
        has_linked_items: 'Limiter l’utilisation à une catégorie ou expérience',
        linked_items_configuration: 'Configuration des articles liés',
        prestation_categories: 'Catégories de prestations',
        product_categories: 'Catégories de produits',
        food_categories: 'Catégories de restauration',
        prestations: 'Prestations',
        products: 'Produits',
        packages: 'Forfaits',
        series: 'Séries',
        treatments: 'Abonnements',
        success: 'Succès',
        promotion_added: 'Promotion ajoutée avec succès',
        promotion_updated: 'Promotion mise à jour avec succès',
        promotion_deleted: 'Promotion supprimée avec succès',
        fetch_error: 'Erreur lors du chargement des promotions',
        promotion_enabled: 'Promotion activée',
        promotion_disabled: 'Promotion désactivée',
        delete_promotion_title: 'Supprimer la promotion',
        delete_promotion_confirm: 'Voulez-vous vraiment supprimer cette promotion ?',
        active: 'Actif',
        activated: 'Activé',
        disabled: 'Désactivé',
        expired: 'Expiré',
        no_expiration_date: 'Aucune',
        start_date: 'Date de début',
        end_date: 'Date de fin',
        discount_type: 'Type de réduction',
        discount_amount: 'Montant',
        discount_pourcent: 'Pourcentage',
        percentage: 'Pourcentage',
        fixed_amount: 'Montant fixe',
        main_information: 'Informations principales',
        code: 'Code',
        title: 'Nom interne',
        discount_details: 'Remise',
        repetition_by_days: 'Répétition par jours',
        apply_on_reservation_date: 'Appliquer sur la date de réservation',
        datatable: {
            title: 'Nom interne',
            code: 'Code',
            discount_type: 'Type de réduction',
            discount_amount: 'Réduction',
            start_date: 'Date de début',
            expiration_date: "Date d'expiration",
            status: 'Statut',
            actions: 'Actions',
            uses: 'Qté.',
            used: 'Nbr. utilisés',
        },
        actions: {
            edit: 'Modifier',
            enable: 'Activer',
            disable: 'Désactiver',
            delete: 'Supprimer',
        },
        linked_items: {
            prestation_categories: "Catégories d'expériences",
            product_categories: 'Catégories de produits',
            food_categories: 'Catégories de restauration',
            prestations: 'Expériences',
            products: 'Produits',
            packages: 'Forfaits',
            series: 'Abonnements',
            treatments: 'Abonnements',
            combo: 'Formules combinées',
            foods: 'Restauration (Carte)',
            foodPacks: 'Restauration (Menus)',
        },
        limit_order_type: "Limiter l'utilisation à un type de commande",
        order_types: {
            voucher: 'Bon cadeau',
            prestation: 'Expérience',
            product: 'Ventes additionnelle',
            food: 'Restauration',
        },
        reviews: {
            code: 'Code promo',
            uses: "Nombre d'utilisations",
            remise: 'Remise',
            expiration: 'Expiration',
            limit_per_user: "Limite d'utilisation par client",
            shop_min_amount: 'Panier minimum',
        },
        days: {
            mon: 'L',
            tue: 'M',
            wed: 'Me',
            thu: 'J',
            fri: 'V',
            sat: 'S',
            sun: 'D',
        },
        usage_limits: "Limites d'utilisation",
    },
    roles: {
        names: {
            admin: 'Administrateur',
            manager: 'Manager',
            operator: 'Opérateur',
            accounter: 'Comptable',
        },
        title: 'Rôles',
        add: 'Ajouter un rôle',
        edit: 'Modifier un rôle',
        general_info: 'Informations générales',
        display_name: "Nom d'affichage",
        unique_name: 'Nom interne',
        placeholder_display_name: 'Ex: Responsable',
        placeholder_unique_name: 'Ex: Manager',
        permissions: 'Permissions',
        select_all: 'Tout sélectionner',
        deselect_all: 'Tout déselectionner',
        user_assignment: 'Utilisateurs associés à ce rôle',
        no_users: 'Aucun utilisateur enregistré.',
        privileged_access_tooltip: 'Accorder comme privilège (bypass plan level)',
        accessible_with_plan: 'Accessible avec votre plan',
        higher_plan_required: 'Plan supérieur requis',
        access_granted_by_admin: "Accès accordé par l'administrateur",
        delete_title: 'Supprimer un rôle',
        delete_confirm_single: 'Voulez-vous vraiment supprimer ce rôle ?',
        delete_confirm_multiple: 'Voulez-vous vraiment supprimer ces rôles ?',
        selected_count: '{count} sélectionné{plural}',
        subscription_short: 'Abo.',
        errors: {
            load_error: 'Une erreur est survenue lors du chargement des données.',
            save_error: "Une erreur est survenue lors de l'enregistrement.",
            display_name_required: "Le nom d'affichage est requis",
            unique_name_required: 'Le nom unique est requis',
            form_validation: 'Veuillez corriger les erreurs de validation.',
            fetch_role: 'Erreur lors du chargement du rôle.',
        },
        messages: {
            save_matrix_success: 'Matrice de permissions enregistrée avec succès.',
            create_success: 'Rôle créé avec succès.',
            update_success: 'Rôle mis à jour avec succès.',
        },
        title_v3: 'Gestion des permissions',
        content_v3: 'Configurez les permissions de chaque rôle',
        subscription_access: 'Accès abonnement',
        click_to_unlock: "Débloquer (Inclus dans l'abonnement)",
        click_to_lock: 'Bloquer (Hors abonnement)',
        with_of_subscription: 'avec abonnement',
        switch_role_perm_fonct: {
            toogle: {
                permissions: 'Permissions',
                features: 'Fonctionalitiés',
            },
        },
    },
    staff: {
        title: 'Utilisateurs',
        availabilities: 'Disponibilités',
        no_preference: 'Pas de préférence',
        or: 'Ou',
        choose_staff_placeholder: 'choisissez votre praticien(ne) préféré(e)',
        you_have_chosen: 'Vous avez choisi :',
        add_employee: 'Ajouter un utilisateur',
        external_resource: {
            add: 'Ajouter une ressource externe',
            edit: 'Modifier',
            delete: 'Supprimer',
            name: 'Nom de la ressource',
            email: 'Email de la ressource',
        },
        edit_employee: 'Modifier un utilisateur',
        main_info: 'Informations principales',
        assignments: 'Affectations',
        roles: 'Rôle',
        prestations: 'Prestations',
        planning_visible: 'Planning visible',
        calendar_visible: 'Calendrier visible',
        status: 'Activé',
        form: {
            last_name_placeholder: 'Entrez le nom',
            first_name_placeholder: 'Entrez le prénom',
            email_placeholder: "Entrez l'email",
            phone_placeholder: 'Entrez le numéro de téléphone',
            password_placeholder: 'Entrez le mot de passe',
            password_edit_placeholder: 'Laissez vide pour ne pas changer',
            select_role: 'Sélectionner un rôle...',
            select_prestation: 'Sélectionner une prestation...',
            pin_edit_placeholder: 'Entrez le PIN',
            validation: {
                last_name_required: 'Le nom est requis',
                first_name_required: 'Le prénom est requis',
                email_required: "L'email est requis",
                phone_required: 'Le numéro de téléphone est requis',
                role_required: 'Le rôle est requis',
                pin_required: 'Le PIN est requis',
            },
        },
        table: {
            columns: {
                status: 'Statut',
                first_name: 'Prénom',
                last_name: 'Nom',
                email: 'Email',
                phone: 'Téléphone',
                roles: 'Rôles',
                actions: 'Actions',
            },
            delete_popup: {
                title: 'Supprimer un membre du personnel',
                description_single: 'Voulez-vous vraiment supprimer ce membre du personnel ?',
                description_multiple: 'Voulez-vous vraiment supprimer ces membres du personnel ?',
                error: 'Une erreur est survenue lors de la suppression.',
            },
        },
        statuses: {
            active: 'Actif',
            suspended: 'Suspendu',
            forbidden: 'Interdit',
            deleting: 'Suppression',
            deleted: 'Supprimé',
        },
        exit_dialog: {
            title: 'Quitter ?',
            description: 'Vous avez des modifications non enregistrées. Êtes-vous sûr de vouloir quitter ?',
            stay: 'Rester',
            exit: 'Quitter',
        },
        planning_sent_email: 'Planning de {name} envoyé par email avec succès',
        planning_send_error: "Erreur lors de l'envoi du planning",
    },
    subscription: {
        status: {
            active: 'Actif',
            canceled: 'Annulé',
            past_due: 'Impayé',
            incomplete: 'Incomplet',
            trialing: 'Essai',
            unpaid: 'Impayé',
            inactive: 'Inactive',
        },
        hero: {
            title: 'From booking to performance.',
            subtitle: 'Built for Experience Creators who want to manage, sell, and retain customers. Simply.',
        },
        plans: {
            free: {
                name: 'Gratuit',
                subtitle: 'Pour découvrir PlayPro',
                button: 'Gratuit',
                features: [
                    'Réservations',
                    'Paiements en ligne et sur place',
                    'Site internet standard',
                    'Gestion de la base clients',
                ],
            },
            essentiel: {
                name: 'Essentiel',
                subtitle: 'Pour gérer son entreprise',
                button: 'Continuer avec Essentiel',
                features: ['Facturation autonome', 'Paiement par acomptes', 'Pack multi-activités', "Carnet d'entrées"],
            },
            pro: {
                name: 'Pro',
                subtitle: 'Pour booster ses revenus',
                button: 'Continuer avec Pro',
                badge: 'Populaire',
                features: [
                    'Ajout de ventes additionnelles',
                    'Outils de fidélisation clients',
                    'Gestion des Devis',
                    'Applicatif caisse professionnelle',
                ],
            },
            premium: {
                name: 'Premium',
                subtitle: 'Pour les centres multi-activités ou réseaux',
                button: 'Continuer avec Premium',
                features: [
                    'Application mobile custom',
                    'QR Code de commande à table',
                    'Signature & Relance des Devis',
                    'Support prioritaire WhatsApp 24/7',
                ],
            },
        },
        plan_required: {
            essentiel: 'Plan Essentiel requis',
            premium: 'Plan Premium requis',
        },
        common: {
            monthly_ht: 'HT / mois',
            unlimited: 'illimitées',
            unlimited_singular: 'illimité',
            unlimited_feminine: 'illimitée',
            on_quote: 'sur devis',
            limit_300: '300',
            limit_2: '2',
            limit_1: '1',
            optional: 'En option',
            free_price: '0€',
            essentiel_price: '39€',
            pro_price: '119€',
            premium_price: '199€',
            soon: 'Bientôt',
            '1_pos': '1 POS',
            '2_pos': '2 POS',
            '5_pos': '5 POS',
            price_145: '145€ / HT',
            price_65: '65€ / HT',
            price_85: '85€ / HT',
            error_checkout: "Impossible d'initier le paiement. Veuillez réessayer.",
            error_portal: "Impossible d'accéder au portail client. Veuillez réessayer.",
            upgrade: "Changer d'offre",
            current_plan: 'Offre actuelle',
            continue_free: 'Continuer en gratuit',
            activate_plan: 'Activer {plan}',
            continue_free_done: "Vous continuez avec l'offre gratuite.",
        },
        table: {
            categories: {
                booking: 'Réservation et expériences',
                website: 'Site Internet & visibilité',
                payment: 'Paiement & Encaissement',
                billing: 'Facturation & Devis',
                collection: 'Encaissement',
                marketing: 'Marketing & Fidélisation',
                automation: 'IA & Automatisations',
                team: 'Équipe & RH',
                support: 'Assistance & Formation',
                complementary_services: 'Services complémentaires',
            },
            features: {
                manual_booking: 'Réservations manuelles',
                multi_activity_creation: "Création d'activités multi-activités",
                multi_activity_packs: 'Création de packs multi-activités',
                registered_customers: 'Clients enregistrés',
                crm_access: 'Accès base clients (CRM)',
                absent_tracking: 'Suivi & Gestion des clients absents',
                quote_requests: 'Demandes de devis en ligne',
                additional_sales: 'Ventes additionnelles',
                customer_export: 'Export de la base clients',
                monthly_reservations: 'Réservations mensuelles',
                activity_creation: "Création d'activités",
                unpaid_followup: 'Relance des réservations non-finalisées',
                multi_languages: 'Multi-langues',
                custom_website: 'Site Internet personnalisé',
                booking_widget: 'Widget de réservation sur votre site',
                custom_domain: 'Nom de domaine personnalisé',
                remove_playpro_logo: 'Suppression du logo PlayPro',
                custom_mobile_app: 'Application mobile personnalisée',
                online_payment: 'Paiement 100% en ligne sécurisés (Stripe)',
                on_site_payment: 'Paiement sur-place',
                deposit_percentage: 'Paiement avec acompte en pourcentage',
                deposit_fixed: 'Paiement avec acompte en montant fixe',
                invoice_edition: 'Édition de factures',
                quote_generation: 'Génération & Édition de devis',
                kanban_quotes: 'Suivi des devis en vue Kanban',
                brochure_with_quote: 'Création & Envoi de Brochure avec le devis',
                deposit_management: 'Suivi et gestion des acomptes',
                auto_quote_followup: 'Relance automatique des devis',
                electronic_signature: 'Signature électronique des devis',
                pos_app: 'Application de caisse (iOS/Android)',
                offline_pos: 'Mode hors-ligne de la caisse',
                qr_code_order: 'Commande par QR Code',
                stock_management: 'Gestion des stocks',
                promo_codes: 'Génération de codes promo',
                entry_books: "Création de carnets d'entrées",
                newsletters: 'Campagnes e-mail de Newsletters',
                loyalty_programs: 'Programmes de fidélité',
                gift_cards: 'Gestion automatisée des Bons cadeaux',
                cse_ticketing: "Billetterie Comité d'Entreprise (CSE)",
                events_tracking: 'Tracking avancé des données via GTM/Matomo',
                subscriptions: "Création & Gestion d'Abonnements",
                wallet: 'Wallet (portefeuille électronique)',
                referral_program: 'Programme de parrainage',
                dynamic_pricing: 'Tarification dynamique (Early Birds)',
                advanced_stats: 'Statistiques avancées',
                auto_emails: 'Emails automatiques (rappel, anniv,..)',
                karafun_integration: 'Liaison avec Karafun',
                google_calendar_sync: 'Synchronisation Google Agenda',
                booking_api: 'API Réservations',
                mcp_server: 'Connexion Serveur MCP',
                custom_email_server: 'Envoi des emails avec votre boite mail',
                multi_establishment: 'Gestion multi-établissements',
                employee_accounts: 'Nombre de comptes employés',
                employee_permissions: 'Permissions & rôles employés',
                team_planning: "Planning d'équipe",
                ai_assistant: 'Assistant IA personnalisée',
                email_support: 'Support par e-mail',
                whatsapp_support: 'Support Whatsapp 24/7',
                data_migration_file: 'Migration de vos données (par fichier)',
                onboarding_training: 'Formation à la prise en main (par heure)',
                exceptional_intervention: 'Intervention exceptionnelle (par heure)',
                data_migration: 'Migration de vos données (sur devis)',
            },
        },
        manage: {
            title: 'Gérer mon abonnement',
            subtitle: 'Gérez vos offres, vos factures et vos options de paiement',
            current_offer: 'OFFRE ACTUELLE',
            trial: 'Essai',
            active_since: 'ACTIF DEPUIS',
            billing: 'FACTURATION',
            monthly: 'Mensuelle',
            manage: 'Gérer',
            change_plan: 'Changer de plan',
            invoices: 'Factures',
            stripe_portal_title: 'Retrouvez vos factures sur notre portail Stripe',
            stripe_portal_desc:
                "Gérez et consultez facilement l'ensemble de vos factures depuis notre portail de facturation sécurisé par Stripe.",
            access_invoices: 'Accéder à mes factures',
            cancel_confirm_title: "Annuler l'abonnement ?",
            cancel_confirm_text: "Votre abonnement restera actif jusqu'à la fin de la période de facturation en cours.",
            cancel_success: 'Abonnement annulé.',
            current_offer_badge: 'OFFRE ACTUELLE',
            renewal: 'RENOUVELLEMENT',
            billing_cycle: 'FACTURATION',
            status: 'STATUT',
            manage_button: 'Gérer',
            change_plan_button: 'Changer de plan',
            invoices_title: 'Factures',
            stripe_text:
                "Retrouvez vos factures sur notre portail Stripe. Gérez et consultez facilement l'ensemble de vos factures depuis notre portail de facturation sécurisé par Stripe.",
            access_invoices_button: 'Accéder à mes factures',
            table_badge: 'Plans & tarifs',
            table_title: 'Comparatif des offres',
            table_subtitle: 'Choisissez le plan adapté à votre activité',
            upgrade_to: 'Passer {plan}',
            change_offer: "Changer d'offre",
            cancel_subscription: "Annuler l'abonnement",
            resume_subscription: "Rétablir l'abonnement",
            downgrade: "Changer d'offre",
            trial_badge: 'Essai',
        },
        banner: {
            payment_failed_title: 'Paiement échoué',
            payment_failed_message:
                'Le paiement de votre abonnement a échoué. Veuillez mettre à jour votre moyen de paiement pour éviter la suspension de votre compte.',
            canceling_title: 'Abonnement en cours de résiliation',
            canceling_message: "Votre abonnement sera actif jusqu'au {date}. Passé cette date, votre accès sera limité.",
            warning_title: 'Attention',
            warning_message: 'Une action est requise sur votre abonnement.',
        },
        faq: {
            title_top: 'Questions',
            title_bottom: 'fréquentes',
            subtitle: 'Toutes les réponses à vos questions sur nos offres et fonctionnalités.',
            items: [
                {
                    question: 'PlayPro est-il gratuit ?',
                    answer: "PlayPro propose des offres adaptées aux équipes de toutes tailles, avec une option gratuite idéale pour les petites structures ou les projets qui démarrent. Nos abonnements payants offrent des fonctionnalités avancées pour les équipes en croissance ou celles qui ont besoin de plus d'outils de gestion.",
                },
                {
                    question: 'Quels sont les moyens de paiement disponibles ?',
                    answer: 'Nous acceptons toutes les cartes bancaires principales et les paiements par virement bancaire.',
                },
                {
                    question: "Puis-je importer des données depuis d'autres outils ?",
                    answer: "Oui, PlayPro permet d'importer vos données depuis d'autres plateformes pour faciliter votre migration.",
                },
                {
                    question: 'Proposez-vous des abonnements mensuels et annuels ?',
                    answer: 'Oui, nous proposons des abonnements mensuels et annuels. Les abonnements annuels bénéficient souvent de réductions.',
                },
                {
                    question: "PlayPro dispose-t-il d'une API ?",
                    answer: "Oui, PlayPro dispose d'une API complète pour les plans Pro et Premium, vous permettant d'intégrer notre plateforme avec vos outils existants.",
                },
            ],
        },
        redirecting_portal: 'Redirection vers le portail...',
        redirecting_stripe: 'Redirection vers Stripe...',
        cancelling: 'Annulation en cours...',
        cancelled: "Abonnement annulé : il reste actif jusqu'à la fin de la période en cours.",
        cancelled_until: "Abonnement annulé : il reste actif jusqu'au {date}.",
        resumed: 'Abonnement rétabli : la résiliation a été annulée.',
    },
    website_settings: {
        title: 'Site Internet',
        tabs: {
            general: 'Apparence',
            sections: 'Sections',
            pages: 'Pages',
            footer: 'Pied de page',
            faq: 'FAQ',
            seo: 'SEO',
            menu: 'Menu',
            mobile_intro: 'Mobile App',
            privacy: 'Politique de confidentialité',
            cguv: 'Mentions légales',
            outils: 'Outils',
        },
        general: {
            title: 'Apparence',
            sections_banner_info:
                'Ces sections apparaissent sur plusieurs pages de votre site Internet pour mettre en avant vos contenus, produits ou informations importantes.',
            customize_style: 'Sélection du template',
            template_section: 'Sélection du template',
            slider_section: 'Images du slider',
            slider_images: 'Images du slider',
            click_or_drop: 'Cliquez ou déposez une image',
            position_image: "Positionner l'image",
            preview: 'Aperçu',
            no_preview: 'Aucun aperçu disponible',
            aspect_16_9: '16:9 (Paysage)',
            aspect_4_3: '4:3 (Standard)',
            aspect_square: 'Carré 1:1',
            aspect_free: 'Libre',
            slider_title: 'Titre de bienvenue',
            slider_desc: 'Description de bienvenue',
            welcome_title: 'Titre de bienvenue',
            welcome_desc: 'Description de bienvenue',
            colors_section: 'Couleurs du thème',
            primary_color: 'Couleur principale',
            secondary_color: 'Couleur secondaire',
            tertiary_color: 'Couleur tertiaire',
            menus_color: 'Couleur des menus',
            action_text_color: 'Couleur texte action',
            options_section: 'Options',
            show_reservation_header: "Afficher l'en-tête réservation",
            show_available_places: 'Afficher les places disponibles',
            reservation_section: 'Page de réservation',
            reservation_title: 'Titre de la page',
            reservation_image: 'Image en-tête',
            cover: 'Image de couverture',
            gift_card_section: 'Bon Cadeau',
            gift_card_title: 'Titre',
            gift_card_desc: 'Description',
            gift_card_image: 'Image',
            undated_ticket_section: 'Billet Non Daté',
            undated_ticket_title: 'Titre',
            undated_ticket_desc: 'Description',
            undated_ticket_image: 'Image',
            undated_title: 'Titre',
            undated_cover: 'Image de couverture',
            undated_desc: 'Description',
            undated_image: 'Image',
            vouchers_warning: 'Proposez les bons cadeaux à la vente pour pouvoir activer cette section.',
            undated_tickets_warning: 'Proposez des billets non datés sur une expérience pour pouvoir activer cette section.',
            restoration_section: 'Restauration',
            restoration_title: 'Titre',
            restoration_desc: 'Description',
            restoration_image: 'Image',
            configure_now: 'Configurer maintenant',
            discovery_offer_section: 'Offre Découverte',
            discovery_offer_title: 'Titre',
            discovery_offer_desc: 'Description ',
            discovery_offer_image: 'Image',
            discovery_section: 'Offre Découverte',
            discovery_title: 'Titre',
            discovery_desc: 'Description',
            discovery_image: 'Image',
            partners_section: 'Partenaires',
            partner_name: 'Nom du partenaire',
            partner_name_placeholder: 'Ex : Fais vibrer ton public.',
            partner_logos: 'Logos partenaires',
            partner_logo: 'Logo du partenaire',
            partner_link: 'Lien du partenaire',
            partner_link_placeholder: 'Ex : https://partenaire.com',
            partner_delete_confirm: 'Êtes-vous sûr de vouloir supprimer ce partenaire ?',
            partner_deleted: 'Partenaire supprimé',
            add_partner: 'Ajouter un partenaire',
            category_section: 'Catégories',
            categories_section: 'Catégories',
            enable_shop: 'Activer la boutique',
            category_men_title: 'Titre catégorie Hommes',
            category_men_desc: 'Description catégorie Hommes',
            category_men_image: 'Image catégorie Hommes',
            category_women_title: 'Titre catégorie Femmes',
            category_women_desc: 'Description catégorie Femmes',
            category_women_image: 'Image catégorie Femmes',
            category_child_title: 'Titre catégorie Enfants',
            category_child_desc: 'Description catégorie Enfants',
            category_child_image: 'Image catégorie Enfants',
            men_category: 'Catégorie Hommes',
            women_category: 'Catégorie Femmes',
            children_category: 'Catégorie Enfants',
            category_title: 'Titre',
            category_desc: 'Description',
            category_image: 'Image',
            choices_section: 'Pourquoi nous ?',
            first_choice_title: 'Titre de section',
            first_choice_desc: 'Description',
            second_choice_title: 'Titre de section',
            second_choice_desc: 'Description',
            third_choice_title: 'Titre de section',
            third_choice_desc: 'Description',
            choice_title: 'Titre de section',
            choice_desc: 'Description',
            choice_icon: 'Icône',
            choice_title_placeholder: 'Ex : Fais vibrer ton public.',
            choice_desc_placeholder:
                'Ex : Achetez votre billet maintenant et choisissez le jour de votre visite quand vous voulez ! Parfait pour offrir ou profiter de notre parc quand cela vous arrange.',
            demande_devis_section: 'Demande de devis',
            demande_devis_title: 'Titre de section',
            demande_devis_desc: 'Description',
            demande_devis_image: 'Image',
            demande_devis_logo: 'Logo',
            demande_devis_title_placeholder: 'Ex : Demandez un devis.',
            demande_devis_desc_placeholder: 'Ex : Nous vous répondrons dans les plus brefs délais.',
            slider_delete_confirm: 'Êtes-vous sûr de vouloir supprimer cette image du slider ?',
            image_deleted: 'Image supprimée',
            tooltips: {
                gift_card: 'Configurez la section des bons cadeaux sur votre site.',
                partners: 'Affichez vos partenaires et leurs logos.',
                choices: 'Mettez en avant vos points forts.',
                demande_devis: 'Configurez la section demande de devis sur votre site.',
                undated_ticket: 'Proposez des billets sans date fixe.',
                restoration: 'Proposez une carte de restauration sur votre site.',
                discovery_offer: 'Mettez en avant vos offres de bienvenue.',
                shop: 'Gérez les catégories de votre boutique en ligne.',
            },
            visual_identity: 'Identité visuelle',
            logo: 'Logo',
            theme: 'Thème',
            home_banner: "Bannière d'accueil",
            welcome_subtitle: 'Sous-titre',
            welcome_subtitle_placeholder: 'Ex : Transforme ton idée en expérience mémorable...',
            welcome_title_placeholder: 'Ex : Fais vibrer ton public.',
            image_right: 'Image à droite',
            carousel: 'Carrousel',
            background_image: 'Image en fond',
            background_video: 'Vidéo en fond',
            add_image: 'Ajouter une image',
            themes: {
                v1: {
                    title: 'V1 - Image à droite',
                    desc: 'Un visuel sur la droite pour illustrer votre message clé.',
                },
                v2: {
                    title: 'V2 - Carrousel',
                    desc: 'Faites défiler plusieurs images pour présenter vos différentes offres.',
                },
                v3: {
                    title: 'V3 - Image en fond',
                    desc: 'Une grande image en arrière-plan pour un impact immédiat.',
                },
                v4: {
                    title: 'V4 - Vidéo en fond',
                    desc: 'Une vidéo en arrière-plan pour une expérience immersive.',
                },
            },
            errors: {
                title_welcome_required: 'Le titre est requis',
                desc_welcome_required: 'Le texte est requis',
                image_header_required: "L'image est requise",
                primary_color_required: 'La couleur primaire est requise',
                secondary_color_required: 'La couleur secondaire est requise',
                menus_color_required: 'La couleur des menus est requise',
                action_text_color_required: "La couleur du texte d'action est requise",
            },
        },
        footer: {
            title: 'Pied de page',
            global_toggle: 'Activer le pied de page',
            global_toggle_tooltip: "Affichez ou masquez le pied de page sur l'ensemble de votre site.",
            identity_section: 'Identité visuelle',
            footer_logo: 'Logo du pied de page',
            presentation_section: 'Présentation de votre établissement',
            presentation_title_label: 'Titre de présentation',
            presentation_title_placeholder: 'Ex : À propos de nous',
            contact_section: 'Contactez-nous',
            contact_info_banner:
                'Vos informations de contact sont automatiquement récupérées depuis les paramètres de votre établissement.',
            configure_now: 'Configurer maintenant',
            contact_title: 'Titre contactez nous',
            contact_desc: 'Description contactez nous',
            contact_button_text: 'Texte du bouton',
            footer_desc_section: 'Description pied de page',
            opening_hours_section: "Horaires d'ouverture",
            hours_label: 'Activer les horaires personnalisés',
            hours_info_banner_1: "Vos horaires d'ouverture sont automatiquement récupéré depuis les",
            hours_info_banner_link: 'paramètres de votre établissement',
            hours_info_banner_2:
                'Vous pouvez les personnaliser au format texte, elles remplaceront celles affichées sur votre site Internet.',
            hours_placeholder: 'Ex : Fermé, 9h - 18h, sur demande...',
            social_networks: 'Réseaux sociaux',
            social: {
                facebook: 'Facebook',
                linkedin: 'LinkedIn',
                youtube: 'Youtube',
                twitter: 'Twitter/X',
                instagram: 'Instagram',
                tiktok: 'TikTok',
                pinterest: 'Pinterest',
                snapchat: 'Snapchat',
                telegram: 'Telegram',
                threads: 'Threads',
            },
            analytics: {
                google_analytics: 'Google Analytics',
                facebook_pixel: 'Facebook Pixel',
            },
            analytics_tracking: 'Analytics & Tracking',
            custom_script: 'Script personnalisé',
            save_success: 'Pied de page enregistré avec succès',
            placeholders: {
                logo: 'Logo',
                presentation_desc:
                    'Présentez votre activité en quelques mots: ce que vous faites, pour qui, et ce qui vous rend unique. Idéalement, utilisez des mots-clés pertinents pour améliorer votre référencement.',
                contact_title: 'Contactez-nous',
                contact_desc: 'Vous avez des questions ?...',
                contact_button: 'Envoyer...',
                facebook: 'https://facebook.com/..',
                linkedin: 'https://linkedin.com/..',
                youtube: 'https://youtube.com/..',
                twitter: 'https://twitter.com/..',
                instagram: 'https://instagram.com/..',
                tiktok: 'https://tiktok.com/..',
                pinterest: 'https://pinterest.com/..',
                snapchat: 'https://snapchat.com/..',
                telegram: 'https://telegram.me/..',
                threads: 'https://threads.net/..',
                footer_desc: 'Description pied de page',
                custom_script: 'Code du script personnalisé...',
            },
            days: {
                monday: 'Lundi',
                tuesday: 'Mardi',
                wednesday: 'Mercredi',
                thursday: 'Jeudi',
                friday: 'Vendredi',
                saturday: 'Samedi',
                sunday: 'Dimanche',
            },
        },
        reservation: {
            title: 'Réservation',
            main_title: 'Titre principal',
            description_placeholder: 'Ex: Nos activités',
            display_order: "Ordre d'affichage",
            reservation_url: 'https://demotenant.playpro.fr/reservation',
            display_orders: {
                experiences_first: 'Les expériences en premier',
                categories_first: 'Les catégories en premier',
            },
            background_color: 'Couleur de fond',
        },
        about: {
            title: 'À propos',
            main_info: 'Informations principales',
            main_title: 'Titre de la page',
            description: 'Description',
            description_placeholder: 'Entrez la description',
            content: 'Contenu',
            image: 'Image de présentation',
            presentation_image: 'Image de présentation',
            cover_image: 'Image de couverture',
            cover_image_recommendation: '1500 x 450 pixels recommandé',
            missions_section: 'Nos Missions',
            mission_section: 'Notre mission',
            add_mission: 'Ajouter une mission',
            mission_title_placeholder: 'Titre de la mission',
            mission_desc_placeholder: 'Description de la mission',
            mission_number: 'Mission #',
            missions_empty: 'Aucune mission ajoutée',
            gallery_section: 'Galerie photo',
            gallery_image_recommendation: '440 x 320 pixels recommandé',
            save_success: 'À propos enregistré avec succès',
            gallery_delete_confirm: 'Êtes-vous sûr de vouloir supprimer cette image de la galerie ?',
            gallery_empty: 'Aucune image dans la galerie',
            add_photo: 'Ajouter une photo',
            delete_image: "Supprimer l'image",
            reset_success: 'Formulaire réinitialisé',
            delete_success_gallery: 'Image supprimée de la galerie',
            content_management: 'Gestion du contenu',
            reservation_section: 'Réservation',
            reservation_url: 'https://demotenant.playpro.fr/reservation',
            display_order: "Ordre d'affichage",
            display_orders: {
                experiences_first: 'Expériences en premier',
                categories_first: 'Catégories en premier',
            },
            background_color: "Couleur d'arrière-plan",
            second_title: 'Deuxième titre',
        },
        cguv: {
            title: 'Conditions générales de vente',
            label: 'Contenu des CGUV',
            placeholder: 'Saisissez vos CGUV ici...',
            privacy_title: 'Politique de confidentialité',
            privacy_label: 'Contenu des Politique de Confidentialité',
            privacy_placeholder: 'Saisissez votre politique de confidentialité ici...',
            show_cguv: 'Utiliser un lien vers mes CGUV',
            show_privacy: 'Utiliser un lien vers ma Politique de Confidentialité',
            link_label: 'Lien des CGUV',
            link_placeholder: 'Saisissez le lien de vos CGUV ici...',
            privacy_link_label: 'Lien de la Politique de Confidentialité',
            privacy_link_placeholder: 'Saisissez le lien de votre politique de confidentialité ici...',
            save_success: 'Mentions légales enregistrées avec succès',
        },
        mobile_intro: {
            title: 'Configurer : Intro Mobile App',
            screen_section: "Écran d'introduction",
            name_label: 'Nom',
            name_placeholder: 'Entrez le nom',
            description_label: 'Description',
            description_placeholder: 'Entrez la description',
            image_label: 'Image',
            upload_image: 'Télécharger image',
            save_success: 'Intro mobile enregistré avec succès',
        },
        menu: {
            title: 'Menu paramètres',
            info_banner:
                'Gérez les éléments affichés dans le menu de navigation de votre site Internet. Vous pouvez activer ou désactiver chaque élément et modifier son intitulé.',
            placeholder: 'Titre menu',
            placeholder_prefix: 'Ex : ',
            footer_title: 'Pied de page du site',
            footer_label: 'Activer le pied de page du site (Oui/Non)',
            save_success: 'Paramètres du menu enregistrés',
            sections: {
                about: 'À propos',
                about_placeholder: 'Concept, Qui sommes-nous ?',
                about_label: 'Titre du menu « À propos »',
                discover: 'Nos offres',
                res: 'Réserver',
                res_label: 'Titre du menu « Réserver »',
                offer: 'Offre découverte',
                offer_label: 'Titre du menu « Offre découverte »',
                gift: 'Bon cadeau',
                gift_label: 'Titre du menu « Bon cadeau »',
                event: 'Événements',
                event_label: 'Titre du menu « Événements »',
                sub: 'Abonnements',
                sub_label: 'Titre du menu « Abonnements »',
                rest: 'Restauration',
                rest_label: 'Titre du menu « Restauration »',
                help: 'Aidez-nous',
                help_label: 'Titre du menu « Aidez-nous »',
                contact: 'Contactez-nous',
                contact_placeholder: 'Contactez-nous',
                contact_label: 'Titre du menu « Contactez-nous »',
                shop: 'Boutique',
                shop_placeholder: 'Boutique',
                shop_label: 'Titre du menu « Boutique »',
                blog: 'Blog',
                blog_placeholder: 'Blog',
                blog_label: 'Titre du menu « Blog »',
                evg: 'Devis EVG/F',
                evg_placeholder: 'Devis EVG/F',
                evg_label: 'Titre du menu « Devis EVG/F »',
                ent: 'Devis Entreprise',
                ent_placeholder: 'Devis entreprise',
                ent_label: 'Titre du menu « Devis entreprise »',
                anv: 'Devis Anniversaire',
                anv_placeholder: 'Devis anniversaire',
                anv_label: 'Titre du menu « Devis anniversaire »',
            },
        },
        seo: {
            title: 'Gestion SEO',
            info_banner:
                'Optimisez le référencement de chaque page sur les moteurs de recherche en personnalisant les balises SEO.',
            section_prefix: '',
            configured: 'Configuré',
            configured_badge: 'Configuré',
            to_configure_badge: 'À configurer',
            no_description: 'Aucune description configurée',
            title_label: 'Titre SEO',
            title_placeholder: 'Ex : [Activité principale] à [Ville] - [Nom établissement]',
            description_label: 'Méta description',
            description_placeholder:
                'Ex : Découvrez [activité principale] à [ville]. Idéal pour [anniversaires / sorties en famille / team building]. Réservez votre session en ligne dès maintenant.',
            image_label: "Image affichée lors du partage de l'URL sur les réseaux sociaux",
            image_size_recommendation: 'JPG, JPEG, PNG - moins de 5 Mo',
            empty_state: 'Aucune page à configurer pour le moment',
            char_max: '{max} caractères max',
            save_success: 'Paramètres SEO enregistrés avec succès',
        },
        faq: {
            title: 'FAQ',
            info_banner:
                'La FAQ apparait sur plusieurs pages de votre site Internet pour répondre aux questions générales que vos clients se posent.',
            question_label: 'Question',
            question_label_numbered: 'Question #{n}',
            question_placeholder: 'Ex : Comment réserver une activité ?',
            answer_label: 'Réponse',
            answer_label_numbered: 'Réponse #{n}',
            answer_placeholder:
                "Ex:\n1. Choisissez votre activité (tennis, paintball, VR, atelier peinture, etc.)\n2. Sélectionnez la date et l'horaire disponibles\n3. Indiquez le nombre de participants\n4. Effectuez le paiement en ligne\n5. Recevez une confirmation par email",
            add_question_button: 'Ajouter une question',
            ai_helper_button: "Demander l'aide par l'IA",
            ai_helper_label: 'Décrivez le sujet de vos FAQs',
            ai_helper_placeholder: "Ex: Questions sur les horaires d'ouverture et tarifs d'un parc d'attractions",
            ai_generate_button: 'Générer des FAQs',
            ai_generating: 'Génération...',
            move_up: 'Monter',
            move_down: 'Descendre',
            remove: 'Supprimer',
            add: 'Ajouter',
            empty_state: "Aucune question n'a été ajoutée",
            save_success: 'FAQ enregistrées avec succès',
            ai_success: 'FAQs générées avec succès!',
            ai_empty: 'Aucune FAQ générée. Essayez une autre description.',
            ai_error: 'Erreur lors de la génération des FAQs',
            errors: {
                question_required: 'La question est requise',
                answer_required: 'La réponse est requise',
            },
        },
        outils: {
            title: 'Outils : Intégrez des Fonctionnalités Avancées sur Votre Site',
            empty: 'Aucun outil disponible',
            integrate: 'Intégrer',
            visit_website: 'Consulter le site web',
            modal: {
                title_default: 'Ajouter le Script',
                title_google_search: 'Mettre le contenu de votre fichier google',
                title_google_analytics: 'Ajouter la clé google analytics',
                label_default: 'Script',
                label_google_search: 'Contenu',
                label_google_analytics: 'Clé',
                placeholder_default: 'Insérer votre code',
                placeholder_google_search: 'Mettre le contenu de votre fichier google',
                placeholder_google_analytics: 'Entrez le key google analytics GTM-XXXXXX',
                error_required: 'Le script est obligatoire',
                add: 'Ajouter',
                clear: 'Effacer',
                update_success: 'Outil mis à jour avec succès',
            },
        },
        privacy: {
            title: 'Politique de Confidentialité',
            content_label: 'Contenu de la politique de confidentialité',
            placeholder: 'Saisissez votre politique de confidentialité ici...',
            save_success: 'Politique de confidentialité enregistrée',
        },
        actions: {
            save: 'Enregistrer',
            saving: 'Enregistrement...',
            save_success: 'Vos modifications ont été enregistrées',
            save_error: "Erreur lors de l'enregistrement",
            delete_error: 'Erreur lors de la suppression',
            reset: 'Réinitialiser',
            integrate_widget: 'Widgets à intégrer',
            view_site: 'Voir le site',
        },
    },
    pos: {
        title: 'Points de vente (POS)',
        downloadPOS: 'Télécharger PlayProPOS',
        add: 'Ajouter un POS',
        edit: 'Modifier un POS',
        save_success: 'Caisse enregistrée avec succès',
        delete_success: 'Caisse supprimée avec succès',
        deactivated: 'Caisse désactivée',
        activated: 'Caisse activée',
        device_id_label: "ID de l'appareil",
        device_id_placeholder: 'Ex: POS-001',
        device_name_label: "Nom de l'appareil",
        device_name_placeholder: 'Ex: Caisse Principale',
        status_label: 'Statut',
        exit_title: 'Quitter le formulaire',
        exit_message: 'Voulez-vous vraiment quitter ? Les modifications non enregistrées seront perdues.',
        exit_confirm: 'Quitter',
        exit_cancel: 'Rester',
        validation_device_id: "L'ID de l'appareil est requis.",
        validation_device_name: "Le nom de l'appareil est requis.",
        status_active: 'Actif',
        status_pending: 'En attente',
        status_inactive: 'Désactivé',
        action_edit: 'Modifier',
        action_deactivate: 'Désactiver',
        action_activate: 'Activer',
        action_delete: 'Supprimer',
        selected_items: '{count} élément sélectionné',
        selected_items_plural: '{count} éléments sélectionnés',
        delete_title: 'Supprimer la caisse',
        delete_confirm_single: 'Êtes-vous sûr de vouloir supprimer cette caisse ?',
        column_requested_by: 'Demandé par',
    },
    applications: {
        delete_success: 'Application supprimée avec succès',
        save_success: 'Application enregistrée avec succès',
        selected_items: '{count} élément sélectionné',
        selected_items_plural: '{count} éléments sélectionnés',
        delete_title: "Supprimer l'application",
        delete_confirm_single: 'Êtes-vous sûr de vouloir supprimer cette application ?',
        column_id: "Identifiant de l'application",
        column_name: "Nom de l'application",
    },
    api: {
        title: 'API',
        create: 'Créer une application',
        download_documentation: 'Télécharger la documentation API',
        form: {
            title_edit: 'Modifier une API',
            title_add: 'Ajouter une API',
            name: {
                label: "Nom de l'application",
                placeholder: 'Ex: Planéa',
            },
            regenerate_secret: {
                label: 'Régénérer le secret',
                placeholder: 'Régénérer le secret',
            },
            scopes: {
                label: 'Portées autorisées',
                help: "Ce que cette clé pourra appeler. Le partenaire demande ces portées à l'émission de son jeton ; toute autre lui sera refusée.",
                all: 'Tout cocher',
                none: 'Tout décocher',
                empty: 'Aucune portée disponible.',
                unrestricted: 'Aucune portée cochée : la clé pourra tout appeler (comportement des clés existantes).',
            },
        },
        errors: {
            name_required: "Le nom de l'application est requis.",
        },
        view_documentation: 'Voir la documentation',
        add: 'Ajouter une application',
        view: {
            identifiant: "Identifiant de l'application",
            secret: "Secret de l'application",
            title: "Informations de l'application",
        },
    },
    cart: {
        title: 'Panier',
        empty: 'Aucun article dans le panier.',
        columns: {
            qty: 'Qté',
            designation: 'Désignation',
            unit_price: 'Prix Unit',
            total_ttc: 'Total TTC',
        },
        item_types: {
            subscription: 'Abonnement',
            package: 'Forfait',
        },
        alerts: {
            select_prepayment: 'Veuillez sélectionner le prépaiement à appliquer.',
            sale_clotured: 'Cette vente est clôturée',
        },
        fidelity: {
            points: 'Points de fidélité',
            remaining: 'Point(s) restant(s) :',
            discount: 'Remise fidélité',
        },
        payment: {
            acompte: 'Acompte',
            acompte_and_rest: 'Acompte et reste',
            acompte_to_pay: 'Acompte à payer :',
            already_paid: 'Déjà payé :',
            rest_to_pay: 'Reste à payer :',
            promo_code: 'Réduction & Code Promo :',
            total_ttc: 'Total TTC :',
        },
        errors: {
            no_date: 'Aucune date disponible',
            invalid_date: 'Date invalide',
        },
    },
    survey: {
        description: 'Description générale',
        image: 'Image',
        upload_image: 'Télécharger une image',
        question: 'Question',
        response_type: 'Type de réponse',
        correct_answers_count: 'Nombre de réponses correctes',
        required_response: 'Réponse obligatoire',
        response_possibilities: 'Possibilités de réponse',
        add_response: 'Ajouter une nouvelle réponse',
        delete_question: 'Supprimer la question',
        save_form: 'Enregistrer formulaire',
        ai_help: "Demander l'aide par l'IA",
        ai_placeholder: 'Écrivez votre sujet ici...',
        question_placeholder: 'ex: Comment avez vous trouvé votre prestation?',
        number_placeholder: 'ex: 3',
        min_value: 'Valeur minimale',
        max_value: 'Valeur maximale',
        min_value_placeholder: 'ex: 0',
        max_value_placeholder: 'ex: 500',
        default_fields: {
            last_name: 'Nom',
            first_name: 'Prénom',
            phone: 'Téléphone',
            email: 'E-mail',
        },
        types: {
            multiple_choice: 'Choix multiple',
            single_choice: 'Choix unique',
            choice_list: 'Liste des choix',
            free_choice_text: 'Choix libre (caractères)',
            free_choice_number: 'Choix libre (chiffres)',
            date_time: 'Date et Heure',
            date: 'Date',
            time: 'Heure',
            long_text: 'Texte long',
        },
    },
    available_soon: {
        title: 'Cette fonctionnalité est bientôt de retour',
        description:
            'Cette fonctionnalité est temporairement indisponible le temps de sa refonte. Elle reviendra bientôt dans une version améliorée.',
        back_home: 'Retour à la page d’accueil',
        image_alt: 'Illustration de fonctionnalité en maintenance',
    },
    customerInfo: {
        customer_details: 'Fiche client',
        professional: 'Professionnel',
        individual: 'Particulier',
        form: {
            email: {
                label: 'Adresse e-mail',
            },
            phone_number: {
                label: 'Numéro de téléphone',
            },
            civility: {
                label: 'Civilité',
            },
            address: {
                label: 'Adresse',
            },
            source_of_acquisition: {
                label: "Source d'acquisition",
                placeholder: '- Sélectionner une source d’acquisition -',
            },
            note: {
                label: 'Note',
            },
            registered_for_communications: {
                label: 'Inscrit aux communications',
            },
            groups: {
                label: 'Groupes clients',
            },
        },
        titles: {
            additional_information: 'Informations complémentaires',
            orders_and_reservations: 'Commandes et réservations',
            packages_and_subscriptions: 'Forfaits & Abonnements',
            vouchers: 'Bons cadeaux',
            groups: 'Groupes',
        },
        metrics: {
            loyalty_points: 'Points de fidélité',
            wallet: 'Wallet',
            reservations: 'Réservations',
            total_spent: 'Montant total dépensé',
            packages_and_subscriptions: 'Forfaits & Abonnements',
            vouchers: 'Bons cadeaux',
            groups: 'Groupes',
            date_created: 'Date de création',
        },
        types: {
            treatment: 'Forfait',
            serie: 'Abonnement',
        },
        status: {
            cancelled: 'Annulée',
            upcoming: 'À venir',
            partially_paid: 'Partiellement payée',
            paid: 'Payée',
            pending: 'En attente',
            in_progress: 'En cours',
            closed: 'Clôturée',
        },
    },
    helpdesk: {
        index: {
            title: "Centre d'aide",
            subtitle: "Gérez vos demandes d'assistance et suivez leur avancement",
            create_button: 'Créer un ticket',
            loading: 'Chargement des tickets...',
            empty_title: 'Aucun ticket pour le moment',
            empty_subtitle: "Vous avez besoin d'aide ?",
            empty_note: 'Merci de ne pas relancer nos équipes dès que vous avez transmis un ticket',
            info_banner: {
                label: 'Délai de réponse :',
                has_tickets:
                    'notre équipe s’engage à traiter votre ticket dans un délai de 4 jours ouvrés. La réponse vous sera communiquée par e-mail.',
                no_tickets:
                    "Notre équipe s'engage à traiter votre ticket dans un délai de 3 à 14 jours selon le niveau de priorité. La réponse vous sera communiquée par e-mail.",
            },
            statuses: {
                active: 'Ouvert',
                pending: 'En cours',
                closed: 'Résolu',
            },
        },
        form: {
            create_title: 'Créer un ticket de support',
            view_title: 'Ticket #{id}',
            create_description: 'Remplissez le formulaire ci-dessous pour créer un nouveau ticket de support',
            view_description: 'Détails du ticket de support',
            close: 'Fermer',
            send_ticket: 'Envoyer',
            subject: 'Sujet',
            subject_placeholder: 'Entrez le sujet de votre ticket',
            category: 'Catégorie',
            priority: 'Priorité',
            message: 'Message',
            text_placeholder: 'Décrivez votre problème ou votre suggestion avec le plus de détails possible',
            attachments: 'Pièces jointes',
            status: 'Statut',
            created_at: 'Date de création',
            client: 'Client',
            support: 'Support',
            download: 'Télécharger',
            file: 'Fichier',
            success_message: 'Votre demande a bien été transmise. Notre équipe vous répondra sous 24 à 48 heures ouvrées.',
            user_not_available: 'Utilisateur non disponible',
            priorities: {
                low: 'Basse',
                normal: 'Moyenne',
                high: 'Élevée',
                urgent: 'Urgent',
            },
            statuses: {
                active: 'Actif',
                closed: 'Fermé',
                pending: 'En attente',
            },
            categories: {
                technical: 'Problème technique',
                billing: 'Abonnement / Facturation PlayPro',
                suggestion: "Proposition d'amélioration",
                onboarding: 'Onboarding',
            },
        },
    },
    planning_v3: {
        reservations: 'Réservations',
        today: "Aujourd'hui",
        filters: 'Filtres',
        saved_filters: 'Filtres enregistrés',
        create_filter_placeholder: 'Créer un nouveau filtre',
        no_filter: 'Aucun filtre enregistré',
        deselect_filter: 'Désélectionner le filtre',
        practitioners: 'Praticiennes',
        spaces: 'Salles',
        search_reservation: 'Rechercher réservation...',
        add_reservation: 'Ajouter une nouvelle réservation',
        take_reservation: 'Prendre une réservation',
        block_slot: 'Bloquer le créneau',
        export: 'Exporter',
        exporting: 'Export en cours...',
        export_error: "Une erreur est survenue lors de l'export.",
        select_all: 'Tout cocher',
        clear: 'Effacer',
        no_result: 'Aucun résultat',
        mixing_disabled_warning: "Le client a désactivé l'autorisation du mixage.",
        capacity: 'Capacité',
        generic_error: "Opps! Une erreur s'est produite.",
        label_total: 'Total :',
        search_placeholder: 'Rechercher...',
        listing: {
            space: 'Espace',
            qty: 'Qté.',
            persons: 'Pers.',
            note: 'Note',
            client_note: 'Note du client',
            paid: 'Réglé',
            free: 'Gratuit',
            to_pay: '{amount} à régler',
            to_pay_short: 'à régler',
            no_reservations: 'Aucune réservation',
            no_reservations_desc: "Il n'y a pas de réservations prévues pour la période sélectionnée.",
            reservations_count: 'réservation',
            clients_count: '{n} client | {n} clients',
            days_count: '{n} jour | {n} jours',
        },
        modal_add: {
            title: 'Prendre une réservation',
            new_reservation: 'Nouvelle réservation',
            client_section: 'CLIENT',
            client_existing: 'Client existant',
            client_new: 'Nouveau',
            client_walkin: 'Client de passage',
            select_client: 'Sélectionner un client',
            search_client: 'Rechercher un client...',
            experiences_section: 'EXPÉRIENCES',
            linked_only: 'Installations liées uniquement',
            date: 'DATE',
            time: 'HEURE',
            duration: 'DURÉE',
            players: 'NB DE JOUEURS',
            tickets: 'BILLETS',
            tickets_required: 'Choisissez au moins un billet pour chaque billetterie.',
            space: 'ESPACE',
            practitioner: 'PRATICIEN(NE)',
            slot: 'CRÉNEAU',
            options_label: 'OPTIONS',
            total_price: 'PRIX TOTAL',
            add_experience: 'Ajouter une expérience',
            options_section: 'OPTIONS',
            payment_link: 'Envoyer un lien de paiement',
            send_quote: 'Générer et envoyer un devis',
            internal_note_section: 'NOTE INTERNE',
            internal_note_placeholder: 'Ajouter une note visible uniquement par l’équipe',
            create_reservation: 'Créer la réservation',
        },
        modal_view: {
            title_resa: 'Réservation',
            title_lunch: 'Pause midi',
            title_indispo: 'Indisponibilité',
            tickets: 'BILLETS',
            optional_products: 'PRODUITS OPTIONNELS',
            reassort: 'RÉASSORT',
            order_section: 'COMMANDE',
            no_description: 'Aucune description fournie.',
            tab_slots: 'Créneaux',
            tab_booking: 'Réservation',
            tab_options: 'Billets/Options',
            confirm_absent: 'Marquer ce client comme absent ?',
            confirm_delete_booking: 'Êtes-vous sûr de vouloir supprimer cette réservation ?',
            confirm_delete_slot: 'Êtes-vous sûr de vouloir supprimer ce créneau ?',
            timeslot_label: 'Horaire',
            activity_label: 'Activité',
            duration_label: 'Durée',
            modify_btn: 'Modifier',
            cancel_slot_btn: 'Annuler le créneau',
            delete_irreversible: 'La suppression de ce créneau est irréversible',
            confirm_btn: 'Confirmer',
            cancel_btn: 'Annuler',
            encaisser_btn: 'Encaisser la réservation',
            send_to_client_section: 'Envoyer au client',
            booking_reminder_btn: 'Rappel de réservation',
            payment_link_btn: 'Lien de paiement',
            management_section: 'Gestion',
            order_detail_btn: 'Détail commande',
            duplicate_btn: 'Dupliquer',
            absent_client_btn: 'Client absent',
            merge_btn: 'Fusionner',
            select_locker_title: 'Sélectionner un casier',
            modify_staffs_label: 'Modifier les staffs',
            no_result_for: 'Aucun résultat pour',
            total_order: 'Total de la commande :',
            generate_payment_link: 'Générer un lien de paiement',
            confirm_and_create: 'Confirmer et Créer',
            internal_note_section: 'Note interne',
            internal_note_placeholder: "Ajouter une note visible uniquement par l'équipe",
            history_section: 'Historique',
            no_history: 'Aucun historique disponible',
            cancel_booking_btn: 'Annuler la réservation',
            reminder_sent_alert: 'Rappel envoyé !',
            payment_link_sent_alert: 'Lien de paiement envoyé !',
            cancel_view: {
                absent_message:
                    "Votre client ne s'est pas présenté à son rendez-vous. Vous pouvez annuler ce rendez-vous selon les actions suivantes :",
                quit_btn: 'Quitter',
                view_details_btn: 'Voir Détails',
                order_closed_alert: 'La commande a déjà été clôturée.',
                activate_actions_btn: 'Activer les actions',
                collect_rest_label: 'Prélever le reste de commande :',
                collect_btn: 'prélever',
                refund_btn: 'rembourser',
                confirm_and_action: 'Confirmer et {action}',
                system_refund_criteria: 'Prélever / Rembourser selon les critères de remboursement du système :',
                refund_without_conditions: 'Annuler et rembourser sans prise en compte les critères de remboursement du système',
                cancel_without_refund_or_collect: 'Annuler seulement, sans rembourser ni prélever.',
                cancel_only_btn: 'Annuler seulement',
                success_delete_msg: 'La suppression {msg}',
                success_absent_msg: "L'annulation {msg}",
                success_completion_msg: " s'est effectuée avec succès et vous avez {action} {amount} {currency}.",
                earned: 'gagné',
                lost: 'perdu',
            },
            tabs: {
                details: 'Détails',
                client: 'Client',
                options: 'Options',
            },
            sections: {
                experience: 'EXPÉRIENCE',
                space: 'ESPACE',
                practitioner: 'PRATICIENNE',
                date_time: 'DATE & HEURE',
                players: 'NB DE JOUEURS',
                price: 'PRIX',
                internal_note: 'NOTE INTERNE',
                cancel_reservation: 'ANNULER LA RÉSERVATION',
            },
            cancel_section: {
                title: 'Annuler la réservation',
                reason_placeholder: 'Motif de l’annulation...',
                confirm_button: 'Confirmer l’annulation',
                success_msg: 'La réservation a été annulée avec succès.',
            },
            select_locker: 'Sélectionner un casier',
            edit_staffs: 'Modifier les staffs',
            loading: 'Chargement...',
        },
        anonymous_client: 'Client Anonyme',
        payment_status: {
            to_pay: '{amount}€ à payer',
            paid: 'Payé',
        },
        modal_block: {
            title: 'Bloquer le créneau',
            period_section: 'PÉRIODE',
            start: 'Début',
            end: 'Fin',
            recurrent: 'Activer la récurrence',
            targets_section: 'CIBLES',
            spaces: 'Espaces',
            all_spaces_placeholder: 'Tous les espaces',
            internal_note_section: 'NOTE INTERNE',
            internal_note_placeholder: 'Pourquoi bloquer ce créneau ?',
            block_button: 'Bloquer le créneau',
            error_block: "Une erreur s'est produite lors du blocage du créneau.",
        },
        payment: {
            title: 'Encaissement',
            remaining: 'Reste à encaisser',
            settled: 'Solde réglé',
            registered: 'Paiements enregistrés',
            add_method: 'Ajouter un moyen de paiement',
            all: 'Tout',
            validate: "Valider l'encaissement",
            card: 'Carte bancaire',
            cash: 'Espèces',
            holiday_check: 'Chèque vacances',
            online: 'Paiement en ligne',
        },
    },
    statistics_v3: {
        hello: 'Hello',
        stats_view: 'Vue statistiques',
        ops_view: 'Vue opérationnelle',
        last_updated: 'Dernière mise à jour',
        force_update: 'Forcer la mise à jour',
        loading_insights: 'Nous préparons vos insights...',
        never: 'jamais',
        few_seconds_ago: 'il y a quelques secondes',
        minutes_ago: 'il y a {n} minute | il y a {n} minutes',
        hours_ago: 'il y a {n} heure | il y a {n} heures',
        days_ago: 'il y a {n} jour | il y a {n} jours',
        kpis: {
            total_sales: 'Total des ventes',
            total_sales_tooltip: 'Montant total des factures émises (TTC), qu’elles soient déjà payées ou non',
            turnover: 'Chiffre d’affaires réalisé',
            turnover_tooltip:
                'Montant des prestations déjà effectuées (HT). C’est l’indicateur à suivre pour comparer votre activité à vos charges et mesurer votre rentabilité',
            collections: 'Encaissements',
            collections_tooltip: 'Montant total des paiements reçus (TTC)',
            avg_basket: 'Panier moyen',
            realized_entries: 'Entrées réalisées',
            weather: 'Météo',
        },
        charts: {
            turnover: "Chiffre d'affaires",
            total_sales: 'Total des ventes',
            collections: 'Encaissements',
            collection_stats: 'Statistiques encaissements',
            best_sellers: 'Meilleures ventes',
            category: 'Catégorie',
            sales_stats: 'Statistiques des ventes',
            services: 'Services',
            products: 'Produits',
            restoration: 'Restauration',
            loyalty: 'Fidélisation',
            customer_base: 'Base clients',
            customer_stats: 'Statistiques clients',
            attendance: 'Fréquentation',
            reservation_trends: 'Tendances de réservations',
            conversion_peaks: 'Pics de conversion',
            order_to_resa_delays: 'Délais entre commande et réservation',
            last_12p_vs_prev: '12 derniers mois vs année précédente',
            tickets: 'Tickets',
            orders: 'Commandes',
            avg_group_size: 'Taille moyenne des groupes',
            nb_customers: 'Nombre de clients',
            comm_subscribers: 'Abonnés aux communications',
            men: 'Hommes',
            women: 'Femmes',
            others: 'Autres',
            retention_rate: 'Taux de rétention',
            new_customers: 'Nouveaux clients',
            noshow_rate: 'Taux de no-show',
            cancellation_rate: "Taux d'annulation",
            reservations: 'réservations',
            reservation: 'réservation',
            hour_suffix: 'h',
        },
        date_picker: {
            cancel: 'Annuler',
            apply: 'Appliquer',
            today: "Aujourd'hui",
            next_7_days: '7 prochains jours',
            last_7_days: '7 derniers jours',
            current_month: 'Mois en cours',
            last_month: 'Mois dernier',
            current_year: 'Année en cours',
            last_year: 'Année dernière',
            current_exercise: 'Exercice courant',
            last_exercise: 'Exercice précédent',
        },
    },
    subscription_info: {
        pro: 'Pro',
        essentiel: 'Essentiel',
        premium: 'Premium',
    },
    errors_permission: {
        noPermission: 'Vous n’avez pas la permission de réaliser cette action.',
    },
    banners: {
        payment_failed: {
            message:
                'Paiement échoué : {amount}{symbol} le {date} (Carte {card}). Veuillez mettre à jour vos informations de paiement.',
            action: 'Mettre à jour le moyen de paiement',
        },
        subscription_canceled: {
            message: "Abonnement résilié : il sera actif jusqu'au {date}. Passé cette date, votre accès sera limité.",
            action: 'Rétablir mon abonnement',
        },
        trial_ending: {
            message:
                "Votre période d'essai prend fin dans {days} jours. Certaines fonctionnalités ne seront plus accessibles sans abonnement.",
            action: 'Mettre à niveau',
        },
    },
    calendar: {
        spaces: 'Espaces',
        day_short_1: '1J',
        day_short_4: '4j',
        day_short_7: '7j',
        modal: {
            principal: 'Principal',
            calculating: 'calculating ...',
            full_booking_warning: "C'est une réservation complète, vous ne pouvez pas la modifier",
            delete_warning: 'La suppression de ce créneau est irréversible',
            activity: 'Activité',
            client: 'Client :',
            no_results_for: 'Aucun résultat pour',
            no_results: 'Aucun résultat',
            entry: 'Entrée',
            no_client_response: 'Aucune réponse du client.',
            voucher_applied: 'Le bon cadeau a bien été appliqué.',
            voucher_blocked: 'Ce bon cadeau a été bloqué.',
            tickets: 'Les Tickets :',
            optional_products: 'Les produits en option :',
            reassort: 'Reassort :',
            order_date: 'Date de commande :',
            start_time: 'Heure de début :',
            change_parent_client: 'Changer le client principal',
            modify_client: 'Modifier le client',
            swap_coach: 'Permuter un coach par un autre',
            modify_order: 'Modifier la commande :',
            invalid_date_error: 'Date invalide. Veuillez entrer une date valide.',
            invalid_time_format: "Format d'heure invalide. Veuillez entrer une heure valide",
            reservation_locked: 'Cette réservation a été verrouillée',
            smart_booking_title: 'Réservation intelligente',
            select_day: 'Sélectionner un jour',
            time_slots: 'Créneaux :',
            at: 'à',
            week_day: 'Jour de la semaine :',
            wanted_clients: 'Nombre de clients :',
            employee: 'Employé :',
            load_possibilities: 'Charger les possibilités',
            days_short: {
                mon: 'Lun.',
                tue: 'Mar.',
                wed: 'Mer.',
                thu: 'Jeu.',
                fri: 'Ven.',
                sat: 'Sam.',
                sun: 'Dim.',
            },
            days_enum: {
                monday: 'Lundi',
                tuesday: 'Mardi',
                wednesday: 'Mercredi',
                thursday: 'Jeudi',
                friday: 'Vendredi',
                saturday: 'Samedi',
                sunday: 'Dimanche',
            },
            client_alert: 'Alerte client',
            product: 'Produit',
            days_count: 'Nbre de jours',
            status: 'Statut',
            actions: 'Actions',
            finished: 'Fini',
            in_progress: 'En cours',
            create_sale: 'Créer une vente',
            create_sale_product: 'Créer une vente pour ce produit',
            clients_title: 'Clients :',
            passing_customer: 'Client de passage',
            payment_mode: 'Mode de paiement',
            prescription: 'Ordonnance',
            prescription_step2: 'Ordonnance étape 2',
            prescription_step3: 'Ordonnance étape 3',
            invoiced_to: 'Facturé à :',
            client_note: 'Note de client :',
            questions_answers: 'Questions et réponses :',
            delete_order_confirm: 'Souhaitez-vous vraiment supprimer la commande en question ?',
            delete_order_text:
                'Si vous confirmez cette action, la commande ainsi que tous ses composants: prestations, packages, products, options, et les autres éléments associés seront définitivement effacés.',
            must_be_number: 'La valeur doit être un nombre',
            must_be_positive: 'La valeur doit être un nombre positif',
            voucher_error: 'Erreur bon cadeau :',
            voucher_number: 'Bon cadeau n°',
            valid_until: "valable jusqu'au",
            booking_already_paid: 'Réservation déjà payée',
            total_voucher_amount: 'Montant total de bon(s) cadeau {amount}{symbol} disponible',
            voucher_code: 'Bon cadeau',
        },
    },
    customer: {
        reactivate_confirm: 'Voulez-vous <b>réactiver</b> ce client ?',
        deactivate_confirm: 'Voulez-vous <b>désactiver</b> ce client ?',
        first_name: 'Prénom',
        last_name: 'Nom',
        email: 'Email',
        phone: 'Tél.',
        phone_number: 'Numéro de téléphone',
        birthday: 'Date de naissance',
        addresses: 'Adresses (complète)',
        age: 'Âge',
        gender: 'Genre',
        origin: 'Origine',
        spent: 'Dépensé (en {symbol})',
        loyalty_points: 'Points de fidélités',
        first_coming: 'Première venue',
        last_coming: 'Dernière venue',
        created_at: "Date d'ajout",
        actions: 'Actions',
        add_customer: 'Ajouter un client',
        columns: 'Colonnes',
        exporter: 'Exporter',
        export_loading: 'Export...',
        fusionner: 'Fusionner',
        set_password: 'Définir mot de passe',
        caisse: 'Caisse',
        edit: 'Modifier',
        deactivate_client_tooltip: 'Désactiver client',
        reactivate_client_tooltip: 'Réactiver client',
        plan_reservation: 'Planifier réservation',
        deactivate: 'Désactiver',
        activate: 'Activer',
        close: 'Fermer',
        deactivated_success: 'Utilisateur désactiver avec succès',
        activated_success: 'Utilisateur activer avec succès',
        error_occurred: 'Une erreur se produit.',
        emails_sent_count: "Nbre d'email envoyé",
        sms_sent_count: "Nbre d'sms envoyé",
        sms_count: "Nombre d'sms",
        email_count: "Nombre d'e-mails",
        start: 'début',
        month: 'Mois',
        view_details: 'Voir détail',
        content: 'Contenu',
        operation: 'Operation',
        object: 'Objet',
        hour: 'Heure',
        date: 'Date',
        previous: 'Précédent',
        next: 'Suivant',
        page: 'Page',
        general_info: 'Informations générales',
        sms_send_info: 'Nombre des sms à envoyer est {total} : prix par sms 0.07 {symbol}',
        char_limit_note: '(Le nombre de caractères se limite à 150 pour 1 message)',
        message_label: 'Message',
        sms_placeholder: 'Votre SMS..',
        chars_remaining: '{count} caractères restants',
        variables: 'Variable(s)',
        send: 'Envoyer',
        loading: 'Chargement...',
    },
    model_template: {
        title: 'Modèles de devis',
        create: 'Créer un modèle',
    },
    combo: {
        add_title: 'Ajouter un combo',
        edit_title: 'Modifier un combo',
        name_label: 'Nom du combo',
        name_placeholder: 'Exemple : “Après-midi Fun”, “Pack Aventure”.',
        description_label: 'Description',
        visible_online_label: 'Visible en ligne',
        illustration_label: 'Illustration',
        upload_image: 'Télécharger une image',
        type_label: 'Type du combo',
        slot_succession_label: 'Délai entre les activités',
        slot_succession_placeholder: 'Durée entre activités',
        slot_succession_help:
            'Le délai entre les activités permet de définir un intervalle de temps entre chaque activité. Par exemple, pour offrir un créneau de 30 minutes entre deux activités afin que vos clients puissent profiter du bar, il vous suffit d\'entrer "30" dans le champ prévu à cet effet. Si vous souhaitez que les activités se déroulent successivement sans délai, il vous suffit d\'ajouter "0" > Exemple : entre chaque activité, faire une pause de 30 minutes pour laisser les clients se reposer/boire un verre, ou 0 pour les enchainer.',
        same_time_question: 'Les plannings sont identiques pour chaque activité ?',
        same_time_help:
            'Signifie que les activités partagent les mêmes spécifications, notamment en termes de durée et de cadence de départ. Par exemple, toutes les 10 minutes ou toutes les 30 minutes.',
        multi_participants_question: 'Les participants peuvent-ils choisir de ne faire que certaines activités ?',
        discounts_title: 'Remises',
        discount_type: 'Type de remise',
        select_type: 'Sélectionner un type',
        amount: 'Montant',
        value: 'Valeur',
        elements_title: 'Éléments du combo',
        min_elements_label: 'Nombre d’éléments à sélectionner au minimum',
        min_elements_help:
            'Si vous souhaitez que vos clients choisissent un nombre précis de prestations/activités, par exemple 2 activités parmi 6, renseignez 2 en minimum et 2 en maximum.',
        max_elements_label: 'Nombre d’éléments à sélectionner au maximum',
        max_elements_help:
            'Si vous souhaitez que vos clients choisissent un nombre précis de prestations/activités, par exemple 2 activités parmi 6, renseignez 2 en minimum et 2 en maximum.',
        elements_qty_placeholder: 'Nombre des elements',
        elements_qty_empty_help: 'Laissez le champ vide si toutes les activités doivent être incluses.',
        durations_diff_warning: "Il s'agit bien du <i>calendrier identique</i> , mais les durées sélectionnées <b>diffèrent</b>.",
        null_duration_warning: 'Vous avez une ou plusieurs durées non sélectionnées.',
        select_element_label: 'Sélection de l’élément X {index}',
        ticket_options: 'Ticket Options',
        select_activity: "Sélection de l'activité",
        no_results: 'Aucun résultat trouvé pour {search}',
        no_elements: "Aucun élément n'est trouvé.",
        duration: 'Durée',
        select_duration: 'Sélection duration',
        option_and_duration: 'Option et duration',
        select_option: 'Sélectionner une option',
        required_item: 'Rendre l’élément obligatoire',
        order_required_question: 'Faut-il rendre cet ordre obligatoire ?',
        price_vat_title: 'Prix & TVA',
        barcode: 'Code-barres',
        vat_rate: 'Taux de TVA (en %)',
        selling_price: 'Prix de vente (en {currency})',
        price_ht: 'Prix HT en ({currency})',
        deposit: 'Acompte',
        request_deposit: 'Demander un acompte ?',
        deposit_type: 'Acompte type',
        please_select: 'Veuillez sélectionner',
        discount: 'Remise',
        activate_discount: 'Activier le remise',
        discount_help: '(Nous permettons de spécifier, si on va activer le remise pour les activités)',
        discount_percent: 'Pourcentage de remise',
        advanced_options: 'Options avancées',
        merge_questions: 'Regrouper les questions identiques',
        merge_questions_help:
            'Éviter les doublons : si plusieurs activités partagent la même question, elle s’affichiera une seule fois.',
        categories_title: 'Catégories de ce combo',
        choose_categories: 'Choisissez une ou plusieurs catégories',
        select_categories_aria: 'Sélectionnez de(s) catégorie(s)',
        update_success: 'Le combo mis à jour avec succès !',
        create_success: 'Le combo créé avec succès !',
        error_general: "Erreur lors de l'enregistrement",
        error_durations: 'Les durées sélectionnées ne sont pas les mêmes.',
        error_val_zero: 'Le champ ne peut pas contenir la valeur 0.',
        types: {
            all: 'Tous les prestations',
            specific: 'Combos de prestations personnalisées',
            family: 'Combo Loisirs en Groupe',
            specific_desc:
                "Créez des offres sur-mesure en sélectionnant librement les activités de votre choix et en définissant la durée de chaque prestation. Ce système flexible vous permet d'adapter vos combos en fonction des besoins spécifiques de vos clients, pour des expériences uniques et personnalisées.",
            family_desc:
                "Conçu pour gérer facilement les réservations de groupes, offrant à vos clients une expérience collective tout en permettant une flexibilité maximale. Ce module vous permet de regrouper plusieurs activités sous une seule réservation, avec la possibilité d'affecter différentes activités à chaque membre du groupe, tout en veillant à ce que le groupe démarre en même temps.",
        },
        yes: 'Oui',
        no: 'Non',
        order_required: {
            yes: 'Les clients doivent suivre les activités dans l’ordre défini.',
            no: 'Les clients peuvent les faire dans n’importe quel ordre.',
        },
        multi_participants: {
            yes: 'Le client peut définir un nombre différent de participants pour chaque activité.',
            no: 'Tous les participants réservés feront toutes les activités.',
        },
    },
    chatbot: {
        button_label: 'Assistant IA',
        header_title: 'Louise, votre assistante IA',
        input_placeholder: 'Demander à Louise',
        error_no_response: 'Désolé, je n’ai pas pu traiter votre demande.',
        error_connection: 'Erreur de connexion. Veuillez réessayer.',
        status_online: 'En ligne',
        status_offline: 'Non connectée',
        close: 'Fermer',
        good_morning: 'Bonjour',
        good_evening: 'Bonsoir',
        greet_question: 'Que voulez-vous faire ?',
        action_day: 'Résumer ma journée',
        action_calendar: 'Voir mon calendrier',
        action_search: 'Rechercher une réservation / un client',
        action_stats: 'Voir mes stats',
        action_devis: 'Créer un devis',
        action_booking: 'Créer une réservation',
        action_performance: 'Analyser mes performances',
        suggestion_reservations: 'Combien de réservations aujourd’hui ?',
        suggestion_turnover: 'Quel est mon chiffre d’affaires cette semaine ?',
        suggestion_invoices: 'Où je peux voir mes factures ?',
        coach_title: 'Louise répond à vos questions sur votre activité',
        coach_body:
            'Votre assistante lit vos réservations, vos ventes et vos factures. Posez-lui une question en français, elle cherche la réponse dans PlayPro.',
        coach_item_1: 'Le planning du jour en une phrase',
        coach_item_2: 'Chiffre d’affaires, no-shows, créneaux libres',
        coach_item_3: 'Retrouver une facture ou un client',
        coach_cta: 'Découvrir Louise',
        coach_later: 'Plus tard',
        gemini_key_badge: 'Louise a un message pour vous',
        gemini_key_request: 'Votre assistant IA a besoin de votre clé Gemini pour vous donner des réponses en temps réel.',
        gemini_key_hint_before: 'Créez votre clé sur',
        gemini_key_hint_after: ' puis collez-la ici.',
        gemini_key_activate: 'Activer',
        gemini_key_saving: 'Activation…',
        gemini_key_saved_inline: 'Clé enregistrée',
        gemini_key_empty: 'Collez votre clé avant d’activer.',
        gemini_key_forbidden:
            'Vous n’avez pas la permission de modifier les intégrations. Demandez à un administrateur d’enregistrer la clé.',
        gemini_key_error: 'La clé n’a pas pu être enregistrée. Veuillez réessayer.',
    },
    staff_planning_v3: {
        toolbar: {
            employees: '{count} employé | {count} employés',
            current_week: 'Semaine en cours',
            download: 'Télécharger',
            duplicate: 'Dupliquer',
            save: 'Enregistrer',
            publish: 'Publier',
            send: 'Envoyer',
            week_display: 'Semaine {week}, {year}',
        },
        main: {
            loading: 'Chargement...',
            shift_created: 'Shift créé avec succès',
            shift_modified: 'Shift modifié avec succès',
            shift_create_error: 'Erreur lors de la création du shift',
            absence_saved: 'Absence enregistrée avec succès',
            absence_modified: 'Absence modifiée avec succès',
            absence_error: "Erreur lors de l'enregistrement de l'absence",
            planning_saved: 'Planning enregistré avec succès',
            planning_published: 'Planning publié avec succès',
            publish_error: 'Erreur lors de la publication',
            planning_sent: 'Planing a été envoyé avec succès',
            send_error: "Erreur lors d'envoi du planning",
            select_employee: 'Veuillez sélectionner au moins un employé',
            planning_duplicated: 'Planning dupliqué avec succès',
            duplicate_error: 'Erreur lors de la duplication du planning',
            planning_downloaded: 'Planning téléchargé avec succès',
            download_error: 'Erreur lors du téléchargement du planning',
            copy_week_to: 'Copier la semaine vers...',
            send_week: 'Envoyer la semaine',
            delete_week: 'Effacer la semaine',
            source_undetermined: 'Impossible de déterminer la source du planning.',
            copy_error: 'Erreur lors de la copie du planning',
            staff_undetermined: 'Impossible de déterminer le membre du staff.',
            load_error: 'Erreur lors du chargement du planning',
            planning_cloned: 'Planning cloné avec succès',
            hours_copied: 'Horaires copiés avec succès',
            absence_deleted: 'Absence supprimée avec succès',
            absence_delete_error: "Erreur lors de la suppression de l'absence",
            shift_deleted: 'Shift supprimé avec succès',
            shift_delete_error: 'Erreur lors de la suppression du shift',
            fill_hours: 'Veuillez remplir les horaires du shift.',
            select_employee_only: 'Veuillez sélectionner un employé.',
            invalid_date: 'Date invalide.',
            load_hours_error: 'Erreur lors du chargement des heures',
            no_planning_found: 'Aucun planning trouvé pour cet employé',
            no_shift_found: 'Aucun shift trouvé pour ce jour',
            select_source: 'Veuillez sélectionner un employé et une semaine source.',
            select_target: "Veuillez sélectionner l'employé de destination.",
            select_all: 'Tout sélectionner',
            deselect_all: 'Tout désélectionner',
            team_title: 'Equipe',
            total: 'Total',
            confirm_delete_title: 'Confirmer la suppression',
            confirm_shift_delete_desc: 'Voulez-vous vraiment supprimer ce shift ?',
            confirm_delete_resource_title: 'Supprimer la ressource externe',
            confirm_delete_resource_desc:
                'Voulez-vous vraiment supprimer cette ressource externe ? Cette action est irréversible.',
            resource_updated: 'Ressource externe modifiée avec succès',
            resource_update_error: 'Erreur lors de la modification de la ressource externe',
            resource_deleted: 'Ressource externe supprimée avec succès',
            resource_delete_error: 'Erreur lors de la suppression de la ressource externe',
            confirm_overwrite_title: "Confirmation d'écrasement",
            confirm_overwrite_desc:
                'Les données existantes sur les semaines cibles peuvent être écrasées. Voulez-vous continuer ?',
            published_upcoming_weeks: 'Semaines publiées à venir',
            personalized_weeks: 'Semaines personnalisées',
        },
        row: {
            external_resource: 'Ressource externe',
            edit_shift: 'Modifier le shift',
            delete_shift: 'Supprimer le shift',
            create_shift: 'Créer un shift',
            add_absence: 'Ajouter une absence',
            add_entry: 'Ajouter une entrée',
        },
        components: {
            absence_modal: {
                title_edit: 'Modifier une absence pour',
                title_add: 'Ajouter une absence pour',
                employee: 'Employé',
                select_employee: 'Sélectionner un employé',
                motif: 'Motif',
                select_motif: 'Sélectionner un motif',
                planning: 'Planning',
                date: 'Date',
                start_time: 'Heure début',
                end_time: 'Heure fin',
                add_schedule: 'Ajouter un horaire',
                advanced_options: 'Options avancés',
                add_recurrence: 'Ajouter une récurrence',
                frequency: 'Fréquence',
                recurrence_end: 'FIN DE RÉCURRENCE',
                choose_days: 'Choisissez les jours pour répéter cette absence :',
                copy_planning: 'Copier depuis un planning existant',
                copy_desc: "Copier les horaires de la semaine précédente ou d'un autre employé.",
                note: 'Note',
                add_note: "Ajouter une note (visible par l'équipe)",
                cancel: 'Annuler',
                edit_absence: "Modifier l'absence",
                add_absence: "Ajouter l'absence",
                paid_leave: 'Congé payé',
                sickness: 'Maladie',
                rest: 'Repos',
                other: 'Autre',
                every_week: 'Toutes les semaines',
                every_2_weeks: 'Toutes les 2 semaines',
                every_month: 'Tous les mois',
            },
            create_shift: {
                title_edit: 'Modifier un shift',
                title_create: 'Créer un shift',
                for: 'pour',
                employee: 'Employé',
                select_employee: 'Sélectionner un employé',
                planning: 'Planning',
                date: 'DATE',
                start_time: 'HEURE DÉBUT',
                end_time: 'HEURE FIN',
                add_schedule: 'Ajouter un horaire',
                advanced_options: 'Options Avancées',
                add_recurrence: 'Ajouter une récurrence',
                frequency: 'Fréquence',
                recurrence_end: 'FIN DE RÉCURRENCE',
                choose_days: 'Choisissez les jours pour répéter ce shift :',
                copy_planning: 'Copier depuis un planning existant',
                copy_from: 'Copier depuis',
                copy_period: 'Période à copier',
                select_week: 'Sélectionner une semaine',
                note: 'Note',
                add_note: "Ajouter une note (visible par l'équipe)",
                cancel: 'Annuler',
                edit_shift: 'Modifier le shift',
                create_shift: 'Créer le shift',
                every_week: 'Toutes les semaines',
                every_2_weeks: 'Toutes les 2 semaines',
                every_month: 'Tous les mois',
                week: 'Semaine',
            },
            copy_planning: {
                title: 'Dupliquer le planning',
                target_employees: 'Employé(s) cible(s)',
                select_employees: 'Sélectionner le(s) employé(s)',
                source_week: 'Semaine source',
                select_source_week: 'Sélectionner la semaine source',
                target_weeks: 'Semaine(s) cible(s)',
                select_target_weeks: 'Sélectionner la/les semaine(s)',
                warning_title: 'Attention',
                warning_desc: 'La duplication va écraser les horaires existants sur les semaines de destination.',
                cancel: 'Annuler',
                duplicate: 'Dupliquer',
            },
            send_planning: {
                title: 'Envoyer le planning',
                format: "Format d'envoi",
                select_format: 'Sélectionner le format',
                employees: 'Employés',
                all_employees: 'Tous les employés de la semaine',
                weeks: 'Semaines',
                select_weeks: 'Sélectionner la/les semaine(s)',
                message: 'Message',
                message_placeholder: 'Ajouter un message optionnel...',
                cancel: 'Annuler',
                send: 'Envoyer',
            },
            download_planning: {
                title: 'Télécharger le planning',
                format: "Format d'export",
                select_format: 'Sélectionner le format',
                employees: 'Employés',
                all_employees: 'Tous les employés de la semaine',
                weeks: 'Semaines',
                select_weeks: 'Sélectionner la/les semaine(s)',
                cancel: 'Annuler',
                download: 'Télécharger',
            },
            confirm_delete_week: {
                title: 'Confirmation',
                message: 'Êtes-vous sûr de vouloir supprimer tous les shifts de la semaine {week} ?',
                cancel: 'Annuler',
                delete: 'Supprimer',
            },
            resource_externe_modal: {
                title_edit: 'Modifier une ressource externe',
                title_create: 'Ajouter une ressource externe',
                name: 'Nom',
                name_placeholder: 'Nom de la ressource',
                email: 'Email',
                email_placeholder: 'Email de la ressource',
                phone: 'Téléphone',
                phone_placeholder: 'Téléphone de la ressource',
                cancel: 'Annuler',
                save: 'Enregistrer',
            },
            note_section: {
                title: 'Note',
                placeholder: "Ajouter une note (visible par l'équipe)",
            },
            staff_selector: {
                search: 'Rechercher un employé',
                all: 'Tous',
                select_all: 'Tout sélectionner',
                deselect_all: 'Tout désélectionner',
                send_to: 'Envoyer à',
                show_for: 'Affichés sur le planning',
            },
            planning_type_selector: {
                week: 'Semaine {week}',
                month: 'Mois',
                personalized: 'Personnalisé',
                min_hint: '2 sem. min.',
                min_weeks_hint: 'Minimum 2 semaines publiées requises',
            },
        },
        copy_modal: {
            title: 'Copier la semaine',
            source_employee: 'Employé source',
            target_employee: 'Employé de destination',
            weeks_to_copy: 'Semaines à copier',
            select_employee: 'Sélectionner un employé',
            select_week: 'Sélectionner une semaine',
            cancel: 'Annuler',
            validate: 'Valider',
            error_source: 'Veuillez sélectionner un employé source.',
            error_target: 'Veuillez sélectionner un employé cible.',
            error_weeks: 'Veuillez sélectionner au moins une semaine cible.',
            confirm: 'Confirmer',
        },
        send_modal: {
            title: 'Envoyer le planning',
        },
        download_modal: {
            title: 'Télécharger le planning',
        },
    },
    categories: {
        dashboard: 'Tableau de bord',
        bookings: 'Réservations',
        orders: 'Commandes',
        customers: 'Clients',
        customer_groups: 'Groupes clients',
        gift_vouchers: 'Bons cadeaux',
        open_tickets: 'Billets non datés',
        quotes: 'Devis',
        invoices: 'Factures',
        announcements: 'Annonces',
        promo_codes: 'Codes promo',
        email_campaigns: 'Campagnes email',
        automated_emails: 'Mails automatiques',
        push_notifications: 'Notifications push',
        blog: 'Blog',
        staff_scheduling: 'Planning Staff',
        users: 'Utilisateurs',
        roles_permissions: 'Droits et permissions',
        accounting: 'Comptabilité',
        facility_settings: 'Paramètres établissement',
        website: 'Site Internet',
        experiences: 'Expériences',
        experience_categories: "Catégories d'expériences",
        bundles: 'Formules combinées',
        packages: 'Forfaits',
        subscriptions: 'Abonnements',
        facilities: 'Installations',
        equipment: 'Matériel',
        widgets: 'Widgets',
        add_ons: 'Ventes additionnelles',
        add_on_categories: 'Catégories ventes additionnelles',
        suppliers: 'Fournisseurs',
        brands: 'Marques',
        catering: 'Restauration',
        catering_categories: 'Catégories de produits restauration',
        tags: 'Tags',
        qr_codes: 'QR Codes',
        quote_templates: 'Modèles de devis',
        quote_requests: 'Demandes de devis',
        pos: 'Points de vente (POS)',
        integrations: 'Intégrations',
        api: 'API',
        reservations_experiences: 'Réservations et expériences',
        website_visibility: 'Site Internet & visibilité',
        payment_collection: 'Paiement & Encaissement',
        billing_quotes: 'Facturation & Devis',
        encaissement: 'Encaissement',
        marketing_fidélisation: 'Marketing & Fidélisation',
        ai_automation: 'AI & Automation',
        team_hr: 'Équipe & RH',
    },
    permissions: {
        dashboard: {
            view_operational: 'Voir le tableau de bord opérationnel',
            view_financial: 'Voir le tableau de bord financier',
        },
        bookings: {
            create: 'Créer une réservation',
            view: 'Voir les réservations',
            edit: 'Modifier une réservation',
            delete: 'Supprimer une réservation',
            export: 'Exporter les réservations',
            block_slot: 'Bloquer/débloquer un créneau',
        },
        orders: {
            create: 'Créer une commande',
            view: 'Voir les commandes',
            edit: 'Modifier une commande',
            delete: 'Supprimer une commande',
            export: 'Exporter les commandes',
        },
        customers: {
            create: 'Créer un client',
            view: 'Consulter les clients',
            edit: 'Modifier un client',
            delete: 'Supprimer un client',
            export: 'Exporter le fichier client',
        },
        customer_groups: {
            create: 'Créer un groupe client',
            view: 'Consulter les groupes clients',
            edit: 'Modifier un groupe client',
            delete: 'Supprimer un groupe client',
            export: 'Exporter les groupes clients',
        },
        gift_vouchers: {
            create: 'Créer un bon cadeau',
            view: 'Consulter les bons cadeaux',
            edit: 'Modifier les bons cadeaux',
            delete: 'Supprimer les bons cadeaux',
            export: 'Exporter les bons cadeaux',
        },
        open_tickets: {
            create: 'Créer un billet non daté',
            view: 'Consulter les billets non datés',
            edit: 'Modifier un billet non daté',
            delete: 'Supprimer un billet non daté',
            export: 'Exporter les billets non datés',
        },
        quotes: {
            create: 'Créer un devis',
            view: 'Voir les devis',
            edit: 'Modifier un devis',
            delete: 'Supprimer un devis',
            remind: 'Relancer un devis',
            export: 'Exporter les devis',
        },
        invoices: {
            create_sales: 'Créer une facture de vente',
            create_credit_note: "Créer une facture d'avoir",
            view: 'Voir les factures',
            remind: 'Relancer une facture',
            export: 'Exporter les factures',
        },
        announcements: {
            create: 'Créer une annonce',
            view: 'Voir les annonces',
            edit: 'Modifier une annonce',
            delete: 'Supprimer une annonce',
        },
        promo_codes: {
            create: 'Créer un code promo',
            view: 'Voir les codes promo',
            edit: 'Modifier un code promo',
            delete: 'Supprimer un code promo',
        },
        email_campaigns: {
            create: 'Créer une campagne',
            view: 'Voir les campagnes',
            edit: 'Modifier une campagne',
            delete: 'Supprimer une campagne',
        },
        automated_emails: {
            view: 'Voir les mails automatiques',
            edit: 'Modifier les mails automatiques',
        },
        push_notifications: {
            send: 'Envoyer une notification',
            view: 'Voir les notifications',
        },
        blog: {
            create: 'Créer un article',
            view: 'Voir les articles',
            edit: 'Modifier un article',
            delete: 'Supprimer un article',
        },
        staff_scheduling: {
            create_shift: 'Créer un shift',
            view: 'Voir le planning',
            edit: 'Modifier le planning',
            delete_shift: 'Supprimer un shift',
            send: 'Envoyer le planning',
            download: 'Télécharger le planning',
        },
        users: {
            create: 'Créer un utilisateur',
            view: 'Voir les utilisateurs',
            edit: 'Modifier un utilisateur',
            delete: 'Supprimer un utilisateur',
        },
        roles_permissions: {
            create: 'Créer un rôle',
            view: 'Voir les rôles',
            edit: 'Modifier un rôle',
            delete: 'Supprimer un rôle',
        },
        accounting: {
            download_accounting: 'Télécharger les documents comptables',
            download_operational: 'Télécharger les documents opérationnels',
        },
        facility_settings: {
            view: 'Voir les paramètres',
            edit: 'Modifier un paramètre',
            delete: 'Supprimer un paramètre',
        },
        website: {
            view: 'Voir les paramètres du site Internet',
            edit: 'Modifier les paramètres du site Internet',
            publish_forms: 'Publier formulaires de demandes de devis',
            custom_domain: 'Configurer domaine personnalisé',
        },
        experiences: {
            create: 'Créer une expérience',
            view: 'Voir les expériences',
            edit: 'Modifier une expérience',
            delete: 'Supprimer une expérience',
        },
        experience_categories: {
            create: "Créer une catégorie d'expériences",
            view: "Voir les catégories d'expériences",
            edit: "Modifier une catégorie d'expériences",
            delete: "Supprimer une catégorie d'expériences",
        },
        bundles: {
            create: 'Créer une formule combinée',
            view: 'Voir les formules combinées',
            edit: 'Modifier une formule combinée',
            delete: 'Supprimer une formule combinée',
            export: 'Exporter les formules combinées',
        },
        packages: {
            create: 'Créer un forfait',
            view: 'Voir les forfaits',
            edit: 'Modifier un forfait',
            delete: 'Supprimer un forfait',
        },
        subscriptions: {
            create: 'Créer un abonnement',
            view: 'Voir les abonnements',
            edit: 'Modifier un abonnement',
            delete: 'Supprimer un abonnement',
        },
        facilities: {
            create: 'Ajouter une installation',
            view: 'Voir les installations',
            edit: 'Modifier une installation',
            delete: 'Supprimer une installation',
            export: 'Exporter les installations',
        },
        equipment: {
            create: 'Ajouter un matériel',
            view: 'Voir les matériels',
            edit: 'Modifier un matériel',
            delete: 'Supprimer un matériel',
            export: 'Exporter les matériels',
        },
        widgets: {
            access: 'Accéder aux widgets',
        },
        add_ons: {
            create: 'Créer un produit additionnel',
            view: 'Voir les produits additionnels',
            edit: 'Modifier un produit additionnel',
            delete: 'Supprimer un produit additionnel',
            publish: 'Publier les produits additionnels',
        },
        add_on_categories: {
            create: 'Créer une catégorie de ventes additionnelles',
            view: 'Voir les catégories de ventes additionnelles',
            edit: 'Modifier une catégorie de ventes additionnelles',
            delete: 'Supprimer une catégorie de ventes additionnelles',
            export: 'Exporter les catégories de ventes additionnelles',
        },
        suppliers: {
            create: 'Ajouter un fournisseur',
            view: 'Voir les fournisseurs',
            edit: 'Modifier un fournisseur',
            delete: 'Supprimer un fournisseur',
            export: 'Exporter les fournisseurs',
        },
        brands: {
            create: 'Ajouter une marque',
            view: 'Voir les marques',
            edit: 'Modifier une marque',
            delete: 'Supprimer une marque',
            export: 'Exporter les marques',
        },
        catering: {
            create: 'Créer un produit',
            view: 'Consulter les produits',
            edit: 'Modifier un produit',
            delete: 'Supprimer un produit',
            export: 'Exporter les produits',
        },
        catering_categories: {
            create: 'Créer une catégorie de produits restauration',
            view: 'Voir les catégories de produits restauration',
            edit: 'Modifier une catégorie de produits restauration',
            delete: 'Supprimer une catégorie de produits restauration',
            export: 'Exporter les catégories de produits restauration',
        },
        tags: {
            create: 'Créer un tag',
            view: 'Voir les tags',
            edit: 'Modifier un tag',
            delete: 'Supprimer un tag',
            export: 'Exporter les tags',
        },
        qr_codes: {
            create: 'Créer un QR Code',
            view: 'Voir les QR Codes',
            edit: 'Modifier un QR Code',
            delete: 'Supprimer un QR Code',
            export: 'Exporter les QR Codes',
        },
        quote_templates: {
            create: 'Créer un modèle',
            view: 'Voir les modèles',
            edit: 'Modifier un modèle',
            delete: 'Supprimer un modèle',
        },
        quote_requests: {
            create: 'Créer un formulaire de demande de devis',
            view: 'Consulter un formulaires de demande de devis',
            edit: 'Modifier un formulaire de demande de devis',
            delete: 'Supprimer un formulaires de demande de devis',
        },
        pos: {
            create: 'Créer un point de vente',
            view: 'Voir les points de vente',
            edit: 'Modifier un point de vente',
            delete: 'Supprimer un point de vente',
        },
        integrations: {
            create: 'Créer une intégration',
            view: 'Consulter les intégrations',
            edit: 'Modifier une intégration',
            delete: 'Supprimer une intégration',
        },
        api: {
            create: 'Créer une clé',
            view: 'Voir les clés',
            edit: 'Modifier une clé',
            delete: 'Supprimer une clé',
        },
        reservations_experiences: {
            creation_formules_combines: 'Création de formules combinées',
            demandes_devis_en_ligne: 'Demandes de devis en ligne',
            ventes_additionnelles: 'Ventes additionnelles',
            export_base_clients: 'Export de la base clients',
            relance_paniers_abandonnes: 'Relance des paniers abandonnés',
        },
        website_visibility: {
            nom_domaine_personnalise: 'Nom de domaine personnalisé',
            suppression_logo_playpro: 'Suppression du logo PlayPro',
            application_mobile_personnalisee: 'Application mobile personnalisée',
        },
        payment_collection: {
            paiement_avec_acompte: 'Paiement avec acompte',
            paiement_avec_apple_pay: 'Paiement avec Apple Pay',
            paiement_avec_google_pay: 'Paiement avec Google Pay',
        },
        billing_quotes: {
            generation_edition_devis: 'Génération & Édition de devis',
            suivi_devis_vue_kanban: 'Suivi des devis en vue Kanban',
            creation_envoi_brochure_devis: 'Création & Envoi de Brochure avec le devis',
            relance_automatique_devis: 'Relance automatique des devis',
            signature_electronique_devis: 'Signature électronique des devis',
        },
        encaissement: {
            commande_qr_code: 'Commande par QR Code',
            gestion_stocks: 'Gestion des stocks',
        },
        marketing_fidélisation: {
            creation_carnets_entrees: "Création de carnets d'entrées",
            campagnes_email_newsletters: 'Campagnes email de Newsletters',
            programmes_fidelite: 'Programmes de fidélité',
            gestion_automatisee_bons_cadeaux: 'Gestion automatisée des Bons cadeaux',
            billetterie_cse: "Billetterie Comité d'Entreprise (CSE)",
            tracking_avance_gtm_matomo: 'Tracking avancé des données via GTM/Matomo',
            creation_gestion_abonnements: "Création & Gestion d'Abonnements",
            wallet_portefeuille_electronique: 'Wallet (portefeuille électronique)',
            programme_parrainage: 'Programme de parrainage',
            tarification_dynamique_early_birds: 'Tarification dynamique (Early Birds)',
        },
        ai_automation: {
            emails_automatiques: 'Emails automatiques (rappel, anniv,..)',
            liaison_karafun: 'Liaison avec Karafun',
            synchronisation_google_agenda: 'Synchronisation Google Agenda',
            api_reservations: 'API Réservations',
            envoi_emails_boite_mail: 'Envoi des emails avec votre boite mail',
            gestion_multi_etablissements: 'Gestion multi-établissements',
        },
        team_hr: {
            planning_equipe: "Planning d'équipe",
            suivi_objectifs_gamification: 'Suivi des objectifs (gamification)',
        },
    },
}
export default fr
